const list = [
  {
    "name": "北京市",
    "city": [
      {
        "name": "北京市",
        "area": [
          "东城区",
          "西城区",
          "崇文区",
          "宣武区",
          "朝阳区",
          "丰台区",
          "石景山区",
          "海淀区",
          "门头沟区",
          "房山区",
          "通州区",
          "顺义区",
          "昌平区",
          "大兴区",
          "平谷区",
          "怀柔区",
          "密云县",
          "延庆县"
        ]
      }
    ]
  },
  {
    "name": "天津市",
    "city": [
      {
        "name": "天津市",
        "area": [
          "和平区",
          "河东区",
          "河西区",
          "南开区",
          "河北区",
          "红桥区",
          "塘沽区",
          "汉沽区",
          "大港区",
          "东丽区",
          "西青区",
          "津南区",
          "北辰区",
          "武清区",
          "宝坻区",
          "宁河县",
          "静海县",
          "蓟  县"
        ]
      }
    ]
  },
  {
    "name": "河北省",
    "city": [
      {
        "name": "石家庄",
        "area": [
          "长安区",
          "桥东区",
          "桥西区",
          "新华区",
          "郊  区",
          "井陉矿区",
          "井陉县",
          "正定县",
          "栾城县",
          "行唐县",
          "灵寿县",
          "高邑县",
          "深泽县",
          "赞皇县",
          "无极县",
          "平山县",
          "元氏县",
          "赵  县",
          "辛集市",
          "藁",
          "晋州市",
          "新乐市",
          "鹿泉市"
        ]
      },
      {
        "name": "唐山",
        "area": [
          "路南区",
          "路北区",
          "古冶区",
          "开平区",
          "新  区",
          "丰润县",
          "滦  县",
          "滦南县",
          "乐亭县",
          "迁西县",
          "玉田县",
          "唐海县",
          "遵化市",
          "丰南市",
          "迁安市"
        ]
      },
      {
        "name": "秦皇岛",
        "area": [
          "海港区",
          "山海关区",
          "北戴河区",
          "青龙满族自治县",
          "昌黎县",
          "抚宁县",
          "卢龙县"
        ]
      },
      {
        "name": "邯郸",
        "area": [
          "邯山区",
          "丛台区",
          "复兴区",
          "峰峰矿区",
          "邯郸县",
          "临漳县",
          "成安县",
          "大名县",
          "涉  县",
          "磁  县",
          "肥乡县",
          "永年县",
          "邱  县",
          "鸡泽县",
          "广平县",
          "馆陶县",
          "魏  县",
          "曲周县",
          "武安市"
        ]
      },
      {
        "name": "邢台",
        "area": [
          "桥东区",
          "桥西区",
          "邢台县",
          "临城县",
          "内丘县",
          "柏乡县",
          "隆尧县",
          "任  县",
          "南和县",
          "宁晋县",
          "巨鹿县",
          "新河县",
          "广宗县",
          "平乡县",
          "威  县",
          "清河县",
          "临西县",
          "南宫市",
          "沙河市"
        ]
      },
      {
        "name": "保定",
        "area": [
          "新市区",
          "北市区",
          "南市区",
          "满城县",
          "清苑县",
          "涞水县",
          "阜平县",
          "徐水县",
          "定兴县",
          "唐  县",
          "高阳县",
          "容城县",
          "涞源县",
          "望都县",
          "安新县",
          "易  县",
          "曲阳县",
          "蠡  县",
          "顺平县",
          "博野",
          "雄县",
          "涿州市",
          "定州市",
          "安国市",
          "高碑店市"
        ]
      },
      {
        "name": "张家口",
        "area": [
          "桥东区",
          "桥西区",
          "宣化区",
          "下花园区",
          "宣化县",
          "张北县",
          "康保县",
          "沽源县",
          "尚义县",
          "蔚  县",
          "阳原县",
          "怀安县",
          "万全县",
          "怀来县",
          "涿鹿县",
          "赤城县",
          "崇礼县"
        ]
      },
      {
        "name": "承德",
        "area": [
          "双桥区",
          "双滦区",
          "鹰手营子矿区",
          "承德县",
          "兴隆县",
          "平泉县",
          "滦平县",
          "隆化县",
          "丰宁满族自治县",
          "宽城满族自治县",
          "围场满族蒙古族自治县"
        ]
      },
      {
        "name": "沧州",
        "area": [
          "新华区",
          "运河区",
          "沧县",
          "青县",
          "东光县",
          "海兴县",
          "盐山县",
          "肃宁县",
          "南皮县",
          "吴桥县",
          "献  县",
          "孟村回族自治县",
          "泊头市",
          "任丘市",
          "黄骅市",
          "河间市"
        ]
      },
      {
        "name": "廊坊",
        "area": [
          "安次区",
          "固安县",
          "永清县",
          "香河县",
          "大城县",
          "文安县",
          "大厂回族自治县",
          "霸州市",
          "三河市"
        ]
      },
      {
        "name": "衡水",
        "area": [
          "桃城区",
          "枣强县",
          "武邑县",
          "武强县",
          "饶阳县",
          "安平县",
          "故城县",
          "景县",
          "阜城县",
          "冀州市",
          "深州市"
        ]
      }
    ]
  },
  {
    "name": "山西省",
    "city": [
      {
        "name": "太原",
        "area": [
          "小店区",
          "迎泽区",
          "杏花岭区",
          "尖草坪区",
          "万柏林区",
          "晋源区",
          "清徐县",
          "阳曲县",
          "娄烦县",
          "古交市"
        ]
      },
      {
        "name": "大同",
        "area": [
          "城区",
          "矿区",
          "南郊区",
          "新荣区",
          "阳高县",
          "天镇县",
          "广灵县",
          "灵丘县",
          "浑源县",
          "左云县",
          "大同县"
        ]
      },
      {
        "name": "阳泉",
        "area": [
          "城区",
          "矿区",
          "郊区",
          "平定县",
          "盂县"
        ]
      },
      {
        "name": "长治",
        "area": [
          "城区",
          "郊区",
          "长治县",
          "襄垣县",
          "屯留县",
          "平顺县",
          "黎城县",
          "壶关县",
          "长子县",
          "武乡县",
          "沁县",
          "沁源县",
          "潞城市"
        ]
      },
      {
        "name": "晋城",
        "area": [
          "城区",
          "沁水县",
          "阳城县",
          "陵川县",
          "泽州县",
          "高平市"
        ]
      },
      {
        "name": "朔州",
        "area": [
          "朔城区",
          "平鲁区",
          "山阴县",
          "应县",
          "右玉县",
          "怀仁县"
        ]
      },
      {
        "name": "忻州",
        "area": [
          "忻府区",
          "原平市",
          "定襄县",
          "五台县",
          "代县",
          "繁峙县",
          "宁武县",
          "静乐县",
          "神池县",
          "五寨县",
          "岢岚县",
          "河曲县",
          "保德县",
          "偏关县"
        ]
      },
      {
        "name": "吕梁",
        "area": [
          "离石区",
          "孝义市",
          "汾阳市",
          "文水县",
          "交城县",
          "兴县",
          "临县",
          "柳林县",
          "石楼县",
          "岚县",
          "方山县",
          "中阳县",
          "交口县"
        ]
      },
      {
        "name": "晋中",
        "area": [
          "榆次市",
          "介休市",
          "榆社县",
          "左权县",
          "和顺县",
          "昔阳县",
          "寿阳县",
          "太谷县",
          "祁县",
          "平遥县",
          "灵石县"
        ]
      },
      {
        "name": "临汾",
        "area": [
          "临汾市",
          "侯马市",
          "霍州市",
          "曲沃县",
          "翼城县",
          "襄汾县",
          "洪洞县",
          "古县",
          "安泽县",
          "浮山县",
          "吉县",
          "乡宁县",
          "蒲县",
          "大宁县",
          "永和县",
          "隰县",
          "汾西县"
        ]
      },
      {
        "name": "运城",
        "area": [
          "运城市",
          "永济市",
          "河津市",
          "芮城县",
          "临猗县",
          "万荣县",
          "新绛县",
          "稷山县",
          "闻喜县",
          "夏县",
          "绛县",
          "平陆县",
          "垣曲县"
        ]
      }
    ]
  },
  {
    "name": "内蒙古",
    "city": [
      {
        "name": "呼和浩特",
        "area": [
          "新城区",
          "回民区",
          "玉泉区",
          "郊区",
          "土默特左旗",
          "托克托县",
          "和林格尔县",
          "清水河县",
          "武川县"
        ]
      },
      {
        "name": "包头",
        "area": [
          "东河区",
          "昆都伦区",
          "青山区",
          "石拐矿区",
          "白云矿区",
          "郊区",
          "土默特右旗",
          "固阳县",
          "达尔罕茂明安联合旗"
        ]
      },
      {
        "name": "乌海",
        "area": [
          "海勃湾区",
          "海南区",
          "乌达区"
        ]
      },
      {
        "name": "赤峰",
        "area": [
          "红山区",
          "元宝山区",
          "松山区",
          "阿鲁科尔沁旗",
          "巴林左旗",
          "巴林右旗",
          "林西县",
          "克什克腾旗",
          "翁牛特旗",
          "喀喇沁旗",
          "宁城县",
          "敖汉旗"
        ]
      },
      {
        "name": "呼伦贝尔",
        "area": [
          "海拉尔市",
          "满洲里市",
          "扎兰屯市",
          "牙克石市",
          "根河市",
          "额尔古纳市",
          "阿荣旗",
          "莫力达瓦达斡尔族自治旗",
          "鄂伦春自治旗",
          "鄂温克族自治旗",
          "新巴尔虎右旗",
          "新巴尔虎左旗",
          "陈巴尔虎旗"
        ]
      },
      {
        "name": "兴安盟",
        "area": [
          "乌兰浩特市",
          "阿尔山市",
          "科尔沁右翼前旗",
          "科尔沁右翼中旗",
          "扎赉特旗",
          "突泉县"
        ]
      },
      {
        "name": "通辽",
        "area": [
          "科尔沁区",
          "霍林郭勒市",
          "科尔沁左翼中旗",
          "科尔沁左翼后旗",
          "开鲁县",
          "库伦旗",
          "奈曼旗",
          "扎鲁特旗"
        ]
      },
      {
        "name": "锡林郭勒盟",
        "area": [
          "二连浩特市",
          "锡林浩特市",
          "阿巴嘎旗",
          "苏尼特左旗",
          "苏尼特右旗",
          "东乌珠穆沁旗",
          "西乌珠穆沁旗",
          "太仆寺旗",
          "镶黄旗",
          "正镶白旗",
          "正蓝旗",
          "多伦县"
        ]
      },
      {
        "name": "乌兰察布盟",
        "area": [
          "集宁市",
          "丰镇市",
          "卓资县",
          "化德县",
          "商都县",
          "兴和县",
          "凉城县",
          "察哈尔右翼前旗",
          "察哈尔右翼中旗",
          "察哈尔右翼后旗",
          "四子王旗"
        ]
      },
      {
        "name": "伊克昭盟",
        "area": [
          "东胜市",
          "达拉特旗",
          "准格尔旗",
          "鄂托克前旗",
          "鄂托克旗",
          "杭锦旗",
          "乌审旗",
          "伊金霍洛旗"
        ]
      },
      {
        "name": "巴彦淖尔盟",
        "area": [
          "临河市",
          "五原县",
          "磴口县",
          "乌拉特前旗",
          "乌拉特中旗",
          "乌拉特后旗",
          "杭锦后旗"
        ]
      },
      {
        "name": "阿拉善盟",
        "area": [
          "阿拉善左旗",
          "阿拉善右旗",
          "额济纳旗"
        ]
      }
    ]
  },
  {
    "name": "辽宁省",
    "city": [
      {
        "name": "沈阳",
        "area": [
          "沈河区",
          "皇姑区",
          "和平区",
          "大东区",
          "铁西区",
          "苏家屯区",
          "东陵区",
          "于洪区",
          "新民市",
          "法库县",
          "辽中县",
          "康平县",
          "新城子区",
          "其他"
        ]
      },
      {
        "name": "大连",
        "area": [
          "西岗区",
          "中山区",
          "沙河口区",
          "甘井子区",
          "旅顺口区",
          "金州区",
          "瓦房店市",
          "普兰店市",
          "庄河市",
          "长海县",
          "其他"
        ]
      },
      {
        "name": "鞍山",
        "area": [
          "铁东区",
          "铁西区",
          "立山区",
          "千山区",
          "海城市",
          "台安县",
          "岫岩满族自治县",
          "其他"
        ]
      },
      {
        "name": "抚顺",
        "area": [
          "顺城区",
          "新抚区",
          "东洲区",
          "望花区",
          "抚顺县",
          "清原满族自治县",
          "新宾满族自治县",
          "其他"
        ]
      },
      {
        "name": "本溪",
        "area": [
          "平山区",
          "明山区",
          "溪湖区",
          "南芬区",
          "本溪满族自治县",
          "桓仁满族自治县",
          "其他"
        ]
      },
      {
        "name": "丹东",
        "area": [
          "振兴区",
          "元宝区",
          "振安区",
          "东港市",
          "凤城市",
          "宽甸满族自治县",
          "其他"
        ]
      },
      {
        "name": "锦州",
        "area": [
          "太和区",
          "古塔区",
          "凌河区",
          "凌海市",
          "黑山县",
          "义县",
          "北宁市",
          "其他"
        ]
      },
      {
        "name": "营口",
        "area": [
          "站前区",
          "西市区",
          "鲅鱼圈区",
          "老边区",
          "大石桥市",
          "盖州市",
          "其他"
        ]
      },
      {
        "name": "阜新",
        "area": [
          "海州区",
          "新邱区",
          "太平区",
          "清河门区",
          "细河区",
          "彰武县",
          "阜新蒙古族自治县",
          "其他"
        ]
      },
      {
        "name": "辽阳",
        "area": [
          "白塔区",
          "文圣区",
          "宏伟区",
          "太子河区",
          "弓长岭区",
          "灯塔市",
          "辽阳县",
          "其他"
        ]
      },
      {
        "name": "盘锦",
        "area": [
          "双台子区",
          "兴隆台区",
          "盘山县",
          "大洼县",
          "其他"
        ]
      },
      {
        "name": "铁岭",
        "area": [
          "银州区",
          "清河区",
          "调兵山市",
          "开原市",
          "铁岭县",
          "昌图县",
          "西丰县",
          "其他"
        ]
      },
      {
        "name": "朝阳",
        "area": [
          "双塔区",
          "龙城区",
          "凌源市",
          "北票市",
          "朝阳县",
          "建平县",
          "喀喇沁左翼蒙古族自治县",
          "其他"
        ]
      },
      {
        "name": "葫芦岛",
        "area": [
          "龙港区",
          "南票区",
          "连山区",
          "兴城市",
          "绥中县",
          "建昌县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "吉林省",
    "city": [
      {
        "name": "长春",
        "area": [
          "朝阳区",
          "宽城区",
          "二道区",
          "南关区",
          "绿园区",
          "双阳区",
          "九台市",
          "榆树市",
          "德惠市",
          "农安县",
          "其他"
        ]
      },
      {
        "name": "吉林",
        "area": [
          "船营区",
          "昌邑区",
          "龙潭区",
          "丰满区",
          "舒兰市",
          "桦甸市",
          "蛟河市",
          "磐石市",
          "永吉县",
          "其他"
        ]
      },
      {
        "name": "四平",
        "area": [
          "铁西区",
          "铁东区",
          "公主岭市",
          "双辽市",
          "梨树县",
          "伊通满族自治县",
          "其他"
        ]
      },
      {
        "name": "辽源",
        "area": [
          "龙山区",
          "西安区",
          "东辽县",
          "东丰县",
          "其他"
        ]
      },
      {
        "name": "通化",
        "area": [
          "东昌区",
          "二道江区",
          "梅河口市",
          "集安市",
          "通化县",
          "辉南县",
          "柳河县",
          "其他"
        ]
      },
      {
        "name": "白山",
        "area": [
          "八道江区",
          "江源区",
          "临江市",
          "靖宇县",
          "抚松县",
          "长白朝鲜族自治县",
          "其他"
        ]
      },
      {
        "name": "松原",
        "area": [
          "宁江区",
          "乾安县",
          "长岭县",
          "扶余县",
          "前郭尔罗斯蒙古族自治县",
          "其他"
        ]
      },
      {
        "name": "白城",
        "area": [
          "洮北区",
          "大安市",
          "洮南市",
          "镇赉县",
          "通榆县",
          "其他"
        ]
      },
      {
        "name": "延边朝鲜族自治州",
        "area": [
          "延吉市",
          "图们市",
          "敦化市",
          "龙井市",
          "珲春市",
          "和龙市",
          "安图县",
          "汪清县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "黑龙江省",
    "city": [
      {
        "name": "哈尔滨",
        "area": [
          "松北区",
          "道里区",
          "南岗区",
          "平房区",
          "香坊区",
          "道外区",
          "呼兰区",
          "阿城区",
          "双城市",
          "尚志市",
          "五常市",
          "宾县",
          "方正县",
          "通河县",
          "巴彦县",
          "延寿县",
          "木兰县",
          "依兰县",
          "其他"
        ]
      },
      {
        "name": "齐齐哈尔",
        "area": [
          "龙沙区",
          "昂昂溪区",
          "铁锋区",
          "建华区",
          "富拉尔基区",
          "碾子山区",
          "梅里斯达斡尔族区",
          "讷河市",
          "富裕县",
          "拜泉县",
          "甘南县",
          "依安县",
          "克山县",
          "泰来县",
          "克东县",
          "龙江县",
          "其他"
        ]
      },
      {
        "name": "鹤岗",
        "area": [
          "兴山区",
          "工农区",
          "南山区",
          "兴安区",
          "向阳区",
          "东山区",
          "萝北县",
          "绥滨县",
          "其他"
        ]
      },
      {
        "name": "双鸭山",
        "area": [
          "尖山区",
          "岭东区",
          "四方台区",
          "宝山区",
          "集贤县",
          "宝清县",
          "友谊县",
          "饶河县",
          "其他"
        ]
      },
      {
        "name": "鸡西",
        "area": [
          "鸡冠区",
          "恒山区",
          "城子河区",
          "滴道区",
          "梨树区",
          "麻山区",
          "密山市",
          "虎林市",
          "鸡东县",
          "其他"
        ]
      },
      {
        "name": "大庆",
        "area": [
          "萨尔图区",
          "红岗区",
          "龙凤区",
          "让胡路区",
          "大同区",
          "林甸县",
          "肇州县",
          "肇源县",
          "杜尔伯特蒙古族自治县",
          "其他"
        ]
      },
      {
        "name": "伊春",
        "area": [
          "伊春区",
          "带岭区",
          "南岔区",
          "金山屯区",
          "西林区",
          "美溪区",
          "乌马河区",
          "翠峦区",
          "友好区",
          "上甘岭区",
          "五营区",
          "红星区",
          "新青区",
          "汤旺河区",
          "乌伊岭区",
          "铁力市",
          "嘉荫县",
          "其他"
        ]
      },
      {
        "name": "牡丹江",
        "area": [
          "爱民区",
          "东安区",
          "阳明区",
          "西安区",
          "绥芬河市",
          "宁安市",
          "海林市",
          "穆棱市",
          "林口县",
          "东宁县",
          "其他"
        ]
      },
      {
        "name": "佳木斯",
        "area": [
          "向阳区",
          "前进区",
          "东风区",
          "郊区",
          "同江市",
          "富锦市",
          "桦川县",
          "抚远县",
          "桦南县",
          "汤原县",
          "其他"
        ]
      },
      {
        "name": "七台河",
        "area": [
          "桃山区",
          "新兴区",
          "茄子河区",
          "勃利县",
          "其他"
        ]
      },
      {
        "name": "黑河",
        "area": [
          "爱辉区",
          "北安市",
          "五大连池市",
          "逊克县",
          "嫩江县",
          "孙吴县",
          "其他"
        ]
      },
      {
        "name": "绥化",
        "area": [
          "北林区",
          "安达市",
          "肇东市",
          "海伦市",
          "绥棱县",
          "兰西县",
          "明水县",
          "青冈县",
          "庆安县",
          "望奎县",
          "其他"
        ]
      },
      {
        "name": "大兴安岭地区",
        "area": [
          "呼玛县",
          "塔河县",
          "漠河县",
          "大兴安岭辖区",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "上海市",
    "city": [
      {
        "name": "上海",
        "area": [
          "黄浦区",
          "卢湾区",
          "徐汇区",
          "长宁区",
          "静安区",
          "普陀区",
          "闸北区",
          "虹口区",
          "杨浦区",
          "宝山区",
          "闵行区",
          "嘉定区",
          "松江区",
          "金山区",
          "青浦区",
          "南汇区",
          "奉贤区",
          "浦东新区",
          "崇明县",
          "其他"
        ]
      }
    ]
  },
  {
    "name": "江苏省",
    "city": [
      {
        "name": "南京",
        "area": [
          "玄武区",
          "白下区",
          "秦淮区",
          "建邺区",
          "鼓楼区",
          "下关区",
          "栖霞区",
          "雨花台区",
          "浦口区",
          "江宁区",
          "六合区",
          "溧水县",
          "高淳县",
          "其他"
        ]
      },
      {
        "name": "苏州",
        "area": [
          "金阊区",
          "平江区",
          "沧浪区",
          "虎丘区",
          "吴中区",
          "相城区",
          "常熟市",
          "张家港市",
          "昆山市",
          "吴江市",
          "太仓市",
          "其他"
        ]
      },
      {
        "name": "无锡",
        "area": [
          "崇安区",
          "南长区",
          "北塘区",
          "滨湖区",
          "锡山区",
          "惠山区",
          "江阴市",
          "宜兴市",
          "其他"
        ]
      },
      {
        "name": "常州",
        "area": [
          "钟楼区",
          "天宁区",
          "戚墅堰区",
          "新北区",
          "武进区",
          "金坛市",
          "溧阳市",
          "其他"
        ]
      },
      {
        "name": "镇江",
        "area": [
          "京口区",
          "润州区",
          "丹徒区",
          "丹阳市",
          "扬中市",
          "句容市",
          "其他"
        ]
      },
      {
        "name": "南通",
        "area": [
          "崇川区",
          "港闸区",
          "通州市",
          "如皋市",
          "海门市",
          "启东市",
          "海安县",
          "如东县",
          "其他"
        ]
      },
      {
        "name": "泰州",
        "area": [
          "海陵区",
          "高港区",
          "姜堰市",
          "泰兴市",
          "靖江市",
          "兴化市",
          "其他"
        ]
      },
      {
        "name": "扬州",
        "area": [
          "广陵区",
          "维扬区",
          "邗江区",
          "江都市",
          "仪征市",
          "高邮市",
          "宝应县",
          "其他"
        ]
      },
      {
        "name": "盐城",
        "area": [
          "亭湖区",
          "盐都区",
          "大丰市",
          "东台市",
          "建湖县",
          "射阳县",
          "阜宁县",
          "滨海县",
          "响水县",
          "其他"
        ]
      },
      {
        "name": "连云港",
        "area": [
          "新浦区",
          "海州区",
          "连云区",
          "东海县",
          "灌云县",
          "赣榆县",
          "灌南县",
          "其他"
        ]
      },
      {
        "name": "徐州",
        "area": [
          "云龙区",
          "鼓楼区",
          "九里区",
          "泉山区",
          "贾汪区",
          "邳州市",
          "新沂市",
          "铜山县",
          "睢宁县",
          "沛县",
          "丰县",
          "其他"
        ]
      },
      {
        "name": "淮安",
        "area": [
          "清河区",
          "清浦区",
          "楚州区",
          "淮阴区",
          "涟水县",
          "洪泽县",
          "金湖县",
          "盱眙县",
          "其他"
        ]
      },
      {
        "name": "宿迁",
        "area": [
          "宿城区",
          "宿豫区",
          "沭阳县",
          "泗阳县",
          "泗洪县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "浙江省",
    "city": [
      {
        "name": "杭州",
        "area": [
          "拱墅区",
          "西湖区",
          "上城区",
          "下城区",
          "江干区",
          "滨江区",
          "余杭区",
          "萧山区",
          "建德市",
          "富阳市",
          "临安市",
          "桐庐县",
          "淳安县",
          "其他"
        ]
      },
      {
        "name": "宁波",
        "area": [
          "海曙区",
          "江东区",
          "江北区",
          "镇海区",
          "北仑区",
          "鄞州区",
          "余姚市",
          "慈溪市",
          "奉化市",
          "宁海县",
          "象山县",
          "其他"
        ]
      },
      {
        "name": "温州",
        "area": [
          "鹿城区",
          "龙湾区",
          "瓯海区",
          "瑞安市",
          "乐清市",
          "永嘉县",
          "洞头县",
          "平阳县",
          "苍南县",
          "文成县",
          "泰顺县",
          "其他"
        ]
      },
      {
        "name": "嘉兴",
        "area": [
          "秀城区",
          "秀洲区",
          "海宁市",
          "平湖市",
          "桐乡市",
          "嘉善县",
          "海盐县",
          "其他"
        ]
      },
      {
        "name": "湖州",
        "area": [
          "吴兴区",
          "南浔区",
          "长兴县",
          "德清县",
          "安吉县",
          "其他"
        ]
      },
      {
        "name": "绍兴",
        "area": [
          "越城区",
          "诸暨市",
          "上虞市",
          "嵊州市",
          "绍兴县",
          "新昌县",
          "其他"
        ]
      },
      {
        "name": "金华",
        "area": [
          "婺城区",
          "金东区",
          "兰溪市",
          "义乌市",
          "东阳市",
          "永康市",
          "武义县",
          "浦江县",
          "磐安县",
          "其他"
        ]
      },
      {
        "name": "衢州",
        "area": [
          "柯城区",
          "衢江区",
          "江山市",
          "龙游县",
          "常山县",
          "开化县",
          "其他"
        ]
      },
      {
        "name": "舟山",
        "area": [
          "定海区",
          "普陀区",
          "岱山县",
          "嵊泗县",
          "其他"
        ]
      },
      {
        "name": "台州",
        "area": [
          "椒江区",
          "黄岩区",
          "路桥区",
          "临海市",
          "温岭市",
          "玉环县",
          "天台县",
          "仙居县",
          "三门县",
          "其他"
        ]
      },
      {
        "name": "丽水",
        "area": [
          "莲都区",
          "龙泉市",
          "缙云县",
          "青田县",
          "云和县",
          "遂昌县",
          "松阳县",
          "庆元县",
          "景宁畲族自治县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "安徽省",
    "city": [
      {
        "name": "合肥",
        "area": [
          "庐阳区",
          "瑶海区",
          "蜀山区",
          "包河区",
          "长丰县",
          "肥东县",
          "肥西县",
          "其他"
        ]
      },
      {
        "name": "芜湖",
        "area": [
          "镜湖区",
          "弋江区",
          "鸠江区",
          "三山区",
          "芜湖县",
          "南陵县",
          "繁昌县",
          "其他"
        ]
      },
      {
        "name": "蚌埠",
        "area": [
          "蚌山区",
          "龙子湖区",
          "禹会区",
          "淮上区",
          "怀远县",
          "固镇县",
          "五河县",
          "其他"
        ]
      },
      {
        "name": "淮南",
        "area": [
          "田家庵区",
          "大通区",
          "谢家集区",
          "八公山区",
          "潘集区",
          "凤台县",
          "其他"
        ]
      },
      {
        "name": "马鞍山",
        "area": [
          "雨山区",
          "花山区",
          "金家庄区",
          "当涂县",
          "其他"
        ]
      },
      {
        "name": "淮北",
        "area": [
          "相山区",
          "杜集区",
          "烈山区",
          "濉溪县",
          "其他"
        ]
      },
      {
        "name": "铜陵",
        "area": [
          "铜官山区",
          "狮子山区",
          "郊区",
          "铜陵县",
          "其他"
        ]
      },
      {
        "name": "安庆",
        "area": [
          "迎江区",
          "大观区",
          "宜秀区",
          "桐城市",
          "宿松县",
          "枞阳县",
          "太湖县",
          "怀宁县",
          "岳西县",
          "望江县",
          "潜山县",
          "其他"
        ]
      },
      {
        "name": "黄山",
        "area": [
          "屯溪区",
          "黄山区",
          "徽州区",
          "休宁县",
          "歙县",
          "祁门县",
          "黟县",
          "其他"
        ]
      },
      {
        "name": "滁州",
        "area": [
          "琅琊区",
          "南谯区",
          "天长市",
          "明光市",
          "全椒县",
          "来安县",
          "定远县",
          "凤阳县",
          "其他"
        ]
      },
      {
        "name": "阜阳",
        "area": [
          "颍州区",
          "颍东区",
          "颍泉区",
          "界首市",
          "临泉县",
          "颍上县",
          "阜南县",
          "太和县",
          "其他"
        ]
      },
      {
        "name": "宿州",
        "area": [
          "埇桥区",
          "萧县",
          "泗县",
          "砀山县",
          "灵璧县",
          "其他"
        ]
      },
      {
        "name": "巢湖",
        "area": [
          "居巢区",
          "含山县",
          "无为县",
          "庐江县",
          "和县",
          "其他"
        ]
      },
      {
        "name": "六安",
        "area": [
          "金安区",
          "裕安区",
          "寿县",
          "霍山县",
          "霍邱县",
          "舒城县",
          "金寨县",
          "其他"
        ]
      },
      {
        "name": "亳州",
        "area": [
          "谯城区",
          "利辛县",
          "涡阳县",
          "蒙城县",
          "其他"
        ]
      },
      {
        "name": "池州",
        "area": [
          "贵池区",
          "东至县",
          "石台县",
          "青阳县",
          "其他"
        ]
      },
      {
        "name": "宣城",
        "area": [
          "宣州区",
          "宁国市",
          "广德县",
          "郎溪县",
          "泾县",
          "旌德县",
          "绩溪县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "福建省",
    "city": [
      {
        "name": "福州",
        "area": [
          "鼓楼区",
          "台江区",
          "仓山区",
          "马尾区",
          "晋安区",
          "福清市",
          "长乐市",
          "闽侯县",
          "闽清县",
          "永泰县",
          "连江县",
          "罗源县",
          "平潭县",
          "其他"
        ]
      },
      {
        "name": "厦门",
        "area": [
          "思明区",
          "海沧区",
          "湖里区",
          "集美区",
          "同安区",
          "翔安区",
          "其他"
        ]
      },
      {
        "name": "莆田",
        "area": [
          "城厢区",
          "涵江区",
          "荔城区",
          "秀屿区",
          "仙游县",
          "其他"
        ]
      },
      {
        "name": "三明",
        "area": [
          "梅列区",
          "三元区",
          "永安市",
          "明溪县",
          "将乐县",
          "大田县",
          "宁化县",
          "建宁县",
          "沙县",
          "尤溪县",
          "清流县",
          "泰宁县",
          "其他"
        ]
      },
      {
        "name": "泉州",
        "area": [
          "鲤城区",
          "丰泽区",
          "洛江区",
          "泉港区",
          "石狮市",
          "晋江市",
          "南安市",
          "惠安县",
          "永春县",
          "安溪县",
          "德化县",
          "金门县",
          "其他"
        ]
      },
      {
        "name": "漳州",
        "area": [
          "芗城区",
          "龙文区",
          "龙海市",
          "平和县",
          "南靖县",
          "诏安县",
          "漳浦县",
          "华安县",
          "东山县",
          "长泰县",
          "云霄县",
          "其他"
        ]
      },
      {
        "name": "南平",
        "area": [
          "延平区",
          "建瓯市",
          "邵武市",
          "武夷山市",
          "建阳市",
          "松溪县",
          "光泽县",
          "顺昌县",
          "浦城县",
          "政和县",
          "其他"
        ]
      },
      {
        "name": "龙岩",
        "area": [
          "新罗区",
          "漳平市",
          "长汀县",
          "武平县",
          "上杭县",
          "永定县",
          "连城县",
          "其他"
        ]
      },
      {
        "name": "宁德",
        "area": [
          "蕉城区",
          "福安市",
          "福鼎市",
          "寿宁县",
          "霞浦县",
          "柘荣县",
          "屏南县",
          "古田县",
          "周宁县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "江西省",
    "city": [
      {
        "name": "南昌",
        "area": [
          "东湖区",
          "西湖区",
          "青云谱区",
          "湾里区",
          "青山湖区",
          "新建县",
          "南昌县",
          "进贤县",
          "安义县",
          "其他"
        ]
      },
      {
        "name": "景德镇",
        "area": [
          "珠山区",
          "昌江区",
          "乐平市",
          "浮梁县",
          "其他"
        ]
      },
      {
        "name": "萍乡",
        "area": [
          "安源区",
          "湘东区",
          "莲花县",
          "上栗县",
          "芦溪县",
          "其他"
        ]
      },
      {
        "name": "九江",
        "area": [
          "浔阳区",
          "庐山区",
          "瑞昌市",
          "九江县",
          "星子县",
          "武宁县",
          "彭泽县",
          "永修县",
          "修水县",
          "湖口县",
          "德安县",
          "都昌县",
          "其他"
        ]
      },
      {
        "name": "新余",
        "area": [
          "渝水区",
          "分宜县",
          "其他"
        ]
      },
      {
        "name": "鹰潭",
        "area": [
          "月湖区",
          "贵溪市",
          "余江县",
          "其他"
        ]
      },
      {
        "name": "赣州",
        "area": [
          "章贡区",
          "瑞金市",
          "南康市",
          "石城县",
          "安远县",
          "赣县",
          "宁都县",
          "寻乌县",
          "兴国县",
          "定南县",
          "上犹县",
          "于都县",
          "龙南县",
          "崇义县",
          "信丰县",
          "全南县",
          "大余县",
          "会昌县",
          "其他"
        ]
      },
      {
        "name": "吉安",
        "area": [
          "吉州区",
          "青原区",
          "井冈山市",
          "吉安县",
          "永丰县",
          "永新县",
          "新干县",
          "泰和县",
          "峡江县",
          "遂川县",
          "安福县",
          "吉水县",
          "万安县",
          "其他"
        ]
      },
      {
        "name": "宜春",
        "area": [
          "袁州区",
          "丰城市",
          "樟树市",
          "高安市",
          "铜鼓县",
          "靖安县",
          "宜丰县",
          "奉新县",
          "万载县",
          "上高县",
          "其他"
        ]
      },
      {
        "name": "抚州",
        "area": [
          "临川区",
          "南丰县",
          "乐安县",
          "金溪县",
          "南城县",
          "东乡县",
          "资溪县",
          "宜黄县",
          "广昌县",
          "黎川县",
          "崇仁县",
          "其他"
        ]
      },
      {
        "name": "上饶",
        "area": [
          "信州区",
          "德兴市",
          "上饶县",
          "广丰县",
          "鄱阳县",
          "婺源县",
          "铅山县",
          "余干县",
          "横峰县",
          "弋阳县",
          "玉山县",
          "万年县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "山东省",
    "city": [
      {
        "name": "济南",
        "area": [
          "市中区",
          "历下区",
          "天桥区",
          "槐荫区",
          "历城区",
          "长清区",
          "章丘市",
          "平阴县",
          "济阳县",
          "商河县",
          "其他"
        ]
      },
      {
        "name": "青岛",
        "area": [
          "市南区",
          "市北区",
          "城阳区",
          "四方区",
          "李沧区",
          "黄岛区",
          "崂山区",
          "胶南市",
          "胶州市",
          "平度市",
          "莱西市",
          "即墨市",
          "其他"
        ]
      },
      {
        "name": "淄博",
        "area": [
          "张店区",
          "临淄区",
          "淄川区",
          "博山区",
          "周村区",
          "桓台县",
          "高青县",
          "沂源县",
          "其他"
        ]
      },
      {
        "name": "枣庄",
        "area": [
          "市中区",
          "山亭区",
          "峄城区",
          "台儿庄区",
          "薛城区",
          "滕州市",
          "其他"
        ]
      },
      {
        "name": "东营",
        "area": [
          "东营区",
          "河口区",
          "垦利县",
          "广饶县",
          "利津县",
          "其他"
        ]
      },
      {
        "name": "烟台",
        "area": [
          "芝罘区",
          "福山区",
          "牟平区",
          "莱山区",
          "龙口市",
          "莱阳市",
          "莱州市",
          "招远市",
          "蓬莱市",
          "栖霞市",
          "海阳市",
          "长岛县",
          "其他"
        ]
      },
      {
        "name": "潍坊",
        "area": [
          "潍城区",
          "寒亭区",
          "坊子区",
          "奎文区",
          "青州市",
          "诸城市",
          "寿光市",
          "安丘市",
          "高密市",
          "昌邑市",
          "昌乐县",
          "临朐县",
          "其他"
        ]
      },
      {
        "name": "济宁",
        "area": [
          "市中区",
          "任城区",
          "曲阜市",
          "兖州市",
          "邹城市",
          "鱼台县",
          "金乡县",
          "嘉祥县",
          "微山县",
          "汶上县",
          "泗水县",
          "梁山县",
          "其他"
        ]
      },
      {
        "name": "泰安",
        "area": [
          "泰山区",
          "岱岳区",
          "新泰市",
          "肥城市",
          "宁阳县",
          "东平县",
          "其他"
        ]
      },
      {
        "name": "威海",
        "area": [
          "环翠区",
          "乳山市",
          "文登市",
          "荣成市",
          "其他"
        ]
      },
      {
        "name": "日照",
        "area": [
          "东港区",
          "岚山区",
          "五莲县",
          "莒县",
          "其他"
        ]
      },
      {
        "name": "莱芜",
        "area": [
          "莱城区",
          "钢城区",
          "其他"
        ]
      },
      {
        "name": "临沂",
        "area": [
          "兰山区",
          "罗庄区",
          "河东区",
          "沂南县",
          "郯城县",
          "沂水县",
          "苍山县",
          "费县",
          "平邑县",
          "莒南县",
          "蒙阴县",
          "临沭县",
          "其他"
        ]
      },
      {
        "name": "德州",
        "area": [
          "德城区",
          "乐陵市",
          "禹城市",
          "陵县",
          "宁津县",
          "齐河县",
          "武城县",
          "庆云县",
          "平原县",
          "夏津县",
          "临邑县",
          "其他"
        ]
      },
      {
        "name": "聊城",
        "area": [
          "东昌府区",
          "临清市",
          "高唐县",
          "阳谷县",
          "茌平县",
          "莘县",
          "东阿县",
          "冠县",
          "其他"
        ]
      },
      {
        "name": "滨州",
        "area": [
          "滨城区",
          "邹平县",
          "沾化县",
          "惠民县",
          "博兴县",
          "阳信县",
          "无棣县",
          "其他"
        ]
      },
      {
        "name": "菏泽",
        "area": [
          "牡丹区",
          "鄄城县",
          "单县",
          "郓城县",
          "曹县",
          "定陶县",
          "巨野县",
          "东明县",
          "成武县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "河南省",
    "city": [
      {
        "name": "郑州",
        "area": [
          "中原区",
          "金水区",
          "二七区",
          "管城回族区",
          "上街区",
          "惠济区",
          "巩义市",
          "新郑市",
          "新密市",
          "登封市",
          "荥阳市",
          "中牟县",
          "其他"
        ]
      },
      {
        "name": "开封",
        "area": [
          "鼓楼区",
          "龙亭区",
          "顺河回族区",
          "禹王台区",
          "金明区",
          "开封县",
          "尉氏县",
          "兰考县",
          "杞县",
          "通许县",
          "其他"
        ]
      },
      {
        "name": "洛阳",
        "area": [
          "西工区",
          "老城区",
          "涧西区",
          "瀍河回族区",
          "洛龙区",
          "吉利区",
          "偃师市",
          "孟津县",
          "汝阳县",
          "伊川县",
          "洛宁县",
          "嵩县",
          "宜阳县",
          "新安县",
          "栾川县",
          "其他"
        ]
      },
      {
        "name": "平顶山",
        "area": [
          "新华区",
          "卫东区",
          "湛河区",
          "石龙区",
          "汝州市",
          "舞钢市",
          "宝丰县",
          "叶县",
          "郏县",
          "鲁山县",
          "其他"
        ]
      },
      {
        "name": "安阳",
        "area": [
          "北关区",
          "文峰区",
          "殷都区",
          "龙安区",
          "林州市",
          "安阳县",
          "滑县",
          "内黄县",
          "汤阴县",
          "其他"
        ]
      },
      {
        "name": "鹤壁",
        "area": [
          "淇滨区",
          "山城区",
          "鹤山区",
          "浚县",
          "淇县",
          "其他"
        ]
      },
      {
        "name": "新乡",
        "area": [
          "卫滨区",
          "红旗区",
          "凤泉区",
          "牧野区",
          "卫辉市",
          "辉县市",
          "新乡县",
          "获嘉县",
          "原阳县",
          "长垣县",
          "封丘县",
          "延津县",
          "其他"
        ]
      },
      {
        "name": "焦作",
        "area": [
          "解放区",
          "中站区",
          "马村区",
          "山阳区",
          "沁阳市",
          "孟州市",
          "修武县",
          "温县",
          "武陟县",
          "博爱县",
          "其他"
        ]
      },
      {
        "name": "濮阳",
        "area": [
          "华龙区",
          "濮阳县",
          "南乐县",
          "台前县",
          "清丰县",
          "范县",
          "其他"
        ]
      },
      {
        "name": "许昌",
        "area": [
          "魏都区",
          "禹州市",
          "长葛市",
          "许昌县",
          "鄢陵县",
          "襄城县",
          "其他"
        ]
      },
      {
        "name": "漯河",
        "area": [
          "源汇区",
          "郾城区",
          "召陵区",
          "临颍县",
          "舞阳县",
          "其他"
        ]
      },
      {
        "name": "三门峡",
        "area": [
          "湖滨区",
          "义马市",
          "灵宝市",
          "渑池县",
          "卢氏县",
          "陕县",
          "其他"
        ]
      },
      {
        "name": "南阳",
        "area": [
          "卧龙区",
          "宛城区",
          "邓州市",
          "桐柏县",
          "方城县",
          "淅川县",
          "镇平县",
          "唐河县",
          "南召县",
          "内乡县",
          "新野县",
          "社旗县",
          "西峡县",
          "其他"
        ]
      },
      {
        "name": "商丘",
        "area": [
          "梁园区",
          "睢阳区",
          "永城市",
          "宁陵县",
          "虞城县",
          "民权县",
          "夏邑县",
          "柘城县",
          "睢县",
          "其他"
        ]
      },
      {
        "name": "信阳",
        "area": [
          "浉河区",
          "平桥区",
          "潢川县",
          "淮滨县",
          "息县",
          "新县",
          "商城县",
          "固始县",
          "罗山县",
          "光山县",
          "其他"
        ]
      },
      {
        "name": "周口",
        "area": [
          "川汇区",
          "项城市",
          "商水县",
          "淮阳县",
          "太康县",
          "鹿邑县",
          "西华县",
          "扶沟县",
          "沈丘县",
          "郸城县",
          "其他"
        ]
      },
      {
        "name": "驻马店",
        "area": [
          "驿城区",
          "确山县",
          "新蔡县",
          "上蔡县",
          "西平县",
          "泌阳县",
          "平舆县",
          "汝南县",
          "遂平县",
          "正阳县",
          "其他"
        ]
      },
      {
        "name": "焦作",
        "area": [
          "济源市",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "湖北省",
    "city": [
      {
        "name": "武汉",
        "area": [
          "江岸区",
          "武昌区",
          "江汉区",
          "硚口区",
          "汉阳区",
          "青山区",
          "洪山区",
          "东西湖区",
          "汉南区",
          "蔡甸区",
          "江夏区",
          "黄陂区",
          "新洲区",
          "其他"
        ]
      },
      {
        "name": "黄石",
        "area": [
          "黄石港区",
          "西塞山区",
          "下陆区",
          "铁山区",
          "大冶市",
          "阳新县",
          "其他"
        ]
      },
      {
        "name": "十堰",
        "area": [
          "张湾区",
          "茅箭区",
          "丹江口市",
          "郧县",
          "竹山县",
          "房县",
          "郧西县",
          "竹溪县",
          "其他"
        ]
      },
      {
        "name": "荆州",
        "area": [
          "沙市区",
          "荆州区",
          "洪湖市",
          "石首市",
          "松滋市",
          "监利县",
          "公安县",
          "江陵县",
          "其他"
        ]
      },
      {
        "name": "宜昌",
        "area": [
          "西陵区",
          "伍家岗区",
          "点军区",
          "猇亭区",
          "夷陵区",
          "宜都市",
          "当阳市",
          "枝江市",
          "秭归县",
          "远安县",
          "兴山县",
          "五峰土家族自治县",
          "长阳土家族自治县",
          "其他"
        ]
      },
      {
        "name": "襄樊",
        "area": [
          "襄城区",
          "樊城区",
          "襄阳区",
          "老河口市",
          "枣阳市",
          "宜城市",
          "南漳县",
          "谷城县",
          "保康县",
          "其他"
        ]
      },
      {
        "name": "鄂州",
        "area": [
          "鄂城区",
          "华容区",
          "梁子湖区",
          "其他"
        ]
      },
      {
        "name": "荆门",
        "area": [
          "东宝区",
          "掇刀区",
          "钟祥市",
          "京山县",
          "沙洋县",
          "其他"
        ]
      },
      {
        "name": "孝感",
        "area": [
          "孝南区",
          "应城市",
          "安陆市",
          "汉川市",
          "云梦县",
          "大悟县",
          "孝昌县",
          "其他"
        ]
      },
      {
        "name": "黄冈",
        "area": [
          "黄州区",
          "麻城市",
          "武穴市",
          "红安县",
          "罗田县",
          "浠水县",
          "蕲春县",
          "黄梅县",
          "英山县",
          "团风县",
          "其他"
        ]
      },
      {
        "name": "咸宁",
        "area": [
          "咸安区",
          "赤壁市",
          "嘉鱼县",
          "通山县",
          "崇阳县",
          "通城县",
          "其他"
        ]
      },
      {
        "name": "随州",
        "area": [
          "曾都区",
          "广水市",
          "其他"
        ]
      },
      {
        "name": "恩施土家族苗族自治州",
        "area": [
          "恩施市",
          "利川市",
          "建始县",
          "来凤县",
          "巴东县",
          "鹤峰县",
          "宣恩县",
          "咸丰县",
          "其他"
        ]
      },
      {
        "name": "仙桃",
        "area": [
          "仙桃"
        ]
      },
      {
        "name": "天门",
        "area": [
          "天门"
        ]
      },
      {
        "name": "潜江",
        "area": [
          "潜江"
        ]
      },
      {
        "name": "神农架林区",
        "area": [
          "神农架林区"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "湖南省",
    "city": [
      {
        "name": "长沙",
        "area": [
          "岳麓区",
          "芙蓉区",
          "天心区",
          "开福区",
          "雨花区",
          "浏阳市",
          "长沙县",
          "望城县",
          "宁乡县",
          "其他"
        ]
      },
      {
        "name": "株洲",
        "area": [
          "天元区",
          "荷塘区",
          "芦淞区",
          "石峰区",
          "醴陵市",
          "株洲县",
          "炎陵县",
          "茶陵县",
          "攸县",
          "其他"
        ]
      },
      {
        "name": "湘潭",
        "area": [
          "岳塘区",
          "雨湖区",
          "湘乡市",
          "韶山市",
          "湘潭县",
          "其他"
        ]
      },
      {
        "name": "衡阳",
        "area": [
          "雁峰区",
          "珠晖区",
          "石鼓区",
          "蒸湘区",
          "南岳区",
          "耒阳市",
          "常宁市",
          "衡阳县",
          "衡东县",
          "衡山县",
          "衡南县",
          "祁东县",
          "其他"
        ]
      },
      {
        "name": "邵阳",
        "area": [
          "双清区",
          "大祥区",
          "北塔区",
          "武冈市",
          "邵东县",
          "洞口县",
          "新邵县",
          "绥宁县",
          "新宁县",
          "邵阳县",
          "隆回县",
          "城步苗族自治县",
          "其他"
        ]
      },
      {
        "name": "岳阳",
        "area": [
          "岳阳楼区",
          "云溪区",
          "君山区",
          "临湘市",
          "汨罗市",
          "岳阳县",
          "湘阴县",
          "平江县",
          "华容县",
          "其他"
        ]
      },
      {
        "name": "常德",
        "area": [
          "武陵区",
          "鼎城区",
          "津市市",
          "澧县",
          "临澧县",
          "桃源县",
          "汉寿县",
          "安乡县",
          "石门县",
          "其他"
        ]
      },
      {
        "name": "张家界",
        "area": [
          "永定区",
          "武陵源区",
          "慈利县",
          "桑植县",
          "其他"
        ]
      },
      {
        "name": "益阳",
        "area": [
          "赫山区",
          "资阳区",
          "沅江市",
          "桃江县",
          "南县",
          "安化县",
          "其他"
        ]
      },
      {
        "name": "郴州",
        "area": [
          "北湖区",
          "苏仙区",
          "资兴市",
          "宜章县",
          "汝城县",
          "安仁县",
          "嘉禾县",
          "临武县",
          "桂东县",
          "永兴县",
          "桂阳县",
          "其他"
        ]
      },
      {
        "name": "永州",
        "area": [
          "冷水滩区",
          "零陵区",
          "祁阳县",
          "蓝山县",
          "宁远县",
          "新田县",
          "东安县",
          "江永县",
          "道县",
          "双牌县",
          "江华瑶族自治县",
          "其他"
        ]
      },
      {
        "name": "怀化",
        "area": [
          "鹤城区",
          "洪江市",
          "会同县",
          "沅陵县",
          "辰溪县",
          "溆浦县",
          "中方县",
          "新晃侗族自治县",
          "芷江侗族自治县",
          "通道侗族自治县",
          "靖州苗族侗族自治县",
          "麻阳苗族自治县",
          "其他"
        ]
      },
      {
        "name": "娄底",
        "area": [
          "娄星区",
          "冷水江市",
          "涟源市",
          "新化县",
          "双峰县",
          "其他"
        ]
      },
      {
        "name": "湘西土家族苗族自治州",
        "area": [
          "吉首市",
          "古丈县",
          "龙山县",
          "永顺县",
          "凤凰县",
          "泸溪县",
          "保靖县",
          "花垣县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "广东省",
    "city": [
      {
        "name": "广州",
        "area": [
          "越秀区",
          "荔湾区",
          "海珠区",
          "天河区",
          "白云区",
          "黄埔区",
          "番禺区",
          "花都区",
          "南沙区",
          "萝岗区",
          "增城市",
          "从化市",
          "其他"
        ]
      },
      {
        "name": "深圳",
        "area": [
          "福田区",
          "罗湖区",
          "南山区",
          "宝安区",
          "龙岗区",
          "盐田区",
          "其他"
        ]
      },
      {
        "name": "东莞",
        "area": [
          "莞城",
          "常平",
          "塘厦",
          "塘厦",
          "塘厦",
          "其他"
        ]
      },
      {
        "name": "中山",
        "area": [
          "中山"
        ]
      },
      {
        "name": "潮州",
        "area": [
          "湘桥区",
          "潮安县",
          "饶平县",
          "其他"
        ]
      },
      {
        "name": "揭阳",
        "area": [
          "榕城区",
          "揭东县",
          "揭西县",
          "惠来县",
          "普宁市",
          "其他"
        ]
      },
      {
        "name": "云浮",
        "area": [
          "云城区",
          "新兴县",
          "郁南县",
          "云安县",
          "罗定市",
          "其他"
        ]
      },
      {
        "name": "珠海",
        "area": [
          "香洲区",
          "斗门区",
          "金湾区",
          "其他"
        ]
      },
      {
        "name": "汕头",
        "area": [
          "金平区",
          "濠江区",
          "龙湖区",
          "潮阳区",
          "潮南区",
          "澄海区",
          "南澳县",
          "其他"
        ]
      },
      {
        "name": "韶关",
        "area": [
          "浈江区",
          "武江区",
          "曲江区",
          "乐昌市",
          "南雄市",
          "始兴县",
          "仁化县",
          "翁源县",
          "新丰县",
          "乳源瑶族自治县",
          "其他"
        ]
      },
      {
        "name": "佛山",
        "area": [
          "禅城区",
          "南海区",
          "顺德区",
          "三水区",
          "高明区",
          "其他"
        ]
      },
      {
        "name": "江门",
        "area": [
          "蓬江区",
          "江海区",
          "新会区",
          "恩平市",
          "台山市",
          "开平市",
          "鹤山市",
          "其他"
        ]
      },
      {
        "name": "湛江",
        "area": [
          "赤坎区",
          "霞山区",
          "坡头区",
          "麻章区",
          "吴川市",
          "廉江市",
          "雷州市",
          "遂溪县",
          "徐闻县",
          "其他"
        ]
      },
      {
        "name": "茂名",
        "area": [
          "茂南区",
          "茂港区",
          "化州市",
          "信宜市",
          "高州市",
          "电白县",
          "其他"
        ]
      },
      {
        "name": "肇庆",
        "area": [
          "端州区",
          "鼎湖区",
          "高要市",
          "四会市",
          "广宁县",
          "怀集县",
          "封开县",
          "德庆县",
          "其他"
        ]
      },
      {
        "name": "惠州",
        "area": [
          "惠城区",
          "惠阳区",
          "博罗县",
          "惠东县",
          "龙门县",
          "其他"
        ]
      },
      {
        "name": "梅州",
        "area": [
          "梅江区",
          "兴宁市",
          "梅县",
          "大埔县",
          "丰顺县",
          "五华县",
          "平远县",
          "蕉岭县",
          "其他"
        ]
      },
      {
        "name": "汕尾",
        "area": [
          "城区",
          "陆丰市",
          "海丰县",
          "陆河县",
          "其他"
        ]
      },
      {
        "name": "河源",
        "area": [
          "源城区",
          "紫金县",
          "龙川县",
          "连平县",
          "和平县",
          "东源县",
          "其他"
        ]
      },
      {
        "name": "阳江",
        "area": [
          "江城区",
          "阳春市",
          "阳西县",
          "阳东县",
          "其他"
        ]
      },
      {
        "name": "清远",
        "area": [
          "清城区",
          "英德市",
          "连州市",
          "佛冈县",
          "阳山县",
          "清新县",
          "连山壮族瑶族自治县",
          "连南瑶族自治县",
          "其他"
        ]
      }
    ]
  },
  {
    "name": "广西省",
    "city": [
      {
        "name": "南宁",
        "area": [
          "青秀区",
          "兴宁区",
          "西乡塘区",
          "良庆区",
          "江南区",
          "邕宁区",
          "武鸣县",
          "隆安县",
          "马山县",
          "上林县",
          "宾阳县",
          "横县",
          "其他"
        ]
      },
      {
        "name": "柳州",
        "area": [
          "城中区",
          "鱼峰区",
          "柳北区",
          "柳南区",
          "柳江县",
          "柳城县",
          "鹿寨县",
          "融安县",
          "融水苗族自治县",
          "三江侗族自治县",
          "其他"
        ]
      },
      {
        "name": "桂林",
        "area": [
          "象山区",
          "秀峰区",
          "叠彩区",
          "七星区",
          "雁山区",
          "阳朔县",
          "临桂县",
          "灵川县",
          "全州县",
          "平乐县",
          "兴安县",
          "灌阳县",
          "荔浦县",
          "资源县",
          "永福县",
          "龙胜各族自治县",
          "恭城瑶族自治县",
          "其他"
        ]
      },
      {
        "name": "梧州",
        "area": [
          "万秀区",
          "蝶山区",
          "长洲区",
          "岑溪市",
          "苍梧县",
          "藤县",
          "蒙山县",
          "其他"
        ]
      },
      {
        "name": "北海",
        "area": [
          "海城区",
          "银海区",
          "铁山港区",
          "合浦县",
          "其他"
        ]
      },
      {
        "name": "防城港",
        "area": [
          "港口区",
          "防城区",
          "东兴市",
          "上思县",
          "其他"
        ]
      },
      {
        "name": "钦州",
        "area": [
          "钦南区",
          "钦北区",
          "灵山县",
          "浦北县",
          "其他"
        ]
      },
      {
        "name": "贵港",
        "area": [
          "港北区",
          "港南区",
          "覃塘区",
          "桂平市",
          "平南县",
          "其他"
        ]
      },
      {
        "name": "玉林",
        "area": [
          "玉州区",
          "北流市",
          "容县",
          "陆川县",
          "博白县",
          "兴业县",
          "其他"
        ]
      },
      {
        "name": "百色",
        "area": [
          "右江区",
          "凌云县",
          "平果县",
          "西林县",
          "乐业县",
          "德保县",
          "田林县",
          "田阳县",
          "靖西县",
          "田东县",
          "那坡县",
          "隆林各族自治县",
          "其他"
        ]
      },
      {
        "name": "贺州",
        "area": [
          "八步区",
          "钟山县",
          "昭平县",
          "富川瑶族自治县",
          "其他"
        ]
      },
      {
        "name": "河池",
        "area": [
          "金城江区",
          "宜州市",
          "天峨县",
          "凤山县",
          "南丹县",
          "东兰县",
          "都安瑶族自治县",
          "罗城仫佬族自治县",
          "巴马瑶族自治县",
          "环江毛南族自治县",
          "大化瑶族自治县",
          "其他"
        ]
      },
      {
        "name": "来宾",
        "area": [
          "兴宾区",
          "合山市",
          "象州县",
          "武宣县",
          "忻城县",
          "金秀瑶族自治县",
          "其他"
        ]
      },
      {
        "name": "崇左",
        "area": [
          "江州区",
          "凭祥市",
          "宁明县",
          "扶绥县",
          "龙州县",
          "大新县",
          "天等县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "海南省",
    "city": [
      {
        "name": "海口",
        "area": [
          "龙华区",
          "秀英区",
          "琼山区",
          "美兰区",
          "其他"
        ]
      },
      {
        "name": "三亚",
        "area": [
          "三亚市",
          "其他"
        ]
      },
      {
        "name": "五指山",
        "area": [
          "五指山"
        ]
      },
      {
        "name": "琼海",
        "area": [
          "琼海"
        ]
      },
      {
        "name": "儋州",
        "area": [
          "儋州"
        ]
      },
      {
        "name": "文昌",
        "area": [
          "文昌"
        ]
      },
      {
        "name": "万宁",
        "area": [
          "万宁"
        ]
      },
      {
        "name": "东方",
        "area": [
          "东方"
        ]
      },
      {
        "name": "澄迈县",
        "area": [
          "澄迈县"
        ]
      },
      {
        "name": "定安县",
        "area": [
          "定安县"
        ]
      },
      {
        "name": "屯昌县",
        "area": [
          "屯昌县"
        ]
      },
      {
        "name": "临高县",
        "area": [
          "临高县"
        ]
      },
      {
        "name": "白沙黎族自治县",
        "area": [
          "白沙黎族自治县"
        ]
      },
      {
        "name": "昌江黎族自治县",
        "area": [
          "昌江黎族自治县"
        ]
      },
      {
        "name": "乐东黎族自治县",
        "area": [
          "乐东黎族自治县"
        ]
      },
      {
        "name": "陵水黎族自治县",
        "area": [
          "陵水黎族自治县"
        ]
      },
      {
        "name": "保亭黎族苗族自治县",
        "area": [
          "保亭黎族苗族自治县"
        ]
      },
      {
        "name": "琼中黎族苗族自治县",
        "area": [
          "琼中黎族苗族自治县"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "重庆市",
    "city": [
      {
        "name": "重庆",
        "area": [
          "渝中区",
          "大渡口区",
          "江北区",
          "南岸区",
          "北碚区",
          "渝北区",
          "巴南区",
          "长寿区",
          "双桥区",
          "沙坪坝区",
          "万盛区",
          "万州区",
          "涪陵区",
          "黔江区",
          "永川区",
          "合川区",
          "江津区",
          "九龙坡区",
          "南川区",
          "綦江县",
          "潼南县",
          "荣昌县",
          "璧山县",
          "大足县",
          "铜梁县",
          "梁平县",
          "开县",
          "忠县",
          "城口县",
          "垫江县",
          "武隆县",
          "丰都县",
          "奉节县",
          "云阳县",
          "巫溪县",
          "巫山县",
          "石柱土家族自治县",
          "秀山土家族苗族自治县",
          "酉阳土家族苗族自治县",
          "彭水苗族土家族自治县",
          "其他"
        ]
      }
    ]
  },
  {
    "name": "四川省",
    "city": [
      {
        "name": "成都",
        "area": [
          "青羊区",
          "锦江区",
          "金牛区",
          "武侯区",
          "成华区",
          "龙泉驿区",
          "青白江区",
          "新都区",
          "温江区",
          "都江堰市",
          "彭州市",
          "邛崃市",
          "崇州市",
          "金堂县",
          "郫县",
          "新津县",
          "双流县",
          "蒲江县",
          "大邑县",
          "其他"
        ]
      },
      {
        "name": "自贡",
        "area": [
          "大安区",
          "自流井区",
          "贡井区",
          "沿滩区",
          "荣县",
          "富顺县",
          "其他"
        ]
      },
      {
        "name": "攀枝花",
        "area": [
          "仁和区",
          "米易县",
          "盐边县",
          "东区",
          "西区",
          "其他"
        ]
      },
      {
        "name": "泸州",
        "area": [
          "江阳区",
          "纳溪区",
          "龙马潭区",
          "泸县",
          "合江县",
          "叙永县",
          "古蔺县",
          "其他"
        ]
      },
      {
        "name": "德阳",
        "area": [
          "旌阳区",
          "广汉市",
          "什邡市",
          "绵竹市",
          "罗江县",
          "中江县",
          "其他"
        ]
      },
      {
        "name": "绵阳",
        "area": [
          "涪城区",
          "游仙区",
          "江油市",
          "盐亭县",
          "三台县",
          "平武县",
          "安县",
          "梓潼县",
          "北川羌族自治县",
          "其他"
        ]
      },
      {
        "name": "广元",
        "area": [
          "元坝区",
          "朝天区",
          "青川县",
          "旺苍县",
          "剑阁县",
          "苍溪县",
          "市中区",
          "其他"
        ]
      },
      {
        "name": "遂宁",
        "area": [
          "船山区",
          "安居区",
          "射洪县",
          "蓬溪县",
          "大英县",
          "其他"
        ]
      },
      {
        "name": "内江",
        "area": [
          "市中区",
          "东兴区",
          "资中县",
          "隆昌县",
          "威远县",
          "其他"
        ]
      },
      {
        "name": "乐山",
        "area": [
          "市中区",
          "五通桥区",
          "沙湾区",
          "金口河区",
          "峨眉山市",
          "夹江县",
          "井研县",
          "犍为县",
          "沐川县",
          "马边彝族自治县",
          "峨边彝族自治县",
          "其他"
        ]
      },
      {
        "name": "南充",
        "area": [
          "顺庆区",
          "高坪区",
          "嘉陵区",
          "阆中市",
          "营山县",
          "蓬安县",
          "仪陇县",
          "南部县",
          "西充县",
          "其他"
        ]
      },
      {
        "name": "眉山",
        "area": [
          "东坡区",
          "仁寿县",
          "彭山县",
          "洪雅县",
          "丹棱县",
          "青神县",
          "其他"
        ]
      },
      {
        "name": "宜宾",
        "area": [
          "翠屏区",
          "宜宾县",
          "兴文县",
          "南溪县",
          "珙县",
          "长宁县",
          "高县",
          "江安县",
          "筠连县",
          "屏山县",
          "其他"
        ]
      },
      {
        "name": "广安",
        "area": [
          "广安区",
          "华蓥市",
          "岳池县",
          "邻水县",
          "武胜县",
          "其他"
        ]
      },
      {
        "name": "达州",
        "area": [
          "通川区",
          "万源市",
          "达县",
          "渠县",
          "宣汉县",
          "开江县",
          "大竹县",
          "其他"
        ]
      },
      {
        "name": "雅安",
        "area": [
          "雨城区",
          "芦山县",
          "石棉县",
          "名山县",
          "天全县",
          "荥经县",
          "宝兴县",
          "汉源县",
          "其他"
        ]
      },
      {
        "name": "巴中",
        "area": [
          "巴州区",
          "南江县",
          "平昌县",
          "通江县",
          "其他"
        ]
      },
      {
        "name": "资阳",
        "area": [
          "雁江区",
          "简阳市",
          "安岳县",
          "乐至县",
          "其他"
        ]
      },
      {
        "name": "阿坝藏族羌族自治州",
        "area": [
          "马尔康县",
          "九寨沟县",
          "红原县",
          "汶川县",
          "阿坝县",
          "理县",
          "若尔盖县",
          "小金县",
          "黑水县",
          "金川县",
          "松潘县",
          "壤塘县",
          "茂县",
          "其他"
        ]
      },
      {
        "name": "甘孜藏族自治州",
        "area": [
          "康定县",
          "丹巴县",
          "炉霍县",
          "九龙县",
          "甘孜县",
          "雅江县",
          "新龙县",
          "道孚县",
          "白玉县",
          "理塘县",
          "德格县",
          "乡城县",
          "石渠县",
          "稻城县",
          "色达县",
          "巴塘县",
          "泸定县",
          "得荣县",
          "其他"
        ]
      },
      {
        "name": "凉山彝族自治州",
        "area": [
          "西昌市",
          "美姑县",
          "昭觉县",
          "金阳县",
          "甘洛县",
          "布拖县",
          "雷波县",
          "普格县",
          "宁南县",
          "喜德县",
          "会东县",
          "越西县",
          "会理县",
          "盐源县",
          "德昌县",
          "冕宁县",
          "木里藏族自治县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "贵州省",
    "city": [
      {
        "name": "贵阳",
        "area": [
          "南明区",
          "云岩区",
          "花溪区",
          "乌当区",
          "白云区",
          "小河区",
          "清镇市",
          "开阳县",
          "修文县",
          "息烽县",
          "其他"
        ]
      },
      {
        "name": "六盘水",
        "area": [
          "钟山区",
          "水城县",
          "盘县",
          "六枝特区",
          "其他"
        ]
      },
      {
        "name": "遵义",
        "area": [
          "红花岗区",
          "汇川区",
          "赤水市",
          "仁怀市",
          "遵义县",
          "绥阳县",
          "桐梓县",
          "习水县",
          "凤冈县",
          "正安县",
          "余庆县",
          "湄潭县",
          "道真仡佬族苗族自治县",
          "务川仡佬族苗族自治县",
          "其他"
        ]
      },
      {
        "name": "安顺",
        "area": [
          "西秀区",
          "普定县",
          "平坝县",
          "镇宁布依族苗族自治县",
          "紫云苗族布依族自治县",
          "关岭布依族苗族自治县",
          "其他"
        ]
      },
      {
        "name": "铜仁地区",
        "area": [
          "铜仁市",
          "德江县",
          "江口县",
          "思南县",
          "石阡县",
          "玉屏侗族自治县",
          "松桃苗族自治县",
          "印江土家族苗族自治县",
          "沿河土家族自治县",
          "万山特区",
          "其他"
        ]
      },
      {
        "name": "毕节地区",
        "area": [
          "毕节市",
          "黔西县",
          "大方县",
          "织金县",
          "金沙县",
          "赫章县",
          "纳雍县",
          "威宁彝族回族苗族自治县",
          "其他"
        ]
      },
      {
        "name": "黔西南布依族苗族自治州",
        "area": [
          "兴义市",
          "望谟县",
          "兴仁县",
          "普安县",
          "册亨县",
          "晴隆县",
          "贞丰县",
          "安龙县",
          "其他"
        ]
      },
      {
        "name": "黔东南苗族侗族自治州",
        "area": [
          "凯里市",
          "施秉县",
          "从江县",
          "锦屏县",
          "镇远县",
          "麻江县",
          "台江县",
          "天柱县",
          "黄平县",
          "榕江县",
          "剑河县",
          "三穗县",
          "雷山县",
          "黎平县",
          "岑巩县",
          "丹寨县",
          "其他"
        ]
      },
      {
        "name": "黔南布依族苗族自治州",
        "area": [
          "都匀市",
          "福泉市",
          "贵定县",
          "惠水县",
          "罗甸县",
          "瓮安县",
          "荔波县",
          "龙里县",
          "平塘县",
          "长顺县",
          "独山县",
          "三都水族自治县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "云南省",
    "city": [
      {
        "name": "昆明",
        "area": [
          "盘龙区",
          "五华区",
          "官渡区",
          "西山区",
          "东川区",
          "安宁市",
          "呈贡县",
          "晋宁县",
          "富民县",
          "宜良县",
          "嵩明县",
          "石林彝族自治县",
          "禄劝彝族苗族自治县",
          "寻甸回族彝族自治县",
          "其他"
        ]
      },
      {
        "name": "曲靖",
        "area": [
          "麒麟区",
          "宣威市",
          "马龙县",
          "沾益县",
          "富源县",
          "罗平县",
          "师宗县",
          "陆良县",
          "会泽县",
          "其他"
        ]
      },
      {
        "name": "玉溪",
        "area": [
          "红塔区",
          "江川县",
          "澄江县",
          "通海县",
          "华宁县",
          "易门县",
          "峨山彝族自治县",
          "新平彝族傣族自治县",
          "元江哈尼族彝族傣族自治县",
          "其他"
        ]
      },
      {
        "name": "保山",
        "area": [
          "隆阳区",
          "施甸县",
          "腾冲县",
          "龙陵县",
          "昌宁县",
          "其他"
        ]
      },
      {
        "name": "昭通",
        "area": [
          "昭阳区",
          "鲁甸县",
          "巧家县",
          "盐津县",
          "大关县",
          "永善县",
          "绥江县",
          "镇雄县",
          "彝良县",
          "威信县",
          "水富县",
          "其他"
        ]
      },
      {
        "name": "丽江",
        "area": [
          "古城区",
          "永胜县",
          "华坪县",
          "玉龙纳西族自治县",
          "宁蒗彝族自治县",
          "其他"
        ]
      },
      {
        "name": "普洱",
        "area": [
          "思茅区",
          "普洱哈尼族彝族自治县",
          "墨江哈尼族自治县",
          "景东彝族自治县",
          "景谷傣族彝族自治县",
          "镇沅彝族哈尼族拉祜族自治县",
          "江城哈尼族彝族自治县",
          "孟连傣族拉祜族佤族自治县",
          "澜沧拉祜族自治县",
          "西盟佤族自治县",
          "其他"
        ]
      },
      {
        "name": "临沧",
        "area": [
          "临翔区",
          "凤庆县",
          "云县",
          "永德县",
          "镇康县",
          "双江拉祜族佤族布朗族傣族自治县",
          "耿马傣族佤族自治县",
          "沧源佤族自治县",
          "其他"
        ]
      },
      {
        "name": "德宏傣族景颇族自治州",
        "area": [
          "潞西市",
          "瑞丽市",
          "梁河县",
          "盈江县",
          "陇川县",
          "其他"
        ]
      },
      {
        "name": "怒江傈僳族自治州",
        "area": [
          "泸水县",
          "福贡县",
          "贡山独龙族怒族自治县",
          "兰坪白族普米族自治县",
          "其他"
        ]
      },
      {
        "name": "迪庆藏族自治州",
        "area": [
          "香格里拉县",
          "德钦县",
          "维西傈僳族自治县",
          "其他"
        ]
      },
      {
        "name": "大理白族自治州",
        "area": [
          "大理市",
          "祥云县",
          "宾川县",
          "弥渡县",
          "永平县",
          "云龙县",
          "洱源县",
          "剑川县",
          "鹤庆县",
          "漾濞彝族自治县",
          "南涧彝族自治县",
          "巍山彝族回族自治县",
          "其他"
        ]
      },
      {
        "name": "楚雄彝族自治州",
        "area": [
          "楚雄市",
          "双柏县",
          "牟定县",
          "南华县",
          "姚安县",
          "大姚县",
          "永仁县",
          "元谋县",
          "武定县",
          "禄丰县",
          "其他"
        ]
      },
      {
        "name": "红河哈尼族彝族自治州",
        "area": [
          "蒙自县",
          "个旧市",
          "开远市",
          "绿春县",
          "建水县",
          "石屏县",
          "弥勒县",
          "泸西县",
          "元阳县",
          "红河县",
          "金平苗族瑶族傣族自治县",
          "河口瑶族自治县",
          "屏边苗族自治县",
          "其他"
        ]
      },
      {
        "name": "文山壮族苗族自治州",
        "area": [
          "文山县",
          "砚山县",
          "西畴县",
          "麻栗坡县",
          "马关县",
          "丘北县",
          "广南县",
          "富宁县",
          "其他"
        ]
      },
      {
        "name": "西双版纳傣族自治州",
        "area": [
          "景洪市",
          "勐海县",
          "勐腊县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "西藏自治区",
    "city": [
      {
        "name": "拉萨",
        "area": [
          "城关区",
          "林周县",
          "当雄县",
          "尼木县",
          "曲水县",
          "堆龙德庆县",
          "达孜县",
          "墨竹工卡县",
          "其他"
        ]
      },
      {
        "name": "那曲地区",
        "area": [
          "那曲县",
          "嘉黎县",
          "比如县",
          "聂荣县",
          "安多县",
          "申扎县",
          "索县",
          "班戈县",
          "巴青县",
          "尼玛县",
          "其他"
        ]
      },
      {
        "name": "昌都地区",
        "area": [
          "昌都县",
          "江达县",
          "贡觉县",
          "类乌齐县",
          "丁青县",
          "察雅县",
          "八宿县",
          "左贡县",
          "芒康县",
          "洛隆县",
          "边坝县",
          "其他"
        ]
      },
      {
        "name": "林芝地区",
        "area": [
          "林芝县",
          "工布江达县",
          "米林县",
          "墨脱县",
          "波密县",
          "察隅县",
          "朗县",
          "其他"
        ]
      },
      {
        "name": "山南地区",
        "area": [
          "乃东县",
          "扎囊县",
          "贡嘎县",
          "桑日县",
          "琼结县",
          "曲松县",
          "措美县",
          "洛扎县",
          "加查县",
          "隆子县",
          "错那县",
          "浪卡子县",
          "其他"
        ]
      },
      {
        "name": "日喀则地区",
        "area": [
          "日喀则市",
          "南木林县",
          "江孜县",
          "定日县",
          "萨迦县",
          "拉孜县",
          "昂仁县",
          "谢通门县",
          "白朗县",
          "仁布县",
          "康马县",
          "定结县",
          "仲巴县",
          "亚东县",
          "吉隆县",
          "聂拉木县",
          "萨嘎县",
          "岗巴县",
          "其他"
        ]
      },
      {
        "name": "阿里地区",
        "area": [
          "噶尔县",
          "普兰县",
          "札达县",
          "日土县",
          "革吉县",
          "改则县",
          "措勤县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "陕西省",
    "city": [
      {
        "name": "西安",
        "area": [
          "莲湖区",
          "新城区",
          "碑林区",
          "雁塔区",
          "灞桥区",
          "未央区",
          "阎良区",
          "临潼区",
          "长安区",
          "高陵县",
          "蓝田县",
          "户县",
          "周至县",
          "其他"
        ]
      },
      {
        "name": "铜川",
        "area": [
          "耀州区",
          "王益区",
          "印台区",
          "宜君县",
          "其他"
        ]
      },
      {
        "name": "宝鸡",
        "area": [
          "渭滨区",
          "金台区",
          "陈仓区",
          "岐山县",
          "凤翔县",
          "陇县",
          "太白县",
          "麟游县",
          "扶风县",
          "千阳县",
          "眉县",
          "凤县",
          "其他"
        ]
      },
      {
        "name": "咸阳",
        "area": [
          "秦都区",
          "渭城区",
          "杨陵区",
          "兴平市",
          "礼泉县",
          "泾阳县",
          "永寿县",
          "三原县",
          "彬县",
          "旬邑县",
          "长武县",
          "乾县",
          "武功县",
          "淳化县",
          "其他"
        ]
      },
      {
        "name": "渭南",
        "area": [
          "临渭区",
          "韩城市",
          "华阴市",
          "蒲城县",
          "潼关县",
          "白水县",
          "澄城县",
          "华县",
          "合阳县",
          "富平县",
          "大荔县",
          "其他"
        ]
      },
      {
        "name": "延安",
        "area": [
          "宝塔区",
          "安塞县",
          "洛川县",
          "子长县",
          "黄陵县",
          "延川县",
          "富县",
          "延长县",
          "甘泉县",
          "宜川县",
          "志丹县",
          "黄龙县",
          "吴起县",
          "其他"
        ]
      },
      {
        "name": "汉中",
        "area": [
          "汉台区",
          "留坝县",
          "镇巴县",
          "城固县",
          "南郑县",
          "洋县",
          "宁强县",
          "佛坪县",
          "勉县",
          "西乡县",
          "略阳县",
          "其他"
        ]
      },
      {
        "name": "榆林",
        "area": [
          "榆阳区",
          "清涧县",
          "绥德县",
          "神木县",
          "佳县",
          "府谷县",
          "子洲县",
          "靖边县",
          "横山县",
          "米脂县",
          "吴堡县",
          "定边县",
          "其他"
        ]
      },
      {
        "name": "安康",
        "area": [
          "汉滨区",
          "紫阳县",
          "岚皋县",
          "旬阳县",
          "镇坪县",
          "平利县",
          "石泉县",
          "宁陕县",
          "白河县",
          "汉阴县",
          "其他"
        ]
      },
      {
        "name": "商洛",
        "area": [
          "商州区",
          "镇安县",
          "山阳县",
          "洛南县",
          "商南县",
          "丹凤县",
          "柞水县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "甘肃省",
    "city": [
      {
        "name": "兰州",
        "area": [
          "城关区",
          "七里河区",
          "西固区",
          "安宁区",
          "红古区",
          "永登县",
          "皋兰县",
          "榆中县",
          "其他"
        ]
      },
      {
        "name": "嘉峪关",
        "area": [
          "嘉峪关市",
          "其他"
        ]
      },
      {
        "name": "金昌",
        "area": [
          "金川区",
          "永昌县",
          "其他"
        ]
      },
      {
        "name": "白银",
        "area": [
          "白银区",
          "平川区",
          "靖远县",
          "会宁县",
          "景泰县",
          "其他"
        ]
      },
      {
        "name": "天水",
        "area": [
          "清水县",
          "秦安县",
          "甘谷县",
          "武山县",
          "张家川回族自治县",
          "北道区",
          "秦城区",
          "其他"
        ]
      },
      {
        "name": "武威",
        "area": [
          "凉州区",
          "民勤县",
          "古浪县",
          "天祝藏族自治县",
          "其他"
        ]
      },
      {
        "name": "酒泉",
        "area": [
          "肃州区",
          "玉门市",
          "敦煌市",
          "金塔县",
          "肃北蒙古族自治县",
          "阿克塞哈萨克族自治县",
          "安西县",
          "其他"
        ]
      },
      {
        "name": "张掖",
        "area": [
          "甘州区",
          "民乐县",
          "临泽县",
          "高台县",
          "山丹县",
          "肃南裕固族自治县",
          "其他"
        ]
      },
      {
        "name": "庆阳",
        "area": [
          "西峰区",
          "庆城县",
          "环县",
          "华池县",
          "合水县",
          "正宁县",
          "宁县",
          "镇原县",
          "其他"
        ]
      },
      {
        "name": "平凉",
        "area": [
          "崆峒区",
          "泾川县",
          "灵台县",
          "崇信县",
          "华亭县",
          "庄浪县",
          "静宁县",
          "其他"
        ]
      },
      {
        "name": "定西",
        "area": [
          "安定区",
          "通渭县",
          "临洮县",
          "漳县",
          "岷县",
          "渭源县",
          "陇西县",
          "其他"
        ]
      },
      {
        "name": "陇南",
        "area": [
          "武都区",
          "成县",
          "宕昌县",
          "康县",
          "文县",
          "西和县",
          "礼县",
          "两当县",
          "徽县",
          "其他"
        ]
      },
      {
        "name": "临夏回族自治州",
        "area": [
          "临夏市",
          "临夏县",
          "康乐县",
          "永靖县",
          "广河县",
          "和政县",
          "东乡族自治县",
          "积石山保安族东乡族撒拉族自治县",
          "其他"
        ]
      },
      {
        "name": "甘南藏族自治州",
        "area": [
          "合作市",
          "临潭县",
          "卓尼县",
          "舟曲县",
          "迭部县",
          "玛曲县",
          "碌曲县",
          "夏河县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "青海省",
    "city": [
      {
        "name": "西宁",
        "area": [
          "城中区",
          "城东区",
          "城西区",
          "城北区",
          "湟源县",
          "湟中县",
          "大通回族土族自治县",
          "其他"
        ]
      },
      {
        "name": "海东地区",
        "area": [
          "平安县",
          "乐都县",
          "民和回族土族自治县",
          "互助土族自治县",
          "化隆回族自治县",
          "循化撒拉族自治县",
          "其他"
        ]
      },
      {
        "name": "海北藏族自治州",
        "area": [
          "海晏县",
          "祁连县",
          "刚察县",
          "门源回族自治县",
          "其他"
        ]
      },
      {
        "name": "海南藏族自治州",
        "area": [
          "共和县",
          "同德县",
          "贵德县",
          "兴海县",
          "贵南县",
          "其他"
        ]
      },
      {
        "name": "黄南藏族自治州",
        "area": [
          "同仁县",
          "尖扎县",
          "泽库县",
          "河南蒙古族自治县",
          "其他"
        ]
      },
      {
        "name": "果洛藏族自治州",
        "area": [
          "玛沁县",
          "班玛县",
          "甘德县",
          "达日县",
          "久治县",
          "玛多县",
          "其他"
        ]
      },
      {
        "name": "玉树藏族自治州",
        "area": [
          "玉树县",
          "杂多县",
          "称多县",
          "治多县",
          "囊谦县",
          "曲麻莱县",
          "其他"
        ]
      },
      {
        "name": "海西蒙古族藏族自治州",
        "area": [
          "德令哈市",
          "格尔木市",
          "乌兰县",
          "都兰县",
          "天峻县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "宁夏回族自治区",
    "city": [
      {
        "name": "银川",
        "area": [
          "兴庆区",
          "西夏区",
          "金凤区",
          "灵武市",
          "永宁县",
          "贺兰县",
          "其他"
        ]
      },
      {
        "name": "石嘴山",
        "area": [
          "大武口区",
          "惠农区",
          "平罗县",
          "其他"
        ]
      },
      {
        "name": "吴忠",
        "area": [
          "利通区",
          "青铜峡市",
          "盐池县",
          "同心县",
          "其他"
        ]
      },
      {
        "name": "固原",
        "area": [
          "原州区",
          "西吉县",
          "隆德县",
          "泾源县",
          "彭阳县",
          "其他"
        ]
      },
      {
        "name": "中卫",
        "area": [
          "沙坡头区",
          "中宁县",
          "海原县",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "新疆维吾尔自治区",
    "city": [
      {
        "name": "乌鲁木齐",
        "area": [
          "天山区",
          "沙依巴克区",
          "新市区",
          "水磨沟区",
          "头屯河区",
          "达坂城区",
          "东山区",
          "乌鲁木齐县",
          "其他"
        ]
      },
      {
        "name": "克拉玛依",
        "area": [
          "克拉玛依区",
          "独山子区",
          "白碱滩区",
          "乌尔禾区",
          "其他"
        ]
      },
      {
        "name": "吐鲁番地区",
        "area": [
          "吐鲁番市",
          "托克逊县",
          "鄯善县",
          "其他"
        ]
      },
      {
        "name": "哈密地区",
        "area": [
          "哈密市",
          "伊吾县",
          "巴里坤哈萨克自治县",
          "其他"
        ]
      },
      {
        "name": "和田地区",
        "area": [
          "和田市",
          "和田县",
          "洛浦县",
          "民丰县",
          "皮山县",
          "策勒县",
          "于田县",
          "墨玉县",
          "其他"
        ]
      },
      {
        "name": "阿克苏地区",
        "area": [
          "阿克苏市",
          "温宿县",
          "沙雅县",
          "拜城县",
          "阿瓦提县",
          "库车县",
          "柯坪县",
          "新和县",
          "乌什县",
          "其他"
        ]
      },
      {
        "name": "喀什地区",
        "area": [
          "喀什市",
          "巴楚县",
          "泽普县",
          "伽师县",
          "叶城县",
          "岳普湖县",
          "疏勒县",
          "麦盖提县",
          "英吉沙县",
          "莎车县",
          "疏附县",
          "塔什库尔干塔吉克自治县",
          "其他"
        ]
      },
      {
        "name": "克孜勒苏柯尔克孜自治州",
        "area": [
          "阿图什市",
          "阿合奇县",
          "乌恰县",
          "阿克陶县",
          "其他"
        ]
      },
      {
        "name": "巴音郭楞蒙古自治州",
        "area": [
          "库尔勒市",
          "和静县",
          "尉犁县",
          "和硕县",
          "且末县",
          "博湖县",
          "轮台县",
          "若羌县",
          "焉耆回族自治县",
          "其他"
        ]
      },
      {
        "name": "昌吉回族自治州",
        "area": [
          "昌吉市",
          "阜康市",
          "奇台县",
          "玛纳斯县",
          "吉木萨尔县",
          "呼图壁县",
          "木垒哈萨克自治县",
          "米泉市",
          "其他"
        ]
      },
      {
        "name": "博尔塔拉蒙古自治州",
        "area": [
          "博乐市",
          "精河县",
          "温泉县",
          "其他"
        ]
      },
      {
        "name": "石河子",
        "area": [
          "石河子"
        ]
      },
      {
        "name": "阿拉尔",
        "area": [
          "阿拉尔"
        ]
      },
      {
        "name": "图木舒克",
        "area": [
          "图木舒克"
        ]
      },
      {
        "name": "五家渠",
        "area": [
          "五家渠"
        ]
      },
      {
        "name": "伊犁哈萨克自治州",
        "area": [
          "伊宁市",
          "奎屯市",
          "伊宁县",
          "特克斯县",
          "尼勒克县",
          "昭苏县",
          "新源县",
          "霍城县",
          "巩留县",
          "察布查尔锡伯自治县",
          "塔城地区",
          "阿勒泰地区",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "台湾省",
    "city": [
      {
        "name": "台湾",
        "area": [
          "台北市",
          "高雄市",
          "台北县",
          "桃园县",
          "新竹县",
          "苗栗县",
          "台中县",
          "彰化县",
          "南投县",
          "云林县",
          "嘉义县",
          "台南县",
          "高雄县",
          "屏东县",
          "宜兰县",
          "花莲县",
          "台东县",
          "澎湖县",
          "基隆市",
          "新竹市",
          "台中市",
          "嘉义市",
          "台南市",
          "其他"
        ]
      },
      {
        "name": "其他",
        "area": [
          "其他"
        ]
      }
    ]
  },
  {
    "name": "澳门特别行政区",
    "city": [
      {
        "name": "澳门",
        "area": [
          "花地玛堂区",
          "圣安多尼堂区",
          "大堂区",
          "望德堂区",
          "风顺堂区",
          "嘉模堂区",
          "圣方济各堂区",
          "路凼",
          "其他"
        ]
      }
    ]
  },
  {
    "name": "香港特别行政区",
    "city": [
      {
        "name": "香港",
        "area": [
          "中西区",
          "湾仔区",
          "东区",
          "南区",
          "深水埗区",
          "油尖旺区",
          "九龙城区",
          "黄大仙区",
          "观塘区",
          "北区",
          "大埔区",
          "沙田区",
          "西贡区",
          "元朗区",
          "屯门区",
          "荃湾区",
          "葵青区",
          "离岛区",
          "其他"
        ]
      }
    ]
  },
  {
    "name": "钓鱼岛",
    "city": [
      {
        "name": "钓鱼岛",
        "area": [
          "钓鱼岛"
        ]
      }
    ]
  }
]


const datas =  [
  {
    "value": "110000",
    "province": "北京市",
    "data": [
      {
        "value": "110100",
        "city": "北京市",
        "dataList": [
          {
            "value": "110101",
            "area": "东城区"
          },
          {
            "value": "110102",
            "area": "西城区"
          },
          {
            "value": "110105",
            "area": "朝阳区"
          },
          {
            "value": "110106",
            "area": "丰台区"
          },
          {
            "value": "110107",
            "area": "石景山区"
          },
          {
            "value": "110108",
            "area": "海淀区"
          },
          {
            "value": "110109",
            "area": "门头沟区"
          },
          {
            "value": "110111",
            "area": "房山区"
          },
          {
            "value": "110112",
            "area": "通州区"
          },
          {
            "value": "110113",
            "area": "顺义区"
          },
          {
            "value": "110114",
            "area": "昌平区"
          },
          {
            "value": "110115",
            "area": "大兴区"
          },
          {
            "value": "110116",
            "area": "怀柔区"
          },
          {
            "value": "110117",
            "area": "平谷区"
          },
          {
            "value": "110228",
            "area": "密云区"
          },
          {
            "value": "110229",
            "area": "延庆区"
          }
        ]
      }
    ]
  },
    {
      "value": "120000",
      "province": "天津市",
      "data": [
        {
          "value": "120100",
          "city": "天津市",
          "dataList": [
            {
              "value": "120101",
              "area": "和平区"
            },
            {
              "value": "120102",
              "area": "河东区"
            },
            {
              "value": "120103",
              "area": "河西区"
            },
            {
              "value": "120104",
              "area": "南开区"
            },
            {
              "value": "120105",
              "area": "河北区"
            },
            {
              "value": "120106",
              "area": "红桥区"
            },
            {
              "value": "120110",
              "area": "东丽区"
            },
            {
              "value": "120111",
              "area": "西青区"
            },
            {
              "value": "120112",
              "area": "津南区"
            },
            {
              "value": "120113",
              "area": "北辰区"
            },
            {
              "value": "120114",
              "area": "武清区"
            },
            {
              "value": "120115",
              "area": "宝坻区"
            },
            {
              "value": "120116",
              "area": "滨海新区"
            },
            {
              "value": "120221",
              "area": "宁河区"
            },
            {
              "value": "120223",
              "area": "静海区"
            },
            {
              "value": "120225",
              "area": "蓟州区"
            }
          ]
        }
      ]
    },
    {
      "value": "130000",
      "province": "河北省",
      "data": [
        {
          "value": "130100",
          "city": "石家庄市",
          "dataList": [
            {
              "value": "130102",
              "area": "长安区"
            },
            {
              "value": "130104",
              "area": "桥西区"
            },
            {
              "value": "130105",
              "area": "新华区"
            },
            {
              "value": "130107",
              "area": "井陉矿区"
            },
            {
              "value": "130108",
              "area": "裕华区"
            },
            {
              "value": "130109",
              "area": "藁城区"
            },
            {
              "value": "130110",
              "area": "鹿泉区"
            },
            {
              "value": "130111",
              "area": "栾城区"
            },
            {
              "value": "130121",
              "area": "井陉县"
            },
            {
              "value": "130123",
              "area": "正定县"
            },
            {
              "value": "130125",
              "area": "行唐县"
            },
            {
              "value": "130126",
              "area": "灵寿县"
            },
            {
              "value": "130127",
              "area": "高邑县"
            },
            {
              "value": "130128",
              "area": "深泽县"
            },
            {
              "value": "130129",
              "area": "赞皇县"
            },
            {
              "value": "130130",
              "area": "无极县"
            },
            {
              "value": "130131",
              "area": "平山县"
            },
            {
              "value": "130132",
              "area": "元氏县"
            },
            {
              "value": "130133",
              "area": "赵　县"
            },
            {
              "value": "130181",
              "area": "辛集市"
            },
            {
              "value": "130182",
              "area": "藁城市"
            },
            {
              "value": "130183",
              "area": "晋州市"
            },
            {
              "value": "130184",
              "area": "新乐市"
            }
          ]
        },
        {
          "value": "130200",
          "city": "唐山市",
          "dataList": [
            {
              "value": "130202",
              "area": "路南区"
            },
            {
              "value": "130203",
              "area": "路北区"
            },
            {
              "value": "130204",
              "area": "古冶区"
            },
            {
              "value": "130205",
              "area": "开平区"
            },
            {
              "value": "130207",
              "area": "丰南区"
            },
            {
              "value": "130208",
              "area": "丰润区"
            },
            {
              "value": "130209",
              "area": "曹妃甸区"
            },
            {
              "value": "130223",
              "area": "滦　县"
            },
            {
              "value": "130224",
              "area": "滦南县"
            },
            {
              "value": "130225",
              "area": "乐亭县"
            },
            {
              "value": "130227",
              "area": "迁西县"
            },
            {
              "value": "130229",
              "area": "玉田县"
            },
            {
              "value": "130281",
              "area": "遵化市"
            },
            {
              "value": "130283",
              "area": "迁安市"
            }
          ]
        },
        {
          "value": "130300",
          "city": "秦皇岛市",
          "dataList": [
            {
              "value": "130302",
              "area": "海港区"
            },
            {
              "value": "130303",
              "area": "山海关区"
            },
            {
              "value": "130304",
              "area": "北戴河区"
            },
            {
              "value": "130306",
              "area": "抚宁区"
            },
            {
              "value": "130321",
              "area": "青龙满族自治县"
            },
            {
              "value": "130322",
              "area": "昌黎县"
            },
            {
              "value": "130324",
              "area": "卢龙县"
            }
          ]
        },
        {
          "value": "130400",
          "city": "邯郸市",
          "dataList": [
            {
              "value": "130402",
              "area": "邯山区"
            },
            {
              "value": "130403",
              "area": "丛台区"
            },
            {
              "value": "130404",
              "area": "复兴区"
            },
            {
              "value": "130406",
              "area": "峰峰矿区"
            },
            {
              "value": "130421",
              "area": "邯郸县"
            },
            {
              "value": "130423",
              "area": "临漳县"
            },
            {
              "value": "130424",
              "area": "成安县"
            },
            {
              "value": "130425",
              "area": "大名县"
            },
            {
              "value": "130426",
              "area": "涉　县"
            },
            {
              "value": "130427",
              "area": "磁　县"
            },
            {
              "value": "130428",
              "area": "肥乡县"
            },
            {
              "value": "130429",
              "area": "永年县"
            },
            {
              "value": "130430",
              "area": "邱　县"
            },
            {
              "value": "130431",
              "area": "鸡泽县"
            },
            {
              "value": "130432",
              "area": "广平县"
            },
            {
              "value": "130433",
              "area": "馆陶县"
            },
            {
              "value": "130434",
              "area": "魏　县"
            },
            {
              "value": "130435",
              "area": "曲周县"
            },
            {
              "value": "130481",
              "area": "武安市"
            }
          ]
        },
        {
          "value": "130500",
          "city": "邢台市",
          "dataList": [
            {
              "value": "130502",
              "area": "桥东区"
            },
            {
              "value": "130503",
              "area": "桥西区"
            },
            {
              "value": "130521",
              "area": "邢台县"
            },
            {
              "value": "130522",
              "area": "临城县"
            },
            {
              "value": "130523",
              "area": "内丘县"
            },
            {
              "value": "130524",
              "area": "柏乡县"
            },
            {
              "value": "130525",
              "area": "隆尧县"
            },
            {
              "value": "130526",
              "area": "任　县"
            },
            {
              "value": "130527",
              "area": "南和县"
            },
            {
              "value": "130528",
              "area": "宁晋县"
            },
            {
              "value": "130529",
              "area": "巨鹿县"
            },
            {
              "value": "130530",
              "area": "新河县"
            },
            {
              "value": "130531",
              "area": "广宗县"
            },
            {
              "value": "130532",
              "area": "平乡县"
            },
            {
              "value": "130533",
              "area": "威　县"
            },
            {
              "value": "130534",
              "area": "清河县"
            },
            {
              "value": "130535",
              "area": "临西县"
            },
            {
              "value": "130581",
              "area": "南宫市"
            },
            {
              "value": "130582",
              "area": "沙河市"
            }
          ]
        },
        {
          "value": "130600",
          "city": "保定市",
          "dataList": [
            {
              "value": "130602",
              "area": "竞秀区"
            },
            {
              "value": "130606",
              "area": "莲池区"
            },
            {
              "value": "130607",
              "area": "满城区"
            },
            {
              "value": "130608",
              "area": "清苑区"
            },
            {
              "value": "130609",
              "area": "徐水区"
            },
            {
              "value": "130623",
              "area": "涞水县"
            },
            {
              "value": "130624",
              "area": "阜平县"
            },
            {
              "value": "130626",
              "area": "定兴县"
            },
            {
              "value": "130627",
              "area": "唐　县"
            },
            {
              "value": "130628",
              "area": "高阳县"
            },
            {
              "value": "130629",
              "area": "容城县"
            },
            {
              "value": "130630",
              "area": "涞源县"
            },
            {
              "value": "130631",
              "area": "望都县"
            },
            {
              "value": "130632",
              "area": "安新县"
            },
            {
              "value": "130633",
              "area": "易　县"
            },
            {
              "value": "130634",
              "area": "曲阳县"
            },
            {
              "value": "130635",
              "area": "蠡　县"
            },
            {
              "value": "130636",
              "area": "顺平县"
            },
            {
              "value": "130637",
              "area": "博野县"
            },
            {
              "value": "130638",
              "area": "雄　县"
            },
            {
              "value": "130681",
              "area": "涿州市"
            },
            {
              "value": "130683",
              "area": "安国市"
            },
            {
              "value": "130684",
              "area": "高碑店市"
            }
          ]
        },
        {
          "value": "130700",
          "city": "张家口市",
          "dataList": [
            {
              "value": "130702",
              "area": "桥东区"
            },
            {
              "value": "130703",
              "area": "桥西区"
            },
            {
              "value": "130705",
              "area": "宣化区"
            },
            {
              "value": "130706",
              "area": "下花园区"
            },
            {
              "value": "130721",
              "area": "宣化县"
            },
            {
              "value": "130722",
              "area": "张北县"
            },
            {
              "value": "130723",
              "area": "康保县"
            },
            {
              "value": "130724",
              "area": "沽源县"
            },
            {
              "value": "130725",
              "area": "尚义县"
            },
            {
              "value": "130726",
              "area": "蔚　县"
            },
            {
              "value": "130727",
              "area": "阳原县"
            },
            {
              "value": "130728",
              "area": "怀安县"
            },
            {
              "value": "130729",
              "area": "万全县"
            },
            {
              "value": "130730",
              "area": "怀来县"
            },
            {
              "value": "130731",
              "area": "涿鹿县"
            },
            {
              "value": "130732",
              "area": "赤城县"
            },
            {
              "value": "130733",
              "area": "崇礼县"
            }
          ]
        },
        {
          "value": "130800",
          "city": "承德市",
          "dataList": [
            {
              "value": "130802",
              "area": "双桥区"
            },
            {
              "value": "130803",
              "area": "双滦区"
            },
            {
              "value": "130804",
              "area": "鹰手营子矿区"
            },
            {
              "value": "130821",
              "area": "承德县"
            },
            {
              "value": "130822",
              "area": "兴隆县"
            },
            {
              "value": "130823",
              "area": "平泉县"
            },
            {
              "value": "130824",
              "area": "滦平县"
            },
            {
              "value": "130825",
              "area": "隆化县"
            },
            {
              "value": "130826",
              "area": "丰宁满族自治县"
            },
            {
              "value": "130827",
              "area": "宽城满族自治县"
            },
            {
              "value": "130828",
              "area": "围场满族蒙古族自治县"
            }
          ]
        },
        {
          "value": "130900",
          "city": "沧州市",
          "dataList": [
            {
              "value": "130902",
              "area": "新华区"
            },
            {
              "value": "130903",
              "area": "运河区"
            },
            {
              "value": "130921",
              "area": "沧　县"
            },
            {
              "value": "130922",
              "area": "青　县"
            },
            {
              "value": "130923",
              "area": "东光县"
            },
            {
              "value": "130924",
              "area": "海兴县"
            },
            {
              "value": "130925",
              "area": "盐山县"
            },
            {
              "value": "130926",
              "area": "肃宁县"
            },
            {
              "value": "130927",
              "area": "南皮县"
            },
            {
              "value": "130928",
              "area": "吴桥县"
            },
            {
              "value": "130929",
              "area": "献　县"
            },
            {
              "value": "130930",
              "area": "孟村回族自治县"
            },
            {
              "value": "130981",
              "area": "泊头市"
            },
            {
              "value": "130982",
              "area": "任丘市"
            },
            {
              "value": "130983",
              "area": "黄骅市"
            },
            {
              "value": "130984",
              "area": "河间市"
            }
          ]
        },
        {
          "value": "131000",
          "city": "廊坊市",
          "dataList": [
            {
              "value": "131002",
              "area": "安次区"
            },
            {
              "value": "131003",
              "area": "广阳区"
            },
            {
              "value": "131022",
              "area": "固安县"
            },
            {
              "value": "131023",
              "area": "永清县"
            },
            {
              "value": "131024",
              "area": "香河县"
            },
            {
              "value": "131025",
              "area": "大城县"
            },
            {
              "value": "131026",
              "area": "文安县"
            },
            {
              "value": "131028",
              "area": "大厂回族自治县"
            },
            {
              "value": "131081",
              "area": "霸州市"
            },
            {
              "value": "131082",
              "area": "三河市"
            }
          ]
        },
        {
          "value": "131100",
          "city": "衡水市",
          "dataList": [
            {
              "value": "131102",
              "area": "桃城区"
            },
            {
              "value": "131121",
              "area": "枣强县"
            },
            {
              "value": "131122",
              "area": "武邑县"
            },
            {
              "value": "131123",
              "area": "武强县"
            },
            {
              "value": "131124",
              "area": "饶阳县"
            },
            {
              "value": "131125",
              "area": "安平县"
            },
            {
              "value": "131126",
              "area": "故城县"
            },
            {
              "value": "131127",
              "area": "景　县"
            },
            {
              "value": "131128",
              "area": "阜城县"
            },
            {
              "value": "131181",
              "area": "冀州市"
            },
            {
              "value": "131182",
              "area": "深州市"
            }
          ]
        },
        {
          "value": "139000",
          "city": "省直辖县级行政区划",
          "dataList": [
            {
              "value": "139001",
              "area": "定州市"
            },
            {
              "value": "139002",
              "area": "辛集市"
            }
          ]
        }
      ]
    },
    {
      "value": "140000",
      "province": "山西省",
      "data": [
        {
          "value": "140100",
          "city": "太原市",
          "dataList": [
            {
              "value": "140105",
              "area": "小店区"
            },
            {
              "value": "140106",
              "area": "迎泽区"
            },
            {
              "value": "140107",
              "area": "杏花岭区"
            },
            {
              "value": "140108",
              "area": "尖草坪区"
            },
            {
              "value": "140109",
              "area": "万柏林区"
            },
            {
              "value": "140110",
              "area": "晋源区"
            },
            {
              "value": "140121",
              "area": "清徐县"
            },
            {
              "value": "140122",
              "area": "阳曲县"
            },
            {
              "value": "140123",
              "area": "娄烦县"
            },
            {
              "value": "140181",
              "area": "古交市"
            }
          ]
        },
        {
          "value": "140200",
          "city": "大同市",
          "dataList": [
            {
              "value": "140202",
              "area": "城　区"
            },
            {
              "value": "140203",
              "area": "矿　区"
            },
            {
              "value": "140211",
              "area": "南郊区"
            },
            {
              "value": "140212",
              "area": "新荣区"
            },
            {
              "value": "140221",
              "area": "阳高县"
            },
            {
              "value": "140222",
              "area": "天镇县"
            },
            {
              "value": "140223",
              "area": "广灵县"
            },
            {
              "value": "140224",
              "area": "灵丘县"
            },
            {
              "value": "140225",
              "area": "浑源县"
            },
            {
              "value": "140226",
              "area": "左云县"
            },
            {
              "value": "140227",
              "area": "大同县"
            }
          ]
        },
        {
          "value": "140300",
          "city": "阳泉市",
          "dataList": [
            {
              "value": "140302",
              "area": "城　区"
            },
            {
              "value": "140303",
              "area": "矿　区"
            },
            {
              "value": "140311",
              "area": "郊　区"
            },
            {
              "value": "140321",
              "area": "平定县"
            },
            {
              "value": "140322",
              "area": "盂　县"
            }
          ]
        },
        {
          "value": "140400",
          "city": "长治市",
          "dataList": [
            {
              "value": "140402",
              "area": "城　区"
            },
            {
              "value": "140411",
              "area": "郊　区"
            },
            {
              "value": "140421",
              "area": "长治县"
            },
            {
              "value": "140423",
              "area": "襄垣县"
            },
            {
              "value": "140424",
              "area": "屯留县"
            },
            {
              "value": "140425",
              "area": "平顺县"
            },
            {
              "value": "140426",
              "area": "黎城县"
            },
            {
              "value": "140427",
              "area": "壶关县"
            },
            {
              "value": "140428",
              "area": "长子县"
            },
            {
              "value": "140429",
              "area": "武乡县"
            },
            {
              "value": "140430",
              "area": "沁　县"
            },
            {
              "value": "140431",
              "area": "沁源县"
            },
            {
              "value": "140481",
              "area": "潞城市"
            }
          ]
        },
        {
          "value": "140500",
          "city": "晋城市",
          "dataList": [
            {
              "value": "140502",
              "area": "城　区"
            },
            {
              "value": "140521",
              "area": "沁水县"
            },
            {
              "value": "140522",
              "area": "阳城县"
            },
            {
              "value": "140524",
              "area": "陵川县"
            },
            {
              "value": "140525",
              "area": "泽州县"
            },
            {
              "value": "140581",
              "area": "高平市"
            }
          ]
        },
        {
          "value": "140600",
          "city": "朔州市",
          "dataList": [
            {
              "value": "140602",
              "area": "朔城区"
            },
            {
              "value": "140603",
              "area": "平鲁区"
            },
            {
              "value": "140621",
              "area": "山阴县"
            },
            {
              "value": "140622",
              "area": "应　县"
            },
            {
              "value": "140623",
              "area": "右玉县"
            },
            {
              "value": "140624",
              "area": "怀仁县"
            }
          ]
        },
        {
          "value": "140700",
          "city": "晋中市",
          "dataList": [
            {
              "value": "140702",
              "area": "榆次区"
            },
            {
              "value": "140721",
              "area": "榆社县"
            },
            {
              "value": "140722",
              "area": "左权县"
            },
            {
              "value": "140723",
              "area": "和顺县"
            },
            {
              "value": "140724",
              "area": "昔阳县"
            },
            {
              "value": "140725",
              "area": "寿阳县"
            },
            {
              "value": "140726",
              "area": "太谷县"
            },
            {
              "value": "140727",
              "area": "祁　县"
            },
            {
              "value": "140728",
              "area": "平遥县"
            },
            {
              "value": "140729",
              "area": "灵石县"
            },
            {
              "value": "140781",
              "area": "介休市"
            }
          ]
        },
        {
          "value": "140800",
          "city": "运城市",
          "dataList": [
            {
              "value": "140802",
              "area": "盐湖区"
            },
            {
              "value": "140821",
              "area": "临猗县"
            },
            {
              "value": "140822",
              "area": "万荣县"
            },
            {
              "value": "140823",
              "area": "闻喜县"
            },
            {
              "value": "140824",
              "area": "稷山县"
            },
            {
              "value": "140825",
              "area": "新绛县"
            },
            {
              "value": "140826",
              "area": "绛　县"
            },
            {
              "value": "140827",
              "area": "垣曲县"
            },
            {
              "value": "140828",
              "area": "夏　县"
            },
            {
              "value": "140829",
              "area": "平陆县"
            },
            {
              "value": "140830",
              "area": "芮城县"
            },
            {
              "value": "140881",
              "area": "永济市"
            },
            {
              "value": "140882",
              "area": "河津市"
            }
          ]
        },
        {
          "value": "140900",
          "city": "忻州市",
          "dataList": [
            {
              "value": "140902",
              "area": "忻府区"
            },
            {
              "value": "140921",
              "area": "定襄县"
            },
            {
              "value": "140922",
              "area": "五台县"
            },
            {
              "value": "140923",
              "area": "代　县"
            },
            {
              "value": "140924",
              "area": "繁峙县"
            },
            {
              "value": "140925",
              "area": "宁武县"
            },
            {
              "value": "140926",
              "area": "静乐县"
            },
            {
              "value": "140927",
              "area": "神池县"
            },
            {
              "value": "140928",
              "area": "五寨县"
            },
            {
              "value": "140929",
              "area": "岢岚县"
            },
            {
              "value": "140930",
              "area": "河曲县"
            },
            {
              "value": "140931",
              "area": "保德县"
            },
            {
              "value": "140932",
              "area": "偏关县"
            },
            {
              "value": "140981",
              "area": "原平市"
            }
          ]
        },
        {
          "value": "141000",
          "city": "临汾市",
          "dataList": [
            {
              "value": "141002",
              "area": "尧都区"
            },
            {
              "value": "141021",
              "area": "曲沃县"
            },
            {
              "value": "141022",
              "area": "翼城县"
            },
            {
              "value": "141023",
              "area": "襄汾县"
            },
            {
              "value": "141024",
              "area": "洪洞县"
            },
            {
              "value": "141025",
              "area": "古　县"
            },
            {
              "value": "141026",
              "area": "安泽县"
            },
            {
              "value": "141027",
              "area": "浮山县"
            },
            {
              "value": "141028",
              "area": "吉　县"
            },
            {
              "value": "141029",
              "area": "乡宁县"
            },
            {
              "value": "141030",
              "area": "大宁县"
            },
            {
              "value": "141031",
              "area": "隰　县"
            },
            {
              "value": "141032",
              "area": "永和县"
            },
            {
              "value": "141033",
              "area": "蒲　县"
            },
            {
              "value": "141034",
              "area": "汾西县"
            },
            {
              "value": "141081",
              "area": "侯马市"
            },
            {
              "value": "141082",
              "area": "霍州市"
            }
          ]
        },
        {
          "value": "141100",
          "city": "吕梁市",
          "dataList": [
            {
              "value": "141102",
              "area": "离石区"
            },
            {
              "value": "141121",
              "area": "文水县"
            },
            {
              "value": "141122",
              "area": "交城县"
            },
            {
              "value": "141123",
              "area": "兴　县"
            },
            {
              "value": "141124",
              "area": "临　县"
            },
            {
              "value": "141125",
              "area": "柳林县"
            },
            {
              "value": "141126",
              "area": "石楼县"
            },
            {
              "value": "141127",
              "area": "岚　县"
            },
            {
              "value": "141128",
              "area": "方山县"
            },
            {
              "value": "141129",
              "area": "中阳县"
            },
            {
              "value": "141130",
              "area": "交口县"
            },
            {
              "value": "141181",
              "area": "孝义市"
            },
            {
              "value": "141182",
              "area": "汾阳市"
            }
          ]
        }
      ]
    },
    {
      "value": "150000",
      "province": "内蒙古自治区",
      "data": [
        {
          "value": "150100",
          "city": "呼和浩特市",
          "dataList": [
            {
              "value": "150102",
              "area": "新城区"
            },
            {
              "value": "150103",
              "area": "回民区"
            },
            {
              "value": "150104",
              "area": "玉泉区"
            },
            {
              "value": "150105",
              "area": "赛罕区"
            },
            {
              "value": "150121",
              "area": "土默特左旗"
            },
            {
              "value": "150122",
              "area": "托克托县"
            },
            {
              "value": "150123",
              "area": "和林格尔县"
            },
            {
              "value": "150124",
              "area": "清水河县"
            },
            {
              "value": "150125",
              "area": "武川县"
            }
          ]
        },
        {
          "value": "150200",
          "city": "包头市",
          "dataList": [
            {
              "value": "150202",
              "area": "东河区"
            },
            {
              "value": "150203",
              "area": "昆都仑区"
            },
            {
              "value": "150204",
              "area": "青山区"
            },
            {
              "value": "150205",
              "area": "石拐区"
            },
            {
              "value": "150206",
              "area": "白云鄂博矿区"
            },
            {
              "value": "150207",
              "area": "九原区"
            },
            {
              "value": "150221",
              "area": "土默特右旗"
            },
            {
              "value": "150222",
              "area": "固阳县"
            },
            {
              "value": "150223",
              "area": "达尔罕茂明安联合旗"
            }
          ]
        },
        {
          "value": "150300",
          "city": "乌海市",
          "dataList": [
            {
              "value": "150302",
              "area": "海勃湾区"
            },
            {
              "value": "150303",
              "area": "海南区"
            },
            {
              "value": "150304",
              "area": "乌达区"
            }
          ]
        },
        {
          "value": "150400",
          "city": "赤峰市",
          "dataList": [
            {
              "value": "150402",
              "area": "红山区"
            },
            {
              "value": "150403",
              "area": "元宝山区"
            },
            {
              "value": "150404",
              "area": "松山区"
            },
            {
              "value": "150421",
              "area": "阿鲁科尔沁旗"
            },
            {
              "value": "150422",
              "area": "巴林左旗"
            },
            {
              "value": "150423",
              "area": "巴林右旗"
            },
            {
              "value": "150424",
              "area": "林西县"
            },
            {
              "value": "150425",
              "area": "克什克腾旗"
            },
            {
              "value": "150426",
              "area": "翁牛特旗"
            },
            {
              "value": "150428",
              "area": "喀喇沁旗"
            },
            {
              "value": "150429",
              "area": "宁城县"
            },
            {
              "value": "150430",
              "area": "敖汉旗"
            }
          ]
        },
        {
          "value": "150500",
          "city": "通辽市",
          "dataList": [
            {
              "value": "150502",
              "area": "科尔沁区"
            },
            {
              "value": "150521",
              "area": "科尔沁左翼中旗"
            },
            {
              "value": "150522",
              "area": "科尔沁左翼后旗"
            },
            {
              "value": "150523",
              "area": "开鲁县"
            },
            {
              "value": "150524",
              "area": "库伦旗"
            },
            {
              "value": "150525",
              "area": "奈曼旗"
            },
            {
              "value": "150526",
              "area": "扎鲁特旗"
            },
            {
              "value": "150581",
              "area": "霍林郭勒市"
            }
          ]
        },
        {
          "value": "150600",
          "city": "鄂尔多斯市",
          "dataList": [
            {
              "value": "150602",
              "area": "东胜区"
            },
            {
              "value": "150621",
              "area": "达拉特旗"
            },
            {
              "value": "150622",
              "area": "准格尔旗"
            },
            {
              "value": "150623",
              "area": "鄂托克前旗"
            },
            {
              "value": "150624",
              "area": "鄂托克旗"
            },
            {
              "value": "150625",
              "area": "杭锦旗"
            },
            {
              "value": "150626",
              "area": "乌审旗"
            },
            {
              "value": "150627",
              "area": "伊金霍洛旗"
            }
          ]
        },
        {
          "value": "150700",
          "city": "呼伦贝尔市",
          "dataList": [
            {
              "value": "150702",
              "area": "海拉尔区"
            },
            {
              "value": "150703",
              "area": "扎赉诺尔区"
            },
            {
              "value": "150721",
              "area": "阿荣旗"
            },
            {
              "value": "150722",
              "area": "莫力达瓦达斡尔族自治旗"
            },
            {
              "value": "150723",
              "area": "鄂伦春自治旗"
            },
            {
              "value": "150724",
              "area": "鄂温克族自治旗"
            },
            {
              "value": "150725",
              "area": "陈巴尔虎旗"
            },
            {
              "value": "150726",
              "area": "新巴尔虎左旗"
            },
            {
              "value": "150727",
              "area": "新巴尔虎右旗"
            },
            {
              "value": "150781",
              "area": "满洲里市"
            },
            {
              "value": "150782",
              "area": "牙克石市"
            },
            {
              "value": "150783",
              "area": "扎兰屯市"
            },
            {
              "value": "150784",
              "area": "额尔古纳市"
            },
            {
              "value": "150785",
              "area": "根河市"
            }
          ]
        },
        {
          "value": "150800",
          "city": "巴彦淖尔市",
          "dataList": [
            {
              "value": "150802",
              "area": "临河区"
            },
            {
              "value": "150821",
              "area": "五原县"
            },
            {
              "value": "150822",
              "area": "磴口县"
            },
            {
              "value": "150823",
              "area": "乌拉特前旗"
            },
            {
              "value": "150824",
              "area": "乌拉特中旗"
            },
            {
              "value": "150825",
              "area": "乌拉特后旗"
            },
            {
              "value": "150826",
              "area": "杭锦后旗"
            }
          ]
        },
        {
          "value": "150900",
          "city": "乌兰察布市",
          "dataList": [
            {
              "value": "150902",
              "area": "集宁区"
            },
            {
              "value": "150921",
              "area": "卓资县"
            },
            {
              "value": "150922",
              "area": "化德县"
            },
            {
              "value": "150923",
              "area": "商都县"
            },
            {
              "value": "150924",
              "area": "兴和县"
            },
            {
              "value": "150925",
              "area": "凉城县"
            },
            {
              "value": "150926",
              "area": "察哈尔右翼前旗"
            },
            {
              "value": "150927",
              "area": "察哈尔右翼中旗"
            },
            {
              "value": "150928",
              "area": "察哈尔右翼后旗"
            },
            {
              "value": "150929",
              "area": "四子王旗"
            },
            {
              "value": "150981",
              "area": "丰镇市"
            }
          ]
        },
        {
          "value": "152200",
          "city": "兴安盟",
          "dataList": [
            {
              "value": "152201",
              "area": "乌兰浩特市"
            },
            {
              "value": "152202",
              "area": "阿尔山市"
            },
            {
              "value": "152221",
              "area": "科尔沁右翼前旗"
            },
            {
              "value": "152222",
              "area": "科尔沁右翼中旗"
            },
            {
              "value": "152223",
              "area": "扎赉特旗"
            },
            {
              "value": "152224",
              "area": "突泉县"
            }
          ]
        },
        {
          "value": "152500",
          "city": "锡林郭勒盟",
          "dataList": [
            {
              "value": "152501",
              "area": "二连浩特市"
            },
            {
              "value": "152502",
              "area": "锡林浩特市"
            },
            {
              "value": "152522",
              "area": "阿巴嘎旗"
            },
            {
              "value": "152523",
              "area": "苏尼特左旗"
            },
            {
              "value": "152524",
              "area": "苏尼特右旗"
            },
            {
              "value": "152525",
              "area": "东乌珠穆沁旗"
            },
            {
              "value": "152526",
              "area": "西乌珠穆沁旗"
            },
            {
              "value": "152527",
              "area": "太仆寺旗"
            },
            {
              "value": "152528",
              "area": "镶黄旗"
            },
            {
              "value": "152529",
              "area": "正镶白旗"
            },
            {
              "value": "152530",
              "area": "正蓝旗"
            },
            {
              "value": "152531",
              "area": "多伦县"
            }
          ]
        },
        {
          "value": "152900",
          "city": "阿拉善盟",
          "dataList": [
            {
              "value": "152921",
              "area": "阿拉善左旗"
            },
            {
              "value": "152922",
              "area": "阿拉善右旗"
            },
            {
              "value": "152923",
              "area": "额济纳旗"
            }
          ]
        }
      ]
    },
    {
      "value": "210000",
      "province": "辽宁省",
      "data": [
        {
          "value": "210100",
          "city": "沈阳市",
          "dataList": [
            {
              "value": "210102",
              "area": "和平区"
            },
            {
              "value": "210103",
              "area": "沈河区"
            },
            {
              "value": "210104",
              "area": "大东区"
            },
            {
              "value": "210105",
              "area": "皇姑区"
            },
            {
              "value": "210106",
              "area": "铁西区"
            },
            {
              "value": "210111",
              "area": "苏家屯区"
            },
            {
              "value": "210112",
              "area": "浑南区"
            },
            {
              "value": "210113",
              "area": "沈北新区"
            },
            {
              "value": "210114",
              "area": "于洪区"
            },
            {
              "value": "210122",
              "area": "辽中县"
            },
            {
              "value": "210123",
              "area": "康平县"
            },
            {
              "value": "210124",
              "area": "法库县"
            },
            {
              "value": "210181",
              "area": "新民市"
            }
          ]
        },
        {
          "value": "210200",
          "city": "大连市",
          "dataList": [
            {
              "value": "210202",
              "area": "中山区"
            },
            {
              "value": "210203",
              "area": "西岗区"
            },
            {
              "value": "210204",
              "area": "沙河口区"
            },
            {
              "value": "210211",
              "area": "甘井子区"
            },
            {
              "value": "210212",
              "area": "旅顺口区"
            },
            {
              "value": "210213",
              "area": "金州区"
            },
            {
              "value": "210224",
              "area": "长海县"
            },
            {
              "value": "210281",
              "area": "瓦房店市"
            },
            {
              "value": "210282",
              "area": "普兰店市"
            },
            {
              "value": "210283",
              "area": "庄河市"
            }
          ]
        },
        {
          "value": "210300",
          "city": "鞍山市",
          "dataList": [
            {
              "value": "210302",
              "area": "铁东区"
            },
            {
              "value": "210303",
              "area": "铁西区"
            },
            {
              "value": "210304",
              "area": "立山区"
            },
            {
              "value": "210311",
              "area": "千山区"
            },
            {
              "value": "210321",
              "area": "台安县"
            },
            {
              "value": "210323",
              "area": "岫岩满族自治县"
            },
            {
              "value": "210381",
              "area": "海城市"
            }
          ]
        },
        {
          "value": "210400",
          "city": "抚顺市",
          "dataList": [
            {
              "value": "210402",
              "area": "新抚区"
            },
            {
              "value": "210403",
              "area": "东洲区"
            },
            {
              "value": "210404",
              "area": "望花区"
            },
            {
              "value": "210411",
              "area": "顺城区"
            },
            {
              "value": "210421",
              "area": "抚顺县"
            },
            {
              "value": "210422",
              "area": "新宾满族自治县"
            },
            {
              "value": "210423",
              "area": "清原满族自治县"
            }
          ]
        },
        {
          "value": "210500",
          "city": "本溪市",
          "dataList": [
            {
              "value": "210502",
              "area": "平山区"
            },
            {
              "value": "210503",
              "area": "溪湖区"
            },
            {
              "value": "210504",
              "area": "明山区"
            },
            {
              "value": "210505",
              "area": "南芬区"
            },
            {
              "value": "210521",
              "area": "本溪满族自治县"
            },
            {
              "value": "210522",
              "area": "桓仁满族自治县"
            }
          ]
        },
        {
          "value": "210600",
          "city": "丹东市",
          "dataList": [
            {
              "value": "210602",
              "area": "元宝区"
            },
            {
              "value": "210603",
              "area": "振兴区"
            },
            {
              "value": "210604",
              "area": "振安区"
            },
            {
              "value": "210624",
              "area": "宽甸满族自治县"
            },
            {
              "value": "210681",
              "area": "东港市"
            },
            {
              "value": "210682",
              "area": "凤城市"
            }
          ]
        },
        {
          "value": "210700",
          "city": "锦州市",
          "dataList": [
            {
              "value": "210702",
              "area": "古塔区"
            },
            {
              "value": "210703",
              "area": "凌河区"
            },
            {
              "value": "210711",
              "area": "太和区"
            },
            {
              "value": "210726",
              "area": "黑山县"
            },
            {
              "value": "210727",
              "area": "义　县"
            },
            {
              "value": "210781",
              "area": "凌海市"
            },
            {
              "value": "210783",
              "area": "北镇市"
            }
          ]
        },
        {
          "value": "210800",
          "city": "营口市",
          "dataList": [
            {
              "value": "210802",
              "area": "站前区"
            },
            {
              "value": "210803",
              "area": "西市区"
            },
            {
              "value": "210804",
              "area": "鲅鱼圈区"
            },
            {
              "value": "210811",
              "area": "老边区"
            },
            {
              "value": "210881",
              "area": "盖州市"
            },
            {
              "value": "210882",
              "area": "大石桥市"
            }
          ]
        },
        {
          "value": "210900",
          "city": "阜新市",
          "dataList": [
            {
              "value": "210902",
              "area": "海州区"
            },
            {
              "value": "210903",
              "area": "新邱区"
            },
            {
              "value": "210904",
              "area": "太平区"
            },
            {
              "value": "210905",
              "area": "清河门区"
            },
            {
              "value": "210911",
              "area": "细河区"
            },
            {
              "value": "210921",
              "area": "阜新蒙古族自治县"
            },
            {
              "value": "210922",
              "area": "彰武县"
            }
          ]
        },
        {
          "value": "211000",
          "city": "辽阳市",
          "dataList": [
            {
              "value": "211002",
              "area": "白塔区"
            },
            {
              "value": "211003",
              "area": "文圣区"
            },
            {
              "value": "211004",
              "area": "宏伟区"
            },
            {
              "value": "211005",
              "area": "弓长岭区"
            },
            {
              "value": "211011",
              "area": "太子河区"
            },
            {
              "value": "211021",
              "area": "辽阳县"
            },
            {
              "value": "211081",
              "area": "灯塔市"
            }
          ]
        },
        {
          "value": "211100",
          "city": "盘锦市",
          "dataList": [
            {
              "value": "211102",
              "area": "双台子区"
            },
            {
              "value": "211103",
              "area": "兴隆台区"
            },
            {
              "value": "211121",
              "area": "大洼县"
            },
            {
              "value": "211122",
              "area": "盘山县"
            }
          ]
        },
        {
          "value": "211200",
          "city": "铁岭市",
          "dataList": [
            {
              "value": "211202",
              "area": "银州区"
            },
            {
              "value": "211204",
              "area": "清河区"
            },
            {
              "value": "211221",
              "area": "铁岭县"
            },
            {
              "value": "211223",
              "area": "西丰县"
            },
            {
              "value": "211224",
              "area": "昌图县"
            },
            {
              "value": "211281",
              "area": "调兵山市"
            },
            {
              "value": "211282",
              "area": "开原市"
            }
          ]
        },
        {
          "value": "211300",
          "city": "朝阳市",
          "dataList": [
            {
              "value": "211302",
              "area": "双塔区"
            },
            {
              "value": "211303",
              "area": "龙城区"
            },
            {
              "value": "211321",
              "area": "朝阳县"
            },
            {
              "value": "211322",
              "area": "建平县"
            },
            {
              "value": "211324",
              "area": "喀喇沁左翼蒙古族自治县"
            },
            {
              "value": "211381",
              "area": "北票市"
            },
            {
              "value": "211382",
              "area": "凌源市"
            }
          ]
        },
        {
          "value": "211400",
          "city": "葫芦岛市",
          "dataList": [
            {
              "value": "211402",
              "area": "连山区"
            },
            {
              "value": "211403",
              "area": "龙港区"
            },
            {
              "value": "211404",
              "area": "南票区"
            },
            {
              "value": "211421",
              "area": "绥中县"
            },
            {
              "value": "211422",
              "area": "建昌县"
            },
            {
              "value": "211481",
              "area": "兴城市"
            }
          ]
        }
      ]
    },
    {
      "value": "220000",
      "province": "吉林省",
      "data": [
        {
          "value": "220100",
          "city": "长春市",
          "dataList": [
            {
              "value": "220102",
              "area": "南关区"
            },
            {
              "value": "220103",
              "area": "宽城区"
            },
            {
              "value": "220104",
              "area": "朝阳区"
            },
            {
              "value": "220105",
              "area": "二道区"
            },
            {
              "value": "220106",
              "area": "绿园区"
            },
            {
              "value": "220112",
              "area": "双阳区"
            },
            {
              "value": "220122",
              "area": "农安县"
            },
            {
              "value": "220181",
              "area": "九台市"
            },
            {
              "value": "220182",
              "area": "榆树市"
            },
            {
              "value": "220183",
              "area": "德惠市"
            }
          ]
        },
        {
          "value": "220200",
          "city": "吉林市",
          "dataList": [
            {
              "value": "220202",
              "area": "昌邑区"
            },
            {
              "value": "220203",
              "area": "龙潭区"
            },
            {
              "value": "220204",
              "area": "船营区"
            },
            {
              "value": "220211",
              "area": "丰满区"
            },
            {
              "value": "220221",
              "area": "永吉县"
            },
            {
              "value": "220281",
              "area": "蛟河市"
            },
            {
              "value": "220282",
              "area": "桦甸市"
            },
            {
              "value": "220283",
              "area": "舒兰市"
            },
            {
              "value": "220284",
              "area": "磐石市"
            }
          ]
        },
        {
          "value": "220300",
          "city": "四平市",
          "dataList": [
            {
              "value": "220302",
              "area": "铁西区"
            },
            {
              "value": "220303",
              "area": "铁东区"
            },
            {
              "value": "220322",
              "area": "梨树县"
            },
            {
              "value": "220323",
              "area": "伊通满族自治县"
            },
            {
              "value": "220381",
              "area": "公主岭市"
            },
            {
              "value": "220382",
              "area": "双辽市"
            }
          ]
        },
        {
          "value": "220400",
          "city": "辽源市",
          "dataList": [
            {
              "value": "220402",
              "area": "龙山区"
            },
            {
              "value": "220403",
              "area": "西安区"
            },
            {
              "value": "220421",
              "area": "东丰县"
            },
            {
              "value": "220422",
              "area": "东辽县"
            }
          ]
        },
        {
          "value": "220500",
          "city": "通化市",
          "dataList": [
            {
              "value": "220502",
              "area": "东昌区"
            },
            {
              "value": "220503",
              "area": "二道江区"
            },
            {
              "value": "220521",
              "area": "通化县"
            },
            {
              "value": "220523",
              "area": "辉南县"
            },
            {
              "value": "220524",
              "area": "柳河县"
            },
            {
              "value": "220581",
              "area": "梅河口市"
            },
            {
              "value": "220582",
              "area": "集安市"
            }
          ]
        },
        {
          "value": "220600",
          "city": "白山市",
          "dataList": [
            {
              "value": "220602",
              "area": "浑江区"
            },
            {
              "value": "220605",
              "area": "江源区"
            },
            {
              "value": "220621",
              "area": "抚松县"
            },
            {
              "value": "220622",
              "area": "靖宇县"
            },
            {
              "value": "220623",
              "area": "长白朝鲜族自治县"
            },
            {
              "value": "220681",
              "area": "临江市"
            }
          ]
        },
        {
          "value": "220700",
          "city": "松原市",
          "dataList": [
            {
              "value": "220702",
              "area": "宁江区"
            },
            {
              "value": "220721",
              "area": "前郭尔罗斯蒙古族自治县"
            },
            {
              "value": "220722",
              "area": "长岭县"
            },
            {
              "value": "220723",
              "area": "乾安县"
            },
            {
              "value": "220724",
              "area": "扶余县"
            }
          ]
        },
        {
          "value": "220800",
          "city": "白城市",
          "dataList": [
            {
              "value": "220802",
              "area": "洮北区"
            },
            {
              "value": "220821",
              "area": "镇赉县"
            },
            {
              "value": "220822",
              "area": "通榆县"
            },
            {
              "value": "220881",
              "area": "洮南市"
            },
            {
              "value": "220882",
              "area": "大安市"
            }
          ]
        },
        {
          "value": "222400",
          "city": "延边朝鲜族自治州",
          "dataList": [
            {
              "value": "222401",
              "area": "延吉市"
            },
            {
              "value": "222402",
              "area": "图们市"
            },
            {
              "value": "222403",
              "area": "敦化市"
            },
            {
              "value": "222404",
              "area": "珲春市"
            },
            {
              "value": "222405",
              "area": "龙井市"
            },
            {
              "value": "222406",
              "area": "和龙市"
            },
            {
              "value": "222424",
              "area": "汪清县"
            },
            {
              "value": "222426",
              "area": "安图县"
            }
          ]
        }
      ]
    },
    {
      "value": "230000",
      "province": "黑龙江省",
      "data": [
        {
          "value": "230100",
          "city": "哈尔滨市",
          "dataList": [
            {
              "value": "230102",
              "area": "道里区"
            },
            {
              "value": "230103",
              "area": "南岗区"
            },
            {
              "value": "230104",
              "area": "道外区"
            },
            {
              "value": "230106",
              "area": "香坊区"
            },
            {
              "value": "230108",
              "area": "平房区"
            },
            {
              "value": "230109",
              "area": "松北区"
            },
            {
              "value": "230111",
              "area": "呼兰区"
            },
            {
              "value": "230123",
              "area": "依兰县"
            },
            {
              "value": "230124",
              "area": "方正县"
            },
            {
              "value": "230125",
              "area": "宾　县"
            },
            {
              "value": "230126",
              "area": "巴彦县"
            },
            {
              "value": "230127",
              "area": "木兰县"
            },
            {
              "value": "230128",
              "area": "通河县"
            },
            {
              "value": "230129",
              "area": "延寿县"
            },
            {
              "value": "230181",
              "area": "阿城市"
            },
            {
              "value": "230182",
              "area": "双城市"
            },
            {
              "value": "230183",
              "area": "尚志市"
            },
            {
              "value": "230184",
              "area": "五常市"
            }
          ]
        },
        {
          "value": "230200",
          "city": "齐齐哈尔市",
          "dataList": [
            {
              "value": "230202",
              "area": "龙沙区"
            },
            {
              "value": "230203",
              "area": "建华区"
            },
            {
              "value": "230204",
              "area": "铁锋区"
            },
            {
              "value": "230205",
              "area": "昂昂溪区"
            },
            {
              "value": "230206",
              "area": "富拉尔基区"
            },
            {
              "value": "230207",
              "area": "碾子山区"
            },
            {
              "value": "230208",
              "area": "梅里斯达斡尔族区"
            },
            {
              "value": "230221",
              "area": "龙江县"
            },
            {
              "value": "230223",
              "area": "依安县"
            },
            {
              "value": "230224",
              "area": "泰来县"
            },
            {
              "value": "230225",
              "area": "甘南县"
            },
            {
              "value": "230227",
              "area": "富裕县"
            },
            {
              "value": "230229",
              "area": "克山县"
            },
            {
              "value": "230230",
              "area": "克东县"
            },
            {
              "value": "230231",
              "area": "拜泉县"
            },
            {
              "value": "230281",
              "area": "讷河市"
            }
          ]
        },
        {
          "value": "230300",
          "city": "鸡西市",
          "dataList": [
            {
              "value": "230302",
              "area": "鸡冠区"
            },
            {
              "value": "230303",
              "area": "恒山区"
            },
            {
              "value": "230304",
              "area": "滴道区"
            },
            {
              "value": "230305",
              "area": "梨树区"
            },
            {
              "value": "230306",
              "area": "城子河区"
            },
            {
              "value": "230307",
              "area": "麻山区"
            },
            {
              "value": "230321",
              "area": "鸡东县"
            },
            {
              "value": "230381",
              "area": "虎林市"
            },
            {
              "value": "230382",
              "area": "密山市"
            }
          ]
        },
        {
          "value": "230400",
          "city": "鹤岗市",
          "dataList": [
            {
              "value": "230402",
              "area": "向阳区"
            },
            {
              "value": "230403",
              "area": "工农区"
            },
            {
              "value": "230404",
              "area": "南山区"
            },
            {
              "value": "230405",
              "area": "兴安区"
            },
            {
              "value": "230406",
              "area": "东山区"
            },
            {
              "value": "230407",
              "area": "兴山区"
            },
            {
              "value": "230421",
              "area": "萝北县"
            },
            {
              "value": "230422",
              "area": "绥滨县"
            }
          ]
        },
        {
          "value": "230500",
          "city": "双鸭山市",
          "dataList": [
            {
              "value": "230502",
              "area": "尖山区"
            },
            {
              "value": "230503",
              "area": "岭东区"
            },
            {
              "value": "230505",
              "area": "四方台区"
            },
            {
              "value": "230506",
              "area": "宝山区"
            },
            {
              "value": "230521",
              "area": "集贤县"
            },
            {
              "value": "230522",
              "area": "友谊县"
            },
            {
              "value": "230523",
              "area": "宝清县"
            },
            {
              "value": "230524",
              "area": "饶河县"
            }
          ]
        },
        {
          "value": "230600",
          "city": "大庆市",
          "dataList": [
            {
              "value": "230602",
              "area": "萨尔图区"
            },
            {
              "value": "230603",
              "area": "龙凤区"
            },
            {
              "value": "230604",
              "area": "让胡路区"
            },
            {
              "value": "230605",
              "area": "红岗区"
            },
            {
              "value": "230606",
              "area": "大同区"
            },
            {
              "value": "230621",
              "area": "肇州县"
            },
            {
              "value": "230622",
              "area": "肇源县"
            },
            {
              "value": "230623",
              "area": "林甸县"
            },
            {
              "value": "230624",
              "area": "杜尔伯特蒙古族自治县"
            }
          ]
        },
        {
          "value": "230700",
          "city": "伊春市",
          "dataList": [
            {
              "value": "230702",
              "area": "伊春区"
            },
            {
              "value": "230703",
              "area": "南岔区"
            },
            {
              "value": "230704",
              "area": "友好区"
            },
            {
              "value": "230705",
              "area": "西林区"
            },
            {
              "value": "230706",
              "area": "翠峦区"
            },
            {
              "value": "230707",
              "area": "新青区"
            },
            {
              "value": "230708",
              "area": "美溪区"
            },
            {
              "value": "230709",
              "area": "金山屯区"
            },
            {
              "value": "230710",
              "area": "五营区"
            },
            {
              "value": "230711",
              "area": "乌马河区"
            },
            {
              "value": "230712",
              "area": "汤旺河区"
            },
            {
              "value": "230713",
              "area": "带岭区"
            },
            {
              "value": "230714",
              "area": "乌伊岭区"
            },
            {
              "value": "230715",
              "area": "红星区"
            },
            {
              "value": "230716",
              "area": "上甘岭区"
            },
            {
              "value": "230722",
              "area": "嘉荫县"
            },
            {
              "value": "230781",
              "area": "铁力市"
            }
          ]
        },
        {
          "value": "230800",
          "city": "佳木斯市",
          "dataList": [
            {
              "value": "230803",
              "area": "向阳区"
            },
            {
              "value": "230804",
              "area": "前进区"
            },
            {
              "value": "230805",
              "area": "东风区"
            },
            {
              "value": "230811",
              "area": "郊　区"
            },
            {
              "value": "230822",
              "area": "桦南县"
            },
            {
              "value": "230826",
              "area": "桦川县"
            },
            {
              "value": "230828",
              "area": "汤原县"
            },
            {
              "value": "230833",
              "area": "抚远县"
            },
            {
              "value": "230881",
              "area": "同江市"
            },
            {
              "value": "230882",
              "area": "富锦市"
            }
          ]
        },
        {
          "value": "230900",
          "city": "七台河市",
          "dataList": [
            {
              "value": "230902",
              "area": "新兴区"
            },
            {
              "value": "230903",
              "area": "桃山区"
            },
            {
              "value": "230904",
              "area": "茄子河区"
            },
            {
              "value": "230921",
              "area": "勃利县"
            }
          ]
        },
        {
          "value": "231000",
          "city": "牡丹江市",
          "dataList": [
            {
              "value": "231002",
              "area": "东安区"
            },
            {
              "value": "231003",
              "area": "阳明区"
            },
            {
              "value": "231004",
              "area": "爱民区"
            },
            {
              "value": "231005",
              "area": "西安区"
            },
            {
              "value": "231024",
              "area": "东宁县"
            },
            {
              "value": "231025",
              "area": "林口县"
            },
            {
              "value": "231081",
              "area": "绥芬河市"
            },
            {
              "value": "231083",
              "area": "海林市"
            },
            {
              "value": "231084",
              "area": "宁安市"
            },
            {
              "value": "231085",
              "area": "穆棱市"
            }
          ]
        },
        {
          "value": "231100",
          "city": "黑河市",
          "dataList": [
            {
              "value": "231102",
              "area": "爱辉区"
            },
            {
              "value": "231121",
              "area": "嫩江县"
            },
            {
              "value": "231123",
              "area": "逊克县"
            },
            {
              "value": "231124",
              "area": "孙吴县"
            },
            {
              "value": "231181",
              "area": "北安市"
            },
            {
              "value": "231182",
              "area": "五大连池市"
            }
          ]
        },
        {
          "value": "231200",
          "city": "绥化市",
          "dataList": [
            {
              "value": "231202",
              "area": "北林区"
            },
            {
              "value": "231221",
              "area": "望奎县"
            },
            {
              "value": "231222",
              "area": "兰西县"
            },
            {
              "value": "231223",
              "area": "青冈县"
            },
            {
              "value": "231224",
              "area": "庆安县"
            },
            {
              "value": "231225",
              "area": "明水县"
            },
            {
              "value": "231226",
              "area": "绥棱县"
            },
            {
              "value": "231281",
              "area": "安达市"
            },
            {
              "value": "231282",
              "area": "肇东市"
            },
            {
              "value": "231283",
              "area": "海伦市"
            }
          ]
        },
        {
          "value": "232700",
          "city": "大兴安岭地区",
          "dataList": [
            {
              "value": "232721",
              "area": "呼玛县"
            },
            {
              "value": "232722",
              "area": "塔河县"
            },
            {
              "value": "232723",
              "area": "漠河县"
            }
          ]
        }
      ]
    },
    {
      "value": "310000",
      "province": "上海市",
      "data": [
        {
          "value": "310100",
          "city": "上海市",
          "dataList": [
            {
              "value": "310101",
              "area": "黄浦区"
            },
            {
              "value": "310104",
              "area": "徐汇区"
            },
            {
              "value": "310105",
              "area": "长宁区"
            },
            {
              "value": "310106",
              "area": "静安区"
            },
            {
              "value": "310107",
              "area": "普陀区"
            },
            {
              "value": "310109",
              "area": "虹口区"
            },
            {
              "value": "310110",
              "area": "杨浦区"
            },
            {
              "value": "310112",
              "area": "闵行区"
            },
            {
              "value": "310113",
              "area": "宝山区"
            },
            {
              "value": "310114",
              "area": "嘉定区"
            },
            {
              "value": "310115",
              "area": "浦东新区"
            },
            {
              "value": "310116",
              "area": "金山区"
            },
            {
              "value": "310117",
              "area": "松江区"
            },
            {
              "value": "310118",
              "area": "青浦区"
            },
            {
              "value": "310120",
              "area": "奉贤区"
            },
            {
              "value": "310230",
              "area": "崇明区"
            }
          ]
        }
      ]
    },
    {
      "value": "320000",
      "province": "江苏省",
      "data": [
        {
          "value": "320100",
          "city": "南京市",
          "dataList": [
            {
              "value": "320102",
              "area": "玄武区"
            },
            {
              "value": "320104",
              "area": "秦淮区"
            },
            {
              "value": "320105",
              "area": "建邺区"
            },
            {
              "value": "320106",
              "area": "鼓楼区"
            },
            {
              "value": "320111",
              "area": "浦口区"
            },
            {
              "value": "320113",
              "area": "栖霞区"
            },
            {
              "value": "320114",
              "area": "雨花台区"
            },
            {
              "value": "320115",
              "area": "江宁区"
            },
            {
              "value": "320116",
              "area": "六合区"
            },
            {
              "value": "320124",
              "area": "溧水区"
            },
            {
              "value": "320125",
              "area": "高淳区"
            }
          ]
        },
        {
          "value": "320200",
          "city": "无锡市",
          "dataList": [
            {
              "value": "320202",
              "area": "崇安区"
            },
            {
              "value": "320203",
              "area": "南长区"
            },
            {
              "value": "320204",
              "area": "北塘区"
            },
            {
              "value": "320205",
              "area": "锡山区"
            },
            {
              "value": "320206",
              "area": "惠山区"
            },
            {
              "value": "320211",
              "area": "滨湖区"
            },
            {
              "value": "320281",
              "area": "江阴市"
            },
            {
              "value": "320282",
              "area": "宜兴市"
            }
          ]
        },
        {
          "value": "320300",
          "city": "徐州市",
          "dataList": [
            {
              "value": "320302",
              "area": "鼓楼区"
            },
            {
              "value": "320303",
              "area": "云龙区"
            },
            {
              "value": "320305",
              "area": "贾汪区"
            },
            {
              "value": "320311",
              "area": "泉山区"
            },
            {
              "value": "320312",
              "area": "铜山区"
            },
            {
              "value": "320321",
              "area": "丰　县"
            },
            {
              "value": "320322",
              "area": "沛　县"
            },
            {
              "value": "320324",
              "area": "睢宁县"
            },
            {
              "value": "320381",
              "area": "新沂市"
            },
            {
              "value": "320382",
              "area": "邳州市"
            }
          ]
        },
        {
          "value": "320400",
          "city": "常州市",
          "dataList": [
            {
              "value": "320402",
              "area": "天宁区"
            },
            {
              "value": "320404",
              "area": "钟楼区"
            },
            {
              "value": "320411",
              "area": "新北区"
            },
            {
              "value": "320412",
              "area": "武进区"
            },
            {
              "value": "320413",
              "area": "金坛区"
            },
            {
              "value": "320481",
              "area": "溧阳市"
            }
          ]
        },
        {
          "value": "320500",
          "city": "苏州市",
          "dataList": [
            {
              "value": "320505",
              "area": "虎丘区"
            },
            {
              "value": "320506",
              "area": "吴中区"
            },
            {
              "value": "320507",
              "area": "相城区"
            },
            {
              "value": "320508",
              "area": "姑苏区"
            },
            {
              "value": "320509",
              "area": "吴江区"
            },
            {
              "value": "320581",
              "area": "常熟市"
            },
            {
              "value": "320582",
              "area": "张家港市"
            },
            {
              "value": "320583",
              "area": "昆山市"
            },
            {
              "value": "320585",
              "area": "太仓市"
            }
          ]
        },
        {
          "value": "320600",
          "city": "南通市",
          "dataList": [
            {
              "value": "320602",
              "area": "崇川区"
            },
            {
              "value": "320611",
              "area": "港闸区"
            },
            {
              "value": "320612",
              "area": "通州区"
            },
            {
              "value": "320621",
              "area": "海安县"
            },
            {
              "value": "320623",
              "area": "如东县"
            },
            {
              "value": "320681",
              "area": "启东市"
            },
            {
              "value": "320682",
              "area": "如皋市"
            },
            {
              "value": "320684",
              "area": "海门市"
            }
          ]
        },
        {
          "value": "320700",
          "city": "连云港市",
          "dataList": [
            {
              "value": "320703",
              "area": "连云区"
            },
            {
              "value": "320706",
              "area": "海州区"
            },
            {
              "value": "320707",
              "area": "赣榆县"
            },
            {
              "value": "320722",
              "area": "东海县"
            },
            {
              "value": "320723",
              "area": "灌云县"
            },
            {
              "value": "320724",
              "area": "灌南县"
            }
          ]
        },
        {
          "value": "320800",
          "city": "淮安市",
          "dataList": [
            {
              "value": "320802",
              "area": "清河区"
            },
            {
              "value": "320803",
              "area": "淮安区"
            },
            {
              "value": "320804",
              "area": "淮阴区"
            },
            {
              "value": "320811",
              "area": "清浦区"
            },
            {
              "value": "320826",
              "area": "涟水县"
            },
            {
              "value": "320829",
              "area": "洪泽县"
            },
            {
              "value": "320830",
              "area": "盱眙县"
            },
            {
              "value": "320831",
              "area": "金湖县"
            }
          ]
        },
        {
          "value": "320900",
          "city": "盐城市",
          "dataList": [
            {
              "value": "320902",
              "area": "亭湖区"
            },
            {
              "value": "320903",
              "area": "盐都区"
            },
            {
              "value": "320904",
              "area": "大丰市"
            },
            {
              "value": "320921",
              "area": "响水县"
            },
            {
              "value": "320922",
              "area": "滨海县"
            },
            {
              "value": "320923",
              "area": "阜宁县"
            },
            {
              "value": "320924",
              "area": "射阳县"
            },
            {
              "value": "320925",
              "area": "建湖县"
            },
            {
              "value": "320981",
              "area": "东台市"
            }
          ]
        },
        {
          "value": "321000",
          "city": "扬州市",
          "dataList": [
            {
              "value": "321002",
              "area": "广陵区"
            },
            {
              "value": "321003",
              "area": "邗江区"
            },
            {
              "value": "321012",
              "area": "江都区"
            },
            {
              "value": "321023",
              "area": "宝应县"
            },
            {
              "value": "321081",
              "area": "仪征市"
            },
            {
              "value": "321084",
              "area": "高邮市"
            }
          ]
        },
        {
          "value": "321100",
          "city": "镇江市",
          "dataList": [
            {
              "value": "321102",
              "area": "京口区"
            },
            {
              "value": "321111",
              "area": "润州区"
            },
            {
              "value": "321112",
              "area": "丹徒区"
            },
            {
              "value": "321181",
              "area": "丹阳市"
            },
            {
              "value": "321182",
              "area": "扬中市"
            },
            {
              "value": "321183",
              "area": "句容市"
            }
          ]
        },
        {
          "value": "321200",
          "city": "泰州市",
          "dataList": [
            {
              "value": "321202",
              "area": "海陵区"
            },
            {
              "value": "321203",
              "area": "高港区"
            },
            {
              "value": "321204",
              "area": "姜堰区"
            },
            {
              "value": "321281",
              "area": "兴化市"
            },
            {
              "value": "321282",
              "area": "靖江市"
            },
            {
              "value": "321283",
              "area": "泰兴市"
            }
          ]
        },
        {
          "value": "321300",
          "city": "宿迁市",
          "dataList": [
            {
              "value": "321302",
              "area": "宿城区"
            },
            {
              "value": "321311",
              "area": "宿豫区"
            },
            {
              "value": "321322",
              "area": "沭阳县"
            },
            {
              "value": "321323",
              "area": "泗阳县"
            },
            {
              "value": "321324",
              "area": "泗洪县"
            }
          ]
        }
      ]
    },
    {
      "value": "330000",
      "province": "浙江省",
      "data": [
        {
          "value": "330100",
          "city": "杭州市",
          "dataList": [
            {
              "value": "330102",
              "area": "上城区"
            },
            {
              "value": "330103",
              "area": "下城区"
            },
            {
              "value": "330104",
              "area": "江干区"
            },
            {
              "value": "330105",
              "area": "拱墅区"
            },
            {
              "value": "330106",
              "area": "西湖区"
            },
            {
              "value": "330108",
              "area": "滨江区"
            },
            {
              "value": "330109",
              "area": "萧山区"
            },
            {
              "value": "330110",
              "area": "余杭区"
            },
            {
              "value": "330111",
              "area": "富阳区"
            },
            {
              "value": "330122",
              "area": "桐庐县"
            },
            {
              "value": "330127",
              "area": "淳安县"
            },
            {
              "value": "330182",
              "area": "建德市"
            },
            {
              "value": "330185",
              "area": "临安市"
            }
          ]
        },
        {
          "value": "330200",
          "city": "宁波市",
          "dataList": [
            {
              "value": "330203",
              "area": "海曙区"
            },
            {
              "value": "330204",
              "area": "江东区"
            },
            {
              "value": "330205",
              "area": "江北区"
            },
            {
              "value": "330206",
              "area": "北仑区"
            },
            {
              "value": "330211",
              "area": "镇海区"
            },
            {
              "value": "330212",
              "area": "鄞州区"
            },
            {
              "value": "330225",
              "area": "象山县"
            },
            {
              "value": "330226",
              "area": "宁海县"
            },
            {
              "value": "330281",
              "area": "余姚市"
            },
            {
              "value": "330282",
              "area": "慈溪市"
            },
            {
              "value": "330283",
              "area": "奉化市"
            }
          ]
        },
        {
          "value": "330300",
          "city": "温州市",
          "dataList": [
            {
              "value": "330302",
              "area": "鹿城区"
            },
            {
              "value": "330303",
              "area": "龙湾区"
            },
            {
              "value": "330304",
              "area": "瓯海区"
            },
            {
              "value": "330305",
              "area": "洞头区"
            },
            {
              "value": "330324",
              "area": "永嘉县"
            },
            {
              "value": "330326",
              "area": "平阳县"
            },
            {
              "value": "330327",
              "area": "苍南县"
            },
            {
              "value": "330328",
              "area": "文成县"
            },
            {
              "value": "330329",
              "area": "泰顺县"
            },
            {
              "value": "330381",
              "area": "瑞安市"
            },
            {
              "value": "330382",
              "area": "乐清市"
            }
          ]
        },
        {
          "value": "330400",
          "city": "嘉兴市",
          "dataList": [
            {
              "value": "330402",
              "area": "南湖区"
            },
            {
              "value": "330411",
              "area": "秀洲区"
            },
            {
              "value": "330421",
              "area": "嘉善县"
            },
            {
              "value": "330424",
              "area": "海盐县"
            },
            {
              "value": "330481",
              "area": "海宁市"
            },
            {
              "value": "330482",
              "area": "平湖市"
            },
            {
              "value": "330483",
              "area": "桐乡市"
            }
          ]
        },
        {
          "value": "330500",
          "city": "湖州市",
          "dataList": [
            {
              "value": "330502",
              "area": "吴兴区"
            },
            {
              "value": "330503",
              "area": "南浔区"
            },
            {
              "value": "330521",
              "area": "德清县"
            },
            {
              "value": "330522",
              "area": "长兴县"
            },
            {
              "value": "330523",
              "area": "安吉县"
            }
          ]
        },
        {
          "value": "330600",
          "city": "绍兴市",
          "dataList": [
            {
              "value": "330602",
              "area": "越城区"
            },
            {
              "value": "330603",
              "area": "柯桥区"
            },
            {
              "value": "330604",
              "area": "上虞区"
            },
            {
              "value": "330624",
              "area": "新昌县"
            },
            {
              "value": "330681",
              "area": "诸暨市"
            },
            {
              "value": "330683",
              "area": "嵊州市"
            }
          ]
        },
        {
          "value": "330700",
          "city": "金华市",
          "dataList": [
            {
              "value": "330702",
              "area": "婺城区"
            },
            {
              "value": "330703",
              "area": "金东区"
            },
            {
              "value": "330723",
              "area": "武义县"
            },
            {
              "value": "330726",
              "area": "浦江县"
            },
            {
              "value": "330727",
              "area": "磐安县"
            },
            {
              "value": "330781",
              "area": "兰溪市"
            },
            {
              "value": "330782",
              "area": "义乌市"
            },
            {
              "value": "330783",
              "area": "东阳市"
            },
            {
              "value": "330784",
              "area": "永康市"
            }
          ]
        },
        {
          "value": "330800",
          "city": "衢州市",
          "dataList": [
            {
              "value": "330802",
              "area": "柯城区"
            },
            {
              "value": "330803",
              "area": "衢江区"
            },
            {
              "value": "330822",
              "area": "常山县"
            },
            {
              "value": "330824",
              "area": "开化县"
            },
            {
              "value": "330825",
              "area": "龙游县"
            },
            {
              "value": "330881",
              "area": "江山市"
            }
          ]
        },
        {
          "value": "330900",
          "city": "舟山市",
          "dataList": [
            {
              "value": "330902",
              "area": "定海区"
            },
            {
              "value": "330903",
              "area": "普陀区"
            },
            {
              "value": "330921",
              "area": "岱山县"
            },
            {
              "value": "330922",
              "area": "嵊泗县"
            }
          ]
        },
        {
          "value": "331000",
          "city": "台州市",
          "dataList": [
            {
              "value": "331002",
              "area": "椒江区"
            },
            {
              "value": "331003",
              "area": "黄岩区"
            },
            {
              "value": "331004",
              "area": "路桥区"
            },
            {
              "value": "331021",
              "area": "玉环县"
            },
            {
              "value": "331022",
              "area": "三门县"
            },
            {
              "value": "331023",
              "area": "天台县"
            },
            {
              "value": "331024",
              "area": "仙居县"
            },
            {
              "value": "331081",
              "area": "温岭市"
            },
            {
              "value": "331082",
              "area": "临海市"
            }
          ]
        },
        {
          "value": "331100",
          "city": "丽水市",
          "dataList": [
            {
              "value": "331102",
              "area": "莲都区"
            },
            {
              "value": "331121",
              "area": "青田县"
            },
            {
              "value": "331122",
              "area": "缙云县"
            },
            {
              "value": "331123",
              "area": "遂昌县"
            },
            {
              "value": "331124",
              "area": "松阳县"
            },
            {
              "value": "331125",
              "area": "云和县"
            },
            {
              "value": "331126",
              "area": "庆元县"
            },
            {
              "value": "331127",
              "area": "景宁畲族自治县"
            },
            {
              "value": "331181",
              "area": "龙泉市"
            }
          ]
        }
      ]
    },
    {
      "value": "340000",
      "province": "安徽省",
      "data": [
        {
          "value": "340100",
          "city": "合肥市",
          "dataList": [
            {
              "value": "340102",
              "area": "瑶海区"
            },
            {
              "value": "340103",
              "area": "庐阳区"
            },
            {
              "value": "340104",
              "area": "蜀山区"
            },
            {
              "value": "340111",
              "area": "包河区"
            },
            {
              "value": "340121",
              "area": "长丰县"
            },
            {
              "value": "340122",
              "area": "肥东县"
            },
            {
              "value": "340123",
              "area": "肥西县"
            },
            {
              "value": "340124",
              "area": "庐江县"
            },
            {
              "value": "340181",
              "area": "巢湖市"
            }
          ]
        },
        {
          "value": "340200",
          "city": "芜湖市",
          "dataList": [
            {
              "value": "340202",
              "area": "镜湖区"
            },
            {
              "value": "340203",
              "area": "弋江区"
            },
            {
              "value": "340207",
              "area": "鸠江区"
            },
            {
              "value": "340208",
              "area": "三山区"
            },
            {
              "value": "340221",
              "area": "芜湖县"
            },
            {
              "value": "340222",
              "area": "繁昌县"
            },
            {
              "value": "340223",
              "area": "南陵县"
            },
            {
              "value": "340225",
              "area": "无为县"
            }
          ]
        },
        {
          "value": "340300",
          "city": "蚌埠市",
          "dataList": [
            {
              "value": "340302",
              "area": "龙子湖区"
            },
            {
              "value": "340303",
              "area": "蚌山区"
            },
            {
              "value": "340304",
              "area": "禹会区"
            },
            {
              "value": "340311",
              "area": "淮上区"
            },
            {
              "value": "340321",
              "area": "怀远县"
            },
            {
              "value": "340322",
              "area": "五河县"
            },
            {
              "value": "340323",
              "area": "固镇县"
            }
          ]
        },
        {
          "value": "340400",
          "city": "淮南市",
          "dataList": [
            {
              "value": "340402",
              "area": "大通区"
            },
            {
              "value": "340403",
              "area": "田家庵区"
            },
            {
              "value": "340404",
              "area": "谢家集区"
            },
            {
              "value": "340405",
              "area": "八公山区"
            },
            {
              "value": "340406",
              "area": "潘集区"
            },
            {
              "value": "340421",
              "area": "凤台县"
            }
          ]
        },
        {
          "value": "340500",
          "city": "马鞍山市",
          "dataList": [
            {
              "value": "340503",
              "area": "花山区"
            },
            {
              "value": "340504",
              "area": "雨山区"
            },
            {
              "value": "340506",
              "area": "博望区"
            },
            {
              "value": "340521",
              "area": "当涂县"
            },
            {
              "value": "340522",
              "area": "含山县"
            },
            {
              "value": "340523",
              "area": "和县"
            }
          ]
        },
        {
          "value": "340600",
          "city": "淮北市",
          "dataList": [
            {
              "value": "340602",
              "area": "杜集区"
            },
            {
              "value": "340603",
              "area": "相山区"
            },
            {
              "value": "340604",
              "area": "烈山区"
            },
            {
              "value": "340621",
              "area": "濉溪县"
            }
          ]
        },
        {
          "value": "340700",
          "city": "铜陵市",
          "dataList": [
            {
              "value": "340702",
              "area": "铜官山区"
            },
            {
              "value": "340703",
              "area": "狮子山区"
            },
            {
              "value": "340711",
              "area": "郊　区"
            },
            {
              "value": "340721",
              "area": "铜陵县"
            }
          ]
        },
        {
          "value": "340800",
          "city": "安庆市",
          "dataList": [
            {
              "value": "340802",
              "area": "迎江区"
            },
            {
              "value": "340803",
              "area": "大观区"
            },
            {
              "value": "340811",
              "area": "宜秀区"
            },
            {
              "value": "340822",
              "area": "怀宁县"
            },
            {
              "value": "340823",
              "area": "枞阳县"
            },
            {
              "value": "340824",
              "area": "潜山县"
            },
            {
              "value": "340825",
              "area": "太湖县"
            },
            {
              "value": "340826",
              "area": "宿松县"
            },
            {
              "value": "340827",
              "area": "望江县"
            },
            {
              "value": "340828",
              "area": "岳西县"
            },
            {
              "value": "340881",
              "area": "桐城市"
            }
          ]
        },
        {
          "value": "341000",
          "city": "黄山市",
          "dataList": [
            {
              "value": "341002",
              "area": "屯溪区"
            },
            {
              "value": "341003",
              "area": "黄山区"
            },
            {
              "value": "341004",
              "area": "徽州区"
            },
            {
              "value": "341021",
              "area": "歙　县"
            },
            {
              "value": "341022",
              "area": "休宁县"
            },
            {
              "value": "341023",
              "area": "黟　县"
            },
            {
              "value": "341024",
              "area": "祁门县"
            }
          ]
        },
        {
          "value": "341100",
          "city": "滁州市",
          "dataList": [
            {
              "value": "341102",
              "area": "琅琊区"
            },
            {
              "value": "341103",
              "area": "南谯区"
            },
            {
              "value": "341122",
              "area": "来安县"
            },
            {
              "value": "341124",
              "area": "全椒县"
            },
            {
              "value": "341125",
              "area": "定远县"
            },
            {
              "value": "341126",
              "area": "凤阳县"
            },
            {
              "value": "341181",
              "area": "天长市"
            },
            {
              "value": "341182",
              "area": "明光市"
            }
          ]
        },
        {
          "value": "341200",
          "city": "阜阳市",
          "dataList": [
            {
              "value": "341202",
              "area": "颍州区"
            },
            {
              "value": "341203",
              "area": "颍东区"
            },
            {
              "value": "341204",
              "area": "颍泉区"
            },
            {
              "value": "341221",
              "area": "临泉县"
            },
            {
              "value": "341222",
              "area": "太和县"
            },
            {
              "value": "341225",
              "area": "阜南县"
            },
            {
              "value": "341226",
              "area": "颍上县"
            },
            {
              "value": "341282",
              "area": "界首市"
            }
          ]
        },
        {
          "value": "341300",
          "city": "宿州市",
          "dataList": [
            {
              "value": "341302",
              "area": "墉桥区"
            },
            {
              "value": "341321",
              "area": "砀山县"
            },
            {
              "value": "341322",
              "area": "萧　县"
            },
            {
              "value": "341323",
              "area": "灵璧县"
            },
            {
              "value": "341324",
              "area": "泗　县"
            }
          ]
        },
        {
          "value": "341500",
          "city": "六安市",
          "dataList": [
            {
              "value": "341502",
              "area": "金安区"
            },
            {
              "value": "341503",
              "area": "裕安区"
            },
            {
              "value": "341521",
              "area": "寿　县"
            },
            {
              "value": "341522",
              "area": "霍邱县"
            },
            {
              "value": "341523",
              "area": "舒城县"
            },
            {
              "value": "341524",
              "area": "金寨县"
            },
            {
              "value": "341525",
              "area": "霍山县"
            }
          ]
        },
        {
          "value": "341600",
          "city": "亳州市",
          "dataList": [
            {
              "value": "341602",
              "area": "谯城区"
            },
            {
              "value": "341621",
              "area": "涡阳县"
            },
            {
              "value": "341622",
              "area": "蒙城县"
            },
            {
              "value": "341623",
              "area": "利辛县"
            }
          ]
        },
        {
          "value": "341700",
          "city": "池州市",
          "dataList": [
            {
              "value": "341702",
              "area": "贵池区"
            },
            {
              "value": "341721",
              "area": "东至县"
            },
            {
              "value": "341722",
              "area": "石台县"
            },
            {
              "value": "341723",
              "area": "青阳县"
            }
          ]
        },
        {
          "value": "341800",
          "city": "宣城市",
          "dataList": [
            {
              "value": "341802",
              "area": "宣州区"
            },
            {
              "value": "341821",
              "area": "郎溪县"
            },
            {
              "value": "341822",
              "area": "广德县"
            },
            {
              "value": "341823",
              "area": "泾　县"
            },
            {
              "value": "341824",
              "area": "绩溪县"
            },
            {
              "value": "341825",
              "area": "旌德县"
            },
            {
              "value": "341881",
              "area": "宁国市"
            }
          ]
        }
      ]
    },
    {
      "value": "350000",
      "province": "福建省",
      "data": [
        {
          "value": "350100",
          "city": "福州市",
          "dataList": [
            {
              "value": "350102",
              "area": "鼓楼区"
            },
            {
              "value": "350103",
              "area": "台江区"
            },
            {
              "value": "350104",
              "area": "仓山区"
            },
            {
              "value": "350105",
              "area": "马尾区"
            },
            {
              "value": "350111",
              "area": "晋安区"
            },
            {
              "value": "350121",
              "area": "闽侯县"
            },
            {
              "value": "350122",
              "area": "连江县"
            },
            {
              "value": "350123",
              "area": "罗源县"
            },
            {
              "value": "350124",
              "area": "闽清县"
            },
            {
              "value": "350125",
              "area": "永泰县"
            },
            {
              "value": "350128",
              "area": "平潭县"
            },
            {
              "value": "350181",
              "area": "福清市"
            },
            {
              "value": "350182",
              "area": "长乐市"
            }
          ]
        },
        {
          "value": "350200",
          "city": "厦门市",
          "dataList": [
            {
              "value": "350203",
              "area": "思明区"
            },
            {
              "value": "350205",
              "area": "海沧区"
            },
            {
              "value": "350206",
              "area": "湖里区"
            },
            {
              "value": "350211",
              "area": "集美区"
            },
            {
              "value": "350212",
              "area": "同安区"
            },
            {
              "value": "350213",
              "area": "翔安区"
            }
          ]
        },
        {
          "value": "350300",
          "city": "莆田市",
          "dataList": [
            {
              "value": "350302",
              "area": "城厢区"
            },
            {
              "value": "350303",
              "area": "涵江区"
            },
            {
              "value": "350304",
              "area": "荔城区"
            },
            {
              "value": "350305",
              "area": "秀屿区"
            },
            {
              "value": "350322",
              "area": "仙游县"
            }
          ]
        },
        {
          "value": "350400",
          "city": "三明市",
          "dataList": [
            {
              "value": "350402",
              "area": "梅列区"
            },
            {
              "value": "350403",
              "area": "三元区"
            },
            {
              "value": "350421",
              "area": "明溪县"
            },
            {
              "value": "350423",
              "area": "清流县"
            },
            {
              "value": "350424",
              "area": "宁化县"
            },
            {
              "value": "350425",
              "area": "大田县"
            },
            {
              "value": "350426",
              "area": "尤溪县"
            },
            {
              "value": "350427",
              "area": "沙　县"
            },
            {
              "value": "350428",
              "area": "将乐县"
            },
            {
              "value": "350429",
              "area": "泰宁县"
            },
            {
              "value": "350430",
              "area": "建宁县"
            },
            {
              "value": "350481",
              "area": "永安市"
            }
          ]
        },
        {
          "value": "350500",
          "city": "泉州市",
          "dataList": [
            {
              "value": "350502",
              "area": "鲤城区"
            },
            {
              "value": "350503",
              "area": "丰泽区"
            },
            {
              "value": "350504",
              "area": "洛江区"
            },
            {
              "value": "350505",
              "area": "泉港区"
            },
            {
              "value": "350521",
              "area": "惠安县"
            },
            {
              "value": "350524",
              "area": "安溪县"
            },
            {
              "value": "350525",
              "area": "永春县"
            },
            {
              "value": "350526",
              "area": "德化县"
            },
            {
              "value": "350527",
              "area": "金门县"
            },
            {
              "value": "350581",
              "area": "石狮市"
            },
            {
              "value": "350582",
              "area": "晋江市"
            },
            {
              "value": "350583",
              "area": "南安市"
            }
          ]
        },
        {
          "value": "350600",
          "city": "漳州市",
          "dataList": [
            {
              "value": "350602",
              "area": "芗城区"
            },
            {
              "value": "350603",
              "area": "龙文区"
            },
            {
              "value": "350622",
              "area": "云霄县"
            },
            {
              "value": "350623",
              "area": "漳浦县"
            },
            {
              "value": "350624",
              "area": "诏安县"
            },
            {
              "value": "350625",
              "area": "长泰县"
            },
            {
              "value": "350626",
              "area": "东山县"
            },
            {
              "value": "350627",
              "area": "南靖县"
            },
            {
              "value": "350628",
              "area": "平和县"
            },
            {
              "value": "350629",
              "area": "华安县"
            },
            {
              "value": "350681",
              "area": "龙海市"
            }
          ]
        },
        {
          "value": "350700",
          "city": "南平市",
          "dataList": [
            {
              "value": "350702",
              "area": "延平区"
            },
            {
              "value": "350703",
              "area": "建阳区"
            },
            {
              "value": "350721",
              "area": "顺昌县"
            },
            {
              "value": "350722",
              "area": "浦城县"
            },
            {
              "value": "350723",
              "area": "光泽县"
            },
            {
              "value": "350724",
              "area": "松溪县"
            },
            {
              "value": "350725",
              "area": "政和县"
            },
            {
              "value": "350781",
              "area": "邵武市"
            },
            {
              "value": "350782",
              "area": "武夷山市"
            },
            {
              "value": "350783",
              "area": "建瓯市"
            }
          ]
        },
        {
          "value": "350800",
          "city": "龙岩市",
          "dataList": [
            {
              "value": "350802",
              "area": "新罗区"
            },
            {
              "value": "350803",
              "area": "永定区"
            },
            {
              "value": "350821",
              "area": "长汀县"
            },
            {
              "value": "350823",
              "area": "上杭县"
            },
            {
              "value": "350824",
              "area": "武平县"
            },
            {
              "value": "350825",
              "area": "连城县"
            },
            {
              "value": "350881",
              "area": "漳平市"
            }
          ]
        },
        {
          "value": "350900",
          "city": "宁德市",
          "dataList": [
            {
              "value": "350902",
              "area": "蕉城区"
            },
            {
              "value": "350921",
              "area": "霞浦县"
            },
            {
              "value": "350922",
              "area": "古田县"
            },
            {
              "value": "350923",
              "area": "屏南县"
            },
            {
              "value": "350924",
              "area": "寿宁县"
            },
            {
              "value": "350925",
              "area": "周宁县"
            },
            {
              "value": "350926",
              "area": "柘荣县"
            },
            {
              "value": "350981",
              "area": "福安市"
            },
            {
              "value": "350982",
              "area": "福鼎市"
            }
          ]
        }
      ]
    },
    {
      "value": "360000",
      "province": "江西省",
      "data": [
        {
          "value": "360100",
          "city": "南昌市",
          "dataList": [
            {
              "value": "360102",
              "area": "东湖区"
            },
            {
              "value": "360103",
              "area": "西湖区"
            },
            {
              "value": "360104",
              "area": "青云谱区"
            },
            {
              "value": "360105",
              "area": "湾里区"
            },
            {
              "value": "360111",
              "area": "青山湖区"
            },
            {
              "value": "360112",
              "area": "新建区"
            },
            {
              "value": "360121",
              "area": "南昌县"
            },
            {
              "value": "360123",
              "area": "安义县"
            },
            {
              "value": "360124",
              "area": "进贤县"
            }
          ]
        },
        {
          "value": "360200",
          "city": "景德镇市",
          "dataList": [
            {
              "value": "360202",
              "area": "昌江区"
            },
            {
              "value": "360203",
              "area": "珠山区"
            },
            {
              "value": "360222",
              "area": "浮梁县"
            },
            {
              "value": "360281",
              "area": "乐平市"
            }
          ]
        },
        {
          "value": "360300",
          "city": "萍乡市",
          "dataList": [
            {
              "value": "360302",
              "area": "安源区"
            },
            {
              "value": "360313",
              "area": "湘东区"
            },
            {
              "value": "360321",
              "area": "莲花县"
            },
            {
              "value": "360322",
              "area": "上栗县"
            },
            {
              "value": "360323",
              "area": "芦溪县"
            }
          ]
        },
        {
          "value": "360400",
          "city": "九江市",
          "dataList": [
            {
              "value": "360402",
              "area": "庐山区"
            },
            {
              "value": "360403",
              "area": "浔阳区"
            },
            {
              "value": "360421",
              "area": "九江县"
            },
            {
              "value": "360423",
              "area": "武宁县"
            },
            {
              "value": "360424",
              "area": "修水县"
            },
            {
              "value": "360425",
              "area": "永修县"
            },
            {
              "value": "360426",
              "area": "德安县"
            },
            {
              "value": "360427",
              "area": "星子县"
            },
            {
              "value": "360428",
              "area": "都昌县"
            },
            {
              "value": "360429",
              "area": "湖口县"
            },
            {
              "value": "360430",
              "area": "彭泽县"
            },
            {
              "value": "360481",
              "area": "瑞昌市"
            },
            {
              "value": "360482",
              "area": "共青城市"
            }
          ]
        },
        {
          "value": "360500",
          "city": "新余市",
          "dataList": [
            {
              "value": "360502",
              "area": "渝水区"
            },
            {
              "value": "360521",
              "area": "分宜县"
            }
          ]
        },
        {
          "value": "360600",
          "city": "鹰潭市",
          "dataList": [
            {
              "value": "360602",
              "area": "月湖区"
            },
            {
              "value": "360622",
              "area": "余江县"
            },
            {
              "value": "360681",
              "area": "贵溪市"
            }
          ]
        },
        {
          "value": "360700",
          "city": "赣州市",
          "dataList": [
            {
              "value": "360702",
              "area": "章贡区"
            },
            {
              "value": "360703",
              "area": "南康区"
            },
            {
              "value": "360721",
              "area": "赣　县"
            },
            {
              "value": "360722",
              "area": "信丰县"
            },
            {
              "value": "360723",
              "area": "大余县"
            },
            {
              "value": "360724",
              "area": "上犹县"
            },
            {
              "value": "360725",
              "area": "崇义县"
            },
            {
              "value": "360726",
              "area": "安远县"
            },
            {
              "value": "360727",
              "area": "龙南县"
            },
            {
              "value": "360728",
              "area": "定南县"
            },
            {
              "value": "360729",
              "area": "全南县"
            },
            {
              "value": "360730",
              "area": "宁都县"
            },
            {
              "value": "360731",
              "area": "于都县"
            },
            {
              "value": "360732",
              "area": "兴国县"
            },
            {
              "value": "360733",
              "area": "会昌县"
            },
            {
              "value": "360734",
              "area": "寻乌县"
            },
            {
              "value": "360735",
              "area": "石城县"
            },
            {
              "value": "360781",
              "area": "瑞金市"
            }
          ]
        },
        {
          "value": "360800",
          "city": "吉安市",
          "dataList": [
            {
              "value": "360802",
              "area": "吉州区"
            },
            {
              "value": "360803",
              "area": "青原区"
            },
            {
              "value": "360821",
              "area": "吉安县"
            },
            {
              "value": "360822",
              "area": "吉水县"
            },
            {
              "value": "360823",
              "area": "峡江县"
            },
            {
              "value": "360824",
              "area": "新干县"
            },
            {
              "value": "360825",
              "area": "永丰县"
            },
            {
              "value": "360826",
              "area": "泰和县"
            },
            {
              "value": "360827",
              "area": "遂川县"
            },
            {
              "value": "360828",
              "area": "万安县"
            },
            {
              "value": "360829",
              "area": "安福县"
            },
            {
              "value": "360830",
              "area": "永新县"
            },
            {
              "value": "360881",
              "area": "井冈山市"
            }
          ]
        },
        {
          "value": "360900",
          "city": "宜春市",
          "dataList": [
            {
              "value": "360902",
              "area": "袁州区"
            },
            {
              "value": "360921",
              "area": "奉新县"
            },
            {
              "value": "360922",
              "area": "万载县"
            },
            {
              "value": "360923",
              "area": "上高县"
            },
            {
              "value": "360924",
              "area": "宜丰县"
            },
            {
              "value": "360925",
              "area": "靖安县"
            },
            {
              "value": "360926",
              "area": "铜鼓县"
            },
            {
              "value": "360981",
              "area": "丰城市"
            },
            {
              "value": "360982",
              "area": "樟树市"
            },
            {
              "value": "360983",
              "area": "高安市"
            }
          ]
        },
        {
          "value": "361000",
          "city": "抚州市",
          "dataList": [
            {
              "value": "361002",
              "area": "临川区"
            },
            {
              "value": "361021",
              "area": "南城县"
            },
            {
              "value": "361022",
              "area": "黎川县"
            },
            {
              "value": "361023",
              "area": "南丰县"
            },
            {
              "value": "361024",
              "area": "崇仁县"
            },
            {
              "value": "361025",
              "area": "乐安县"
            },
            {
              "value": "361026",
              "area": "宜黄县"
            },
            {
              "value": "361027",
              "area": "金溪县"
            },
            {
              "value": "361028",
              "area": "资溪县"
            },
            {
              "value": "361029",
              "area": "东乡县"
            },
            {
              "value": "361030",
              "area": "广昌县"
            }
          ]
        },
        {
          "value": "361100",
          "city": "上饶市",
          "dataList": [
            {
              "value": "361102",
              "area": "信州区"
            },
            {
              "value": "361103",
              "area": "广丰区"
            },
            {
              "value": "361121",
              "area": "上饶县"
            },
            {
              "value": "361123",
              "area": "玉山县"
            },
            {
              "value": "361124",
              "area": "铅山县"
            },
            {
              "value": "361125",
              "area": "横峰县"
            },
            {
              "value": "361126",
              "area": "弋阳县"
            },
            {
              "value": "361127",
              "area": "余干县"
            },
            {
              "value": "361128",
              "area": "鄱阳县"
            },
            {
              "value": "361129",
              "area": "万年县"
            },
            {
              "value": "361130",
              "area": "婺源县"
            },
            {
              "value": "361181",
              "area": "德兴市"
            }
          ]
        }
      ]
    },
    {
      "value": "370000",
      "province": "山东省",
      "data": [
        {
          "value": "370100",
          "city": "济南市",
          "dataList": [
            {
              "value": "370102",
              "area": "历下区"
            },
            {
              "value": "370103",
              "area": "市中区"
            },
            {
              "value": "370104",
              "area": "槐荫区"
            },
            {
              "value": "370105",
              "area": "天桥区"
            },
            {
              "value": "370112",
              "area": "历城区"
            },
            {
              "value": "370113",
              "area": "长清区"
            },
            {
              "value": "370124",
              "area": "平阴县"
            },
            {
              "value": "370125",
              "area": "济阳县"
            },
            {
              "value": "370126",
              "area": "商河县"
            },
            {
              "value": "370181",
              "area": "章丘市"
            }
          ]
        },
        {
          "value": "370200",
          "city": "青岛市",
          "dataList": [
            {
              "value": "370202",
              "area": "市南区"
            },
            {
              "value": "370203",
              "area": "市北区"
            },
            {
              "value": "370205",
              "area": "四方区"
            },
            {
              "value": "370211",
              "area": "黄岛区"
            },
            {
              "value": "370212",
              "area": "崂山区"
            },
            {
              "value": "370213",
              "area": "李沧区"
            },
            {
              "value": "370214",
              "area": "城阳区"
            },
            {
              "value": "370281",
              "area": "胶州市"
            },
            {
              "value": "370282",
              "area": "即墨市"
            },
            {
              "value": "370283",
              "area": "平度市"
            },
            {
              "value": "370285",
              "area": "莱西市"
            }
          ]
        },
        {
          "value": "370300",
          "city": "淄博市",
          "dataList": [
            {
              "value": "370302",
              "area": "淄川区"
            },
            {
              "value": "370303",
              "area": "张店区"
            },
            {
              "value": "370304",
              "area": "博山区"
            },
            {
              "value": "370305",
              "area": "临淄区"
            },
            {
              "value": "370306",
              "area": "周村区"
            },
            {
              "value": "370321",
              "area": "桓台县"
            },
            {
              "value": "370322",
              "area": "高青县"
            },
            {
              "value": "370323",
              "area": "沂源县"
            }
          ]
        },
        {
          "value": "370400",
          "city": "枣庄市",
          "dataList": [
            {
              "value": "370402",
              "area": "市中区"
            },
            {
              "value": "370403",
              "area": "薛城区"
            },
            {
              "value": "370404",
              "area": "峄城区"
            },
            {
              "value": "370405",
              "area": "台儿庄区"
            },
            {
              "value": "370406",
              "area": "山亭区"
            },
            {
              "value": "370481",
              "area": "滕州市"
            }
          ]
        },
        {
          "value": "370500",
          "city": "东营市",
          "dataList": [
            {
              "value": "370502",
              "area": "东营区"
            },
            {
              "value": "370503",
              "area": "河口区"
            },
            {
              "value": "370521",
              "area": "垦利县"
            },
            {
              "value": "370522",
              "area": "利津县"
            },
            {
              "value": "370523",
              "area": "广饶县"
            }
          ]
        },
        {
          "value": "370600",
          "city": "烟台市",
          "dataList": [
            {
              "value": "370602",
              "area": "芝罘区"
            },
            {
              "value": "370611",
              "area": "福山区"
            },
            {
              "value": "370612",
              "area": "牟平区"
            },
            {
              "value": "370613",
              "area": "莱山区"
            },
            {
              "value": "370634",
              "area": "长岛县"
            },
            {
              "value": "370681",
              "area": "龙口市"
            },
            {
              "value": "370682",
              "area": "莱阳市"
            },
            {
              "value": "370683",
              "area": "莱州市"
            },
            {
              "value": "370684",
              "area": "蓬莱市"
            },
            {
              "value": "370685",
              "area": "招远市"
            },
            {
              "value": "370686",
              "area": "栖霞市"
            },
            {
              "value": "370687",
              "area": "海阳市"
            }
          ]
        },
        {
          "value": "370700",
          "city": "潍坊市",
          "dataList": [
            {
              "value": "370702",
              "area": "潍城区"
            },
            {
              "value": "370703",
              "area": "寒亭区"
            },
            {
              "value": "370704",
              "area": "坊子区"
            },
            {
              "value": "370705",
              "area": "奎文区"
            },
            {
              "value": "370724",
              "area": "临朐县"
            },
            {
              "value": "370725",
              "area": "昌乐县"
            },
            {
              "value": "370781",
              "area": "青州市"
            },
            {
              "value": "370782",
              "area": "诸城市"
            },
            {
              "value": "370783",
              "area": "寿光市"
            },
            {
              "value": "370784",
              "area": "安丘市"
            },
            {
              "value": "370785",
              "area": "高密市"
            },
            {
              "value": "370786",
              "area": "昌邑市"
            }
          ]
        },
        {
          "value": "370800",
          "city": "济宁市",
          "dataList": [
            {
              "value": "370811",
              "area": "任城区"
            },
            {
              "value": "370812",
              "area": "兖州区"
            },
            {
              "value": "370826",
              "area": "微山县"
            },
            {
              "value": "370827",
              "area": "鱼台县"
            },
            {
              "value": "370828",
              "area": "金乡县"
            },
            {
              "value": "370829",
              "area": "嘉祥县"
            },
            {
              "value": "370830",
              "area": "汶上县"
            },
            {
              "value": "370831",
              "area": "泗水县"
            },
            {
              "value": "370832",
              "area": "梁山县"
            },
            {
              "value": "370881",
              "area": "曲阜市"
            },
            {
              "value": "370883",
              "area": "邹城市"
            }
          ]
        },
        {
          "value": "370900",
          "city": "泰安市",
          "dataList": [
            {
              "value": "370902",
              "area": "泰山区"
            },
            {
              "value": "370903",
              "area": "岱岳区"
            },
            {
              "value": "370921",
              "area": "宁阳县"
            },
            {
              "value": "370923",
              "area": "东平县"
            },
            {
              "value": "370982",
              "area": "新泰市"
            },
            {
              "value": "370983",
              "area": "肥城市"
            }
          ]
        },
        {
          "value": "371000",
          "city": "威海市",
          "dataList": [
            {
              "value": "371002",
              "area": "环翠区"
            },
            {
              "value": "371081",
              "area": "文登区"
            },
            {
              "value": "371082",
              "area": "荣成市"
            },
            {
              "value": "371083",
              "area": "乳山市"
            }
          ]
        },
        {
          "value": "371100",
          "city": "日照市",
          "dataList": [
            {
              "value": "371102",
              "area": "东港区"
            },
            {
              "value": "371103",
              "area": "岚山区"
            },
            {
              "value": "371121",
              "area": "五莲县"
            },
            {
              "value": "371122",
              "area": "莒　县"
            }
          ]
        },
        {
          "value": "371200",
          "city": "莱芜市",
          "dataList": [
            {
              "value": "371202",
              "area": "莱城区"
            },
            {
              "value": "371203",
              "area": "钢城区"
            }
          ]
        },
        {
          "value": "371300",
          "city": "临沂市",
          "dataList": [
            {
              "value": "371302",
              "area": "兰山区"
            },
            {
              "value": "371311",
              "area": "罗庄区"
            },
            {
              "value": "371312",
              "area": "河东区"
            },
            {
              "value": "371321",
              "area": "沂南县"
            },
            {
              "value": "371322",
              "area": "郯城县"
            },
            {
              "value": "371323",
              "area": "沂水县"
            },
            {
              "value": "371324",
              "area": "兰陵县"
            },
            {
              "value": "371325",
              "area": "费　县"
            },
            {
              "value": "371326",
              "area": "平邑县"
            },
            {
              "value": "371327",
              "area": "莒南县"
            },
            {
              "value": "371328",
              "area": "蒙阴县"
            },
            {
              "value": "371329",
              "area": "临沭县"
            }
          ]
        },
        {
          "value": "371400",
          "city": "德州市",
          "dataList": [
            {
              "value": "371402",
              "area": "德城区"
            },
            {
              "value": "371421",
              "area": "陵城区"
            },
            {
              "value": "371422",
              "area": "宁津县"
            },
            {
              "value": "371423",
              "area": "庆云县"
            },
            {
              "value": "371424",
              "area": "临邑县"
            },
            {
              "value": "371425",
              "area": "齐河县"
            },
            {
              "value": "371426",
              "area": "平原县"
            },
            {
              "value": "371427",
              "area": "夏津县"
            },
            {
              "value": "371428",
              "area": "武城县"
            },
            {
              "value": "371481",
              "area": "乐陵市"
            },
            {
              "value": "371482",
              "area": "禹城市"
            }
          ]
        },
        {
          "value": "371500",
          "city": "聊城市",
          "dataList": [
            {
              "value": "371502",
              "area": "东昌府区"
            },
            {
              "value": "371521",
              "area": "阳谷县"
            },
            {
              "value": "371522",
              "area": "莘　县"
            },
            {
              "value": "371523",
              "area": "茌平县"
            },
            {
              "value": "371524",
              "area": "东阿县"
            },
            {
              "value": "371525",
              "area": "冠　县"
            },
            {
              "value": "371526",
              "area": "高唐县"
            },
            {
              "value": "371581",
              "area": "临清市"
            }
          ]
        },
        {
          "value": "371600",
          "city": "滨州市",
          "dataList": [
            {
              "value": "371602",
              "area": "滨城区"
            },
            {
              "value": "371603",
              "area": "沾化区"
            },
            {
              "value": "371621",
              "area": "惠民县"
            },
            {
              "value": "371622",
              "area": "阳信县"
            },
            {
              "value": "371623",
              "area": "无棣县"
            },
            {
              "value": "371625",
              "area": "博兴县"
            },
            {
              "value": "371626",
              "area": "邹平县"
            }
          ]
        },
        {
          "value": "371700",
          "city": "荷泽市",
          "dataList": [
            {
              "value": "371702",
              "area": "牡丹区"
            },
            {
              "value": "371721",
              "area": "曹 县"
            },
            {
              "value": "371722",
              "area": "单 县"
            },
            {
              "value": "371723",
              "area": "成武县"
            },
            {
              "value": "371724",
              "area": "巨野县"
            },
            {
              "value": "371725",
              "area": "郓城县"
            },
            {
              "value": "371726",
              "area": "鄄城县"
            },
            {
              "value": "371727",
              "area": "定陶县"
            },
            {
              "value": "371728",
              "area": "东明县"
            }
          ]
        }
      ]
    },
    {
      "value": "410000",
      "province": "河南省",
      "data": [
        {
          "value": "410100",
          "city": "郑州市",
          "dataList": [
            {
              "value": "410102",
              "area": "中原区"
            },
            {
              "value": "410103",
              "area": "二七区"
            },
            {
              "value": "410104",
              "area": "管城回族区"
            },
            {
              "value": "410105",
              "area": "金水区"
            },
            {
              "value": "410106",
              "area": "上街区"
            },
            {
              "value": "410108",
              "area": "惠济区"
            },
            {
              "value": "410122",
              "area": "中牟县"
            },
            {
              "value": "410181",
              "area": "巩义市"
            },
            {
              "value": "410182",
              "area": "荥阳市"
            },
            {
              "value": "410183",
              "area": "新密市"
            },
            {
              "value": "410184",
              "area": "新郑市"
            },
            {
              "value": "410185",
              "area": "登封市"
            }
          ]
        },
        {
          "value": "410200",
          "city": "开封市",
          "dataList": [
            {
              "value": "410202",
              "area": "龙亭区"
            },
            {
              "value": "410203",
              "area": "顺河回族区"
            },
            {
              "value": "410204",
              "area": "鼓楼区"
            },
            {
              "value": "410205",
              "area": "禹王台区"
            },
            {
              "value": "410211",
              "area": "金明区"
            },
            {
              "value": "410212",
              "area": "祥符区"
            },
            {
              "value": "410221",
              "area": "杞　县"
            },
            {
              "value": "410222",
              "area": "通许县"
            },
            {
              "value": "410223",
              "area": "尉氏县"
            },
            {
              "value": "410224",
              "area": "开封县"
            },
            {
              "value": "410225",
              "area": "兰考县"
            }
          ]
        },
        {
          "value": "410300",
          "city": "洛阳市",
          "dataList": [
            {
              "value": "410302",
              "area": "老城区"
            },
            {
              "value": "410303",
              "area": "西工区"
            },
            {
              "value": "410304",
              "area": "廛河回族区"
            },
            {
              "value": "410305",
              "area": "涧西区"
            },
            {
              "value": "410306",
              "area": "吉利区"
            },
            {
              "value": "410307",
              "area": "洛龙区"
            },
            {
              "value": "410322",
              "area": "孟津县"
            },
            {
              "value": "410323",
              "area": "新安县"
            },
            {
              "value": "410324",
              "area": "栾川县"
            },
            {
              "value": "410325",
              "area": "嵩　县"
            },
            {
              "value": "410326",
              "area": "汝阳县"
            },
            {
              "value": "410327",
              "area": "宜阳县"
            },
            {
              "value": "410328",
              "area": "洛宁县"
            },
            {
              "value": "410329",
              "area": "伊川县"
            },
            {
              "value": "410381",
              "area": "偃师市"
            }
          ]
        },
        {
          "value": "410400",
          "city": "平顶山市",
          "dataList": [
            {
              "value": "410402",
              "area": "新华区"
            },
            {
              "value": "410403",
              "area": "卫东区"
            },
            {
              "value": "410404",
              "area": "石龙区"
            },
            {
              "value": "410411",
              "area": "湛河区"
            },
            {
              "value": "410421",
              "area": "宝丰县"
            },
            {
              "value": "410422",
              "area": "叶　县"
            },
            {
              "value": "410423",
              "area": "鲁山县"
            },
            {
              "value": "410425",
              "area": "郏　县"
            },
            {
              "value": "410481",
              "area": "舞钢市"
            },
            {
              "value": "410482",
              "area": "汝州市"
            }
          ]
        },
        {
          "value": "410500",
          "city": "安阳市",
          "dataList": [
            {
              "value": "410502",
              "area": "文峰区"
            },
            {
              "value": "410503",
              "area": "北关区"
            },
            {
              "value": "410505",
              "area": "殷都区"
            },
            {
              "value": "410506",
              "area": "龙安区"
            },
            {
              "value": "410522",
              "area": "安阳县"
            },
            {
              "value": "410523",
              "area": "汤阴县"
            },
            {
              "value": "410526",
              "area": "滑　县"
            },
            {
              "value": "410527",
              "area": "内黄县"
            },
            {
              "value": "410581",
              "area": "林州市"
            }
          ]
        },
        {
          "value": "410600",
          "city": "鹤壁市",
          "dataList": [
            {
              "value": "410602",
              "area": "鹤山区"
            },
            {
              "value": "410603",
              "area": "山城区"
            },
            {
              "value": "410611",
              "area": "淇滨区"
            },
            {
              "value": "410621",
              "area": "浚　县"
            },
            {
              "value": "410622",
              "area": "淇　县"
            }
          ]
        },
        {
          "value": "410700",
          "city": "新乡市",
          "dataList": [
            {
              "value": "410702",
              "area": "红旗区"
            },
            {
              "value": "410703",
              "area": "卫滨区"
            },
            {
              "value": "410704",
              "area": "凤泉区"
            },
            {
              "value": "410711",
              "area": "牧野区"
            },
            {
              "value": "410721",
              "area": "新乡县"
            },
            {
              "value": "410724",
              "area": "获嘉县"
            },
            {
              "value": "410725",
              "area": "原阳县"
            },
            {
              "value": "410726",
              "area": "延津县"
            },
            {
              "value": "410727",
              "area": "封丘县"
            },
            {
              "value": "410728",
              "area": "长垣县"
            },
            {
              "value": "410781",
              "area": "卫辉市"
            },
            {
              "value": "410782",
              "area": "辉县市"
            }
          ]
        },
        {
          "value": "410800",
          "city": "焦作市",
          "dataList": [
            {
              "value": "410802",
              "area": "解放区"
            },
            {
              "value": "410803",
              "area": "中站区"
            },
            {
              "value": "410804",
              "area": "马村区"
            },
            {
              "value": "410811",
              "area": "山阳区"
            },
            {
              "value": "410821",
              "area": "修武县"
            },
            {
              "value": "410822",
              "area": "博爱县"
            },
            {
              "value": "410823",
              "area": "武陟县"
            },
            {
              "value": "410825",
              "area": "温　县"
            },
            {
              "value": "410882",
              "area": "沁阳市"
            },
            {
              "value": "410883",
              "area": "孟州市"
            }
          ]
        },
        {
          "value": "410900",
          "city": "濮阳市",
          "dataList": [
            {
              "value": "410902",
              "area": "华龙区"
            },
            {
              "value": "410922",
              "area": "清丰县"
            },
            {
              "value": "410923",
              "area": "南乐县"
            },
            {
              "value": "410926",
              "area": "范　县"
            },
            {
              "value": "410927",
              "area": "台前县"
            },
            {
              "value": "410928",
              "area": "濮阳县"
            }
          ]
        },
        {
          "value": "411000",
          "city": "许昌市",
          "dataList": [
            {
              "value": "411002",
              "area": "魏都区"
            },
            {
              "value": "411023",
              "area": "许昌县"
            },
            {
              "value": "411024",
              "area": "鄢陵县"
            },
            {
              "value": "411025",
              "area": "襄城县"
            },
            {
              "value": "411081",
              "area": "禹州市"
            },
            {
              "value": "411082",
              "area": "长葛市"
            }
          ]
        },
        {
          "value": "411100",
          "city": "漯河市",
          "dataList": [
            {
              "value": "411102",
              "area": "源汇区"
            },
            {
              "value": "411103",
              "area": "郾城区"
            },
            {
              "value": "411104",
              "area": "召陵区"
            },
            {
              "value": "411121",
              "area": "舞阳县"
            },
            {
              "value": "411122",
              "area": "临颍县"
            }
          ]
        },
        {
          "value": "411200",
          "city": "三门峡市",
          "dataList": [
            {
              "value": "411202",
              "area": "湖滨区"
            },
            {
              "value": "411221",
              "area": "渑池县"
            },
            {
              "value": "411222",
              "area": "陕　县"
            },
            {
              "value": "411224",
              "area": "卢氏县"
            },
            {
              "value": "411281",
              "area": "义马市"
            },
            {
              "value": "411282",
              "area": "灵宝市"
            }
          ]
        },
        {
          "value": "411300",
          "city": "南阳市",
          "dataList": [
            {
              "value": "411302",
              "area": "宛城区"
            },
            {
              "value": "411303",
              "area": "卧龙区"
            },
            {
              "value": "411321",
              "area": "南召县"
            },
            {
              "value": "411322",
              "area": "方城县"
            },
            {
              "value": "411323",
              "area": "西峡县"
            },
            {
              "value": "411324",
              "area": "镇平县"
            },
            {
              "value": "411325",
              "area": "内乡县"
            },
            {
              "value": "411326",
              "area": "淅川县"
            },
            {
              "value": "411327",
              "area": "社旗县"
            },
            {
              "value": "411328",
              "area": "唐河县"
            },
            {
              "value": "411329",
              "area": "新野县"
            },
            {
              "value": "411330",
              "area": "桐柏县"
            },
            {
              "value": "411381",
              "area": "邓州市"
            }
          ]
        },
        {
          "value": "411400",
          "city": "商丘市",
          "dataList": [
            {
              "value": "411402",
              "area": "梁园区"
            },
            {
              "value": "411403",
              "area": "睢阳区"
            },
            {
              "value": "411421",
              "area": "民权县"
            },
            {
              "value": "411422",
              "area": "睢　县"
            },
            {
              "value": "411423",
              "area": "宁陵县"
            },
            {
              "value": "411424",
              "area": "柘城县"
            },
            {
              "value": "411425",
              "area": "虞城县"
            },
            {
              "value": "411426",
              "area": "夏邑县"
            },
            {
              "value": "411481",
              "area": "永城市"
            }
          ]
        },
        {
          "value": "411500",
          "city": "信阳市",
          "dataList": [
            {
              "value": "411502",
              "area": "浉河区"
            },
            {
              "value": "411503",
              "area": "平桥区"
            },
            {
              "value": "411521",
              "area": "罗山县"
            },
            {
              "value": "411522",
              "area": "光山县"
            },
            {
              "value": "411523",
              "area": "新　县"
            },
            {
              "value": "411524",
              "area": "商城县"
            },
            {
              "value": "411525",
              "area": "固始县"
            },
            {
              "value": "411526",
              "area": "潢川县"
            },
            {
              "value": "411527",
              "area": "淮滨县"
            },
            {
              "value": "411528",
              "area": "息　县"
            }
          ]
        },
        {
          "value": "411600",
          "city": "周口市",
          "dataList": [
            {
              "value": "411602",
              "area": "川汇区"
            },
            {
              "value": "411621",
              "area": "扶沟县"
            },
            {
              "value": "411622",
              "area": "西华县"
            },
            {
              "value": "411623",
              "area": "商水县"
            },
            {
              "value": "411624",
              "area": "沈丘县"
            },
            {
              "value": "411625",
              "area": "郸城县"
            },
            {
              "value": "411626",
              "area": "淮阳县"
            },
            {
              "value": "411627",
              "area": "太康县"
            },
            {
              "value": "411628",
              "area": "鹿邑县"
            },
            {
              "value": "411681",
              "area": "项城市"
            }
          ]
        },
        {
          "value": "411700",
          "city": "驻马店市",
          "dataList": [
            {
              "value": "411702",
              "area": "驿城区"
            },
            {
              "value": "411721",
              "area": "西平县"
            },
            {
              "value": "411722",
              "area": "上蔡县"
            },
            {
              "value": "411723",
              "area": "平舆县"
            },
            {
              "value": "411724",
              "area": "正阳县"
            },
            {
              "value": "411725",
              "area": "确山县"
            },
            {
              "value": "411726",
              "area": "泌阳县"
            },
            {
              "value": "411727",
              "area": "汝南县"
            },
            {
              "value": "411728",
              "area": "遂平县"
            },
            {
              "value": "411729",
              "area": "新蔡县"
            }
          ]
        },
        {
          "value": "419000",
          "city": "省直辖县级行政区划",
          "dataList": [
            {
              "value": "419001",
              "area": "济源市"
            }
          ]
        }
      ]
    },
    {
      "value": "420000",
      "province": "湖北省",
      "data": [
        {
          "value": "420100",
          "city": "武汉市",
          "dataList": [
            {
              "value": "420102",
              "area": "江岸区"
            },
            {
              "value": "420103",
              "area": "江汉区"
            },
            {
              "value": "420104",
              "area": "硚口区"
            },
            {
              "value": "420105",
              "area": "汉阳区"
            },
            {
              "value": "420106",
              "area": "武昌区"
            },
            {
              "value": "420107",
              "area": "青山区"
            },
            {
              "value": "420111",
              "area": "洪山区"
            },
            {
              "value": "420112",
              "area": "东西湖区"
            },
            {
              "value": "420113",
              "area": "汉南区"
            },
            {
              "value": "420114",
              "area": "蔡甸区"
            },
            {
              "value": "420115",
              "area": "江夏区"
            },
            {
              "value": "420116",
              "area": "黄陂区"
            },
            {
              "value": "420117",
              "area": "新洲区"
            }
          ]
        },
        {
          "value": "420200",
          "city": "黄石市",
          "dataList": [
            {
              "value": "420202",
              "area": "黄石港区"
            },
            {
              "value": "420203",
              "area": "西塞山区"
            },
            {
              "value": "420204",
              "area": "下陆区"
            },
            {
              "value": "420205",
              "area": "铁山区"
            },
            {
              "value": "420222",
              "area": "阳新县"
            },
            {
              "value": "420281",
              "area": "大冶市"
            }
          ]
        },
        {
          "value": "420300",
          "city": "十堰市",
          "dataList": [
            {
              "value": "420302",
              "area": "茅箭区"
            },
            {
              "value": "420303",
              "area": "张湾区"
            },
            {
              "value": "420304",
              "area": "郧阳区"
            },
            {
              "value": "420322",
              "area": "郧西县"
            },
            {
              "value": "420323",
              "area": "竹山县"
            },
            {
              "value": "420324",
              "area": "竹溪县"
            },
            {
              "value": "420325",
              "area": "房　县"
            },
            {
              "value": "420381",
              "area": "丹江口市"
            }
          ]
        },
        {
          "value": "420500",
          "city": "宜昌市",
          "dataList": [
            {
              "value": "420502",
              "area": "西陵区"
            },
            {
              "value": "420503",
              "area": "伍家岗区"
            },
            {
              "value": "420504",
              "area": "点军区"
            },
            {
              "value": "420505",
              "area": "猇亭区"
            },
            {
              "value": "420506",
              "area": "夷陵区"
            },
            {
              "value": "420525",
              "area": "远安县"
            },
            {
              "value": "420526",
              "area": "兴山县"
            },
            {
              "value": "420527",
              "area": "秭归县"
            },
            {
              "value": "420528",
              "area": "长阳土家族自治县"
            },
            {
              "value": "420529",
              "area": "五峰土家族自治县"
            },
            {
              "value": "420581",
              "area": "宜都市"
            },
            {
              "value": "420582",
              "area": "当阳市"
            },
            {
              "value": "420583",
              "area": "枝江市"
            }
          ]
        },
        {
          "value": "420600",
          "city": "襄阳市",
          "dataList": [
            {
              "value": "420602",
              "area": "襄城区"
            },
            {
              "value": "420606",
              "area": "樊城区"
            },
            {
              "value": "420607",
              "area": "襄州区"
            },
            {
              "value": "420624",
              "area": "南漳县"
            },
            {
              "value": "420625",
              "area": "谷城县"
            },
            {
              "value": "420626",
              "area": "保康县"
            },
            {
              "value": "420682",
              "area": "老河口市"
            },
            {
              "value": "420683",
              "area": "枣阳市"
            },
            {
              "value": "420684",
              "area": "宜城市"
            }
          ]
        },
        {
          "value": "420700",
          "city": "鄂州市",
          "dataList": [
            {
              "value": "420702",
              "area": "梁子湖区"
            },
            {
              "value": "420703",
              "area": "华容区"
            },
            {
              "value": "420704",
              "area": "鄂城区"
            }
          ]
        },
        {
          "value": "420800",
          "city": "荆门市",
          "dataList": [
            {
              "value": "420802",
              "area": "东宝区"
            },
            {
              "value": "420804",
              "area": "掇刀区"
            },
            {
              "value": "420821",
              "area": "京山县"
            },
            {
              "value": "420822",
              "area": "沙洋县"
            },
            {
              "value": "420881",
              "area": "钟祥市"
            }
          ]
        },
        {
          "value": "420900",
          "city": "孝感市",
          "dataList": [
            {
              "value": "420902",
              "area": "孝南区"
            },
            {
              "value": "420921",
              "area": "孝昌县"
            },
            {
              "value": "420922",
              "area": "大悟县"
            },
            {
              "value": "420923",
              "area": "云梦县"
            },
            {
              "value": "420981",
              "area": "应城市"
            },
            {
              "value": "420982",
              "area": "安陆市"
            },
            {
              "value": "420984",
              "area": "汉川市"
            }
          ]
        },
        {
          "value": "421000",
          "city": "荆州市",
          "dataList": [
            {
              "value": "421002",
              "area": "沙市区"
            },
            {
              "value": "421003",
              "area": "荆州区"
            },
            {
              "value": "421022",
              "area": "公安县"
            },
            {
              "value": "421023",
              "area": "监利县"
            },
            {
              "value": "421024",
              "area": "江陵县"
            },
            {
              "value": "421081",
              "area": "石首市"
            },
            {
              "value": "421083",
              "area": "洪湖市"
            },
            {
              "value": "421087",
              "area": "松滋市"
            }
          ]
        },
        {
          "value": "421100",
          "city": "黄冈市",
          "dataList": [
            {
              "value": "421102",
              "area": "黄州区"
            },
            {
              "value": "421121",
              "area": "团风县"
            },
            {
              "value": "421122",
              "area": "红安县"
            },
            {
              "value": "421123",
              "area": "罗田县"
            },
            {
              "value": "421124",
              "area": "英山县"
            },
            {
              "value": "421125",
              "area": "浠水县"
            },
            {
              "value": "421126",
              "area": "蕲春县"
            },
            {
              "value": "421127",
              "area": "黄梅县"
            },
            {
              "value": "421181",
              "area": "麻城市"
            },
            {
              "value": "421182",
              "area": "武穴市"
            }
          ]
        },
        {
          "value": "421200",
          "city": "咸宁市",
          "dataList": [
            {
              "value": "421202",
              "area": "咸安区"
            },
            {
              "value": "421221",
              "area": "嘉鱼县"
            },
            {
              "value": "421222",
              "area": "通城县"
            },
            {
              "value": "421223",
              "area": "崇阳县"
            },
            {
              "value": "421224",
              "area": "通山县"
            },
            {
              "value": "421281",
              "area": "赤壁市"
            }
          ]
        },
        {
          "value": "421300",
          "city": "随州市",
          "dataList": [
            {
              "value": "421302",
              "area": "曾都区"
            },
            {
              "value": "421321",
              "area": "随县"
            },
            {
              "value": "421381",
              "area": "广水市"
            }
          ]
        },
        {
          "value": "422800",
          "city": "恩施土家族苗族自治州",
          "dataList": [
            {
              "value": "422801",
              "area": "恩施市"
            },
            {
              "value": "422802",
              "area": "利川市"
            },
            {
              "value": "422822",
              "area": "建始县"
            },
            {
              "value": "422823",
              "area": "巴东县"
            },
            {
              "value": "422825",
              "area": "宣恩县"
            },
            {
              "value": "422826",
              "area": "咸丰县"
            },
            {
              "value": "422827",
              "area": "来凤县"
            },
            {
              "value": "422828",
              "area": "鹤峰县"
            }
          ]
        },
        {
          "value": "429000",
          "city": "省直辖县级行政区划",
          "dataList": [
            {
              "value": "429004",
              "area": "仙桃市"
            },
            {
              "value": "429005",
              "area": "潜江市"
            },
            {
              "value": "429006",
              "area": "天门市"
            },
            {
              "value": "429021",
              "area": "神农架林区"
            }
          ]
        }
      ]
    },
    {
      "value": "430000",
      "province": "湖南省",
      "data": [
        {
          "value": "430100",
          "city": "长沙市",
          "dataList": [
            {
              "value": "430102",
              "area": "芙蓉区"
            },
            {
              "value": "430103",
              "area": "天心区"
            },
            {
              "value": "430104",
              "area": "岳麓区"
            },
            {
              "value": "430105",
              "area": "开福区"
            },
            {
              "value": "430111",
              "area": "雨花区"
            },
            {
              "value": "430112",
              "area": "望城区"
            },
            {
              "value": "430121",
              "area": "长沙县"
            },
            {
              "value": "430124",
              "area": "宁乡县"
            },
            {
              "value": "430181",
              "area": "浏阳市"
            }
          ]
        },
        {
          "value": "430200",
          "city": "株洲市",
          "dataList": [
            {
              "value": "430202",
              "area": "荷塘区"
            },
            {
              "value": "430203",
              "area": "芦淞区"
            },
            {
              "value": "430204",
              "area": "石峰区"
            },
            {
              "value": "430211",
              "area": "天元区"
            },
            {
              "value": "430221",
              "area": "株洲县"
            },
            {
              "value": "430223",
              "area": "攸　县"
            },
            {
              "value": "430224",
              "area": "茶陵县"
            },
            {
              "value": "430225",
              "area": "炎陵县"
            },
            {
              "value": "430281",
              "area": "醴陵市"
            }
          ]
        },
        {
          "value": "430300",
          "city": "湘潭市",
          "dataList": [
            {
              "value": "430302",
              "area": "雨湖区"
            },
            {
              "value": "430304",
              "area": "岳塘区"
            },
            {
              "value": "430321",
              "area": "湘潭县"
            },
            {
              "value": "430381",
              "area": "湘乡市"
            },
            {
              "value": "430382",
              "area": "韶山市"
            }
          ]
        },
        {
          "value": "430400",
          "city": "衡阳市",
          "dataList": [
            {
              "value": "430405",
              "area": "珠晖区"
            },
            {
              "value": "430406",
              "area": "雁峰区"
            },
            {
              "value": "430407",
              "area": "石鼓区"
            },
            {
              "value": "430408",
              "area": "蒸湘区"
            },
            {
              "value": "430412",
              "area": "南岳区"
            },
            {
              "value": "430421",
              "area": "衡阳县"
            },
            {
              "value": "430422",
              "area": "衡南县"
            },
            {
              "value": "430423",
              "area": "衡山县"
            },
            {
              "value": "430424",
              "area": "衡东县"
            },
            {
              "value": "430426",
              "area": "祁东县"
            },
            {
              "value": "430481",
              "area": "耒阳市"
            },
            {
              "value": "430482",
              "area": "常宁市"
            }
          ]
        },
        {
          "value": "430500",
          "city": "邵阳市",
          "dataList": [
            {
              "value": "430502",
              "area": "双清区"
            },
            {
              "value": "430503",
              "area": "大祥区"
            },
            {
              "value": "430511",
              "area": "北塔区"
            },
            {
              "value": "430521",
              "area": "邵东县"
            },
            {
              "value": "430522",
              "area": "新邵县"
            },
            {
              "value": "430523",
              "area": "邵阳县"
            },
            {
              "value": "430524",
              "area": "隆回县"
            },
            {
              "value": "430525",
              "area": "洞口县"
            },
            {
              "value": "430527",
              "area": "绥宁县"
            },
            {
              "value": "430528",
              "area": "新宁县"
            },
            {
              "value": "430529",
              "area": "城步苗族自治县"
            },
            {
              "value": "430581",
              "area": "武冈市"
            }
          ]
        },
        {
          "value": "430600",
          "city": "岳阳市",
          "dataList": [
            {
              "value": "430602",
              "area": "岳阳楼区"
            },
            {
              "value": "430603",
              "area": "云溪区"
            },
            {
              "value": "430611",
              "area": "君山区"
            },
            {
              "value": "430621",
              "area": "岳阳县"
            },
            {
              "value": "430623",
              "area": "华容县"
            },
            {
              "value": "430624",
              "area": "湘阴县"
            },
            {
              "value": "430626",
              "area": "平江县"
            },
            {
              "value": "430681",
              "area": "汨罗市"
            },
            {
              "value": "430682",
              "area": "临湘市"
            }
          ]
        },
        {
          "value": "430700",
          "city": "常德市",
          "dataList": [
            {
              "value": "430702",
              "area": "武陵区"
            },
            {
              "value": "430703",
              "area": "鼎城区"
            },
            {
              "value": "430721",
              "area": "安乡县"
            },
            {
              "value": "430722",
              "area": "汉寿县"
            },
            {
              "value": "430723",
              "area": "澧　县"
            },
            {
              "value": "430724",
              "area": "临澧县"
            },
            {
              "value": "430725",
              "area": "桃源县"
            },
            {
              "value": "430726",
              "area": "石门县"
            },
            {
              "value": "430781",
              "area": "津市市"
            }
          ]
        },
        {
          "value": "430800",
          "city": "张家界市",
          "dataList": [
            {
              "value": "430802",
              "area": "永定区"
            },
            {
              "value": "430811",
              "area": "武陵源区"
            },
            {
              "value": "430821",
              "area": "慈利县"
            },
            {
              "value": "430822",
              "area": "桑植县"
            }
          ]
        },
        {
          "value": "430900",
          "city": "益阳市",
          "dataList": [
            {
              "value": "430902",
              "area": "资阳区"
            },
            {
              "value": "430903",
              "area": "赫山区"
            },
            {
              "value": "430921",
              "area": "南　县"
            },
            {
              "value": "430922",
              "area": "桃江县"
            },
            {
              "value": "430923",
              "area": "安化县"
            },
            {
              "value": "430981",
              "area": "沅江市"
            }
          ]
        },
        {
          "value": "431000",
          "city": "郴州市",
          "dataList": [
            {
              "value": "431002",
              "area": "北湖区"
            },
            {
              "value": "431003",
              "area": "苏仙区"
            },
            {
              "value": "431021",
              "area": "桂阳县"
            },
            {
              "value": "431022",
              "area": "宜章县"
            },
            {
              "value": "431023",
              "area": "永兴县"
            },
            {
              "value": "431024",
              "area": "嘉禾县"
            },
            {
              "value": "431025",
              "area": "临武县"
            },
            {
              "value": "431026",
              "area": "汝城县"
            },
            {
              "value": "431027",
              "area": "桂东县"
            },
            {
              "value": "431028",
              "area": "安仁县"
            },
            {
              "value": "431081",
              "area": "资兴市"
            }
          ]
        },
        {
          "value": "431100",
          "city": "永州市",
          "dataList": [
            {
              "value": "431102",
              "area": "零陵区"
            },
            {
              "value": "431103",
              "area": "冷水滩区"
            },
            {
              "value": "431121",
              "area": "祁阳县"
            },
            {
              "value": "431122",
              "area": "东安县"
            },
            {
              "value": "431123",
              "area": "双牌县"
            },
            {
              "value": "431124",
              "area": "道　县"
            },
            {
              "value": "431125",
              "area": "江永县"
            },
            {
              "value": "431126",
              "area": "宁远县"
            },
            {
              "value": "431127",
              "area": "蓝山县"
            },
            {
              "value": "431128",
              "area": "新田县"
            },
            {
              "value": "431129",
              "area": "江华瑶族自治县"
            }
          ]
        },
        {
          "value": "431200",
          "city": "怀化市",
          "dataList": [
            {
              "value": "431202",
              "area": "鹤城区"
            },
            {
              "value": "431221",
              "area": "中方县"
            },
            {
              "value": "431222",
              "area": "沅陵县"
            },
            {
              "value": "431223",
              "area": "辰溪县"
            },
            {
              "value": "431224",
              "area": "溆浦县"
            },
            {
              "value": "431225",
              "area": "会同县"
            },
            {
              "value": "431226",
              "area": "麻阳苗族自治县"
            },
            {
              "value": "431227",
              "area": "新晃侗族自治县"
            },
            {
              "value": "431228",
              "area": "芷江侗族自治县"
            },
            {
              "value": "431229",
              "area": "靖州苗族侗族自治县"
            },
            {
              "value": "431230",
              "area": "通道侗族自治县"
            },
            {
              "value": "431281",
              "area": "洪江市"
            }
          ]
        },
        {
          "value": "431300",
          "city": "娄底市",
          "dataList": [
            {
              "value": "431302",
              "area": "娄星区"
            },
            {
              "value": "431321",
              "area": "双峰县"
            },
            {
              "value": "431322",
              "area": "新化县"
            },
            {
              "value": "431381",
              "area": "冷水江市"
            },
            {
              "value": "431382",
              "area": "涟源市"
            }
          ]
        },
        {
          "value": "433100",
          "city": "湘西土家族苗族自治州",
          "dataList": [
            {
              "value": "433101",
              "area": "吉首市"
            },
            {
              "value": "433122",
              "area": "泸溪县"
            },
            {
              "value": "433123",
              "area": "凤凰县"
            },
            {
              "value": "433124",
              "area": "花垣县"
            },
            {
              "value": "433125",
              "area": "保靖县"
            },
            {
              "value": "433126",
              "area": "古丈县"
            },
            {
              "value": "433127",
              "area": "永顺县"
            },
            {
              "value": "433130",
              "area": "龙山县"
            }
          ]
        }
      ]
    },
    {
      "value": "440000",
      "province": "广东省",
      "data": [
        {
          "value": "440100",
          "city": "广州市",
          "dataList": [
            {
              "value": "440103",
              "area": "荔湾区"
            },
            {
              "value": "440104",
              "area": "越秀区"
            },
            {
              "value": "440105",
              "area": "海珠区"
            },
            {
              "value": "440106",
              "area": "天河区"
            },
            {
              "value": "440111",
              "area": "白云区"
            },
            {
              "value": "440112",
              "area": "黄埔区"
            },
            {
              "value": "440113",
              "area": "番禺区"
            },
            {
              "value": "440114",
              "area": "花都区"
            },
            {
              "value": "440115",
              "area": "南沙区"
            },
            {
              "value": "440117",
              "area": "萝岗区"
            },
            {
              "value": "440183",
              "area": "增城市"
            },
            {
              "value": "440184",
              "area": "从化区"
            }
          ]
        },
        {
          "value": "440200",
          "city": "韶关市",
          "dataList": [
            {
              "value": "440203",
              "area": "武江区"
            },
            {
              "value": "440204",
              "area": "浈江区"
            },
            {
              "value": "440205",
              "area": "曲江区"
            },
            {
              "value": "440222",
              "area": "始兴县"
            },
            {
              "value": "440224",
              "area": "仁化县"
            },
            {
              "value": "440229",
              "area": "翁源县"
            },
            {
              "value": "440232",
              "area": "乳源瑶族自治县"
            },
            {
              "value": "440233",
              "area": "新丰县"
            },
            {
              "value": "440281",
              "area": "乐昌市"
            },
            {
              "value": "440282",
              "area": "南雄市"
            }
          ]
        },
        {
          "value": "440300",
          "city": "深圳市",
          "dataList": [
            {
              "value": "440303",
              "area": "罗湖区"
            },
            {
              "value": "440304",
              "area": "福田区"
            },
            {
              "value": "440305",
              "area": "南山区"
            },
            {
              "value": "440306",
              "area": "宝安区"
            },
            {
              "value": "440307",
              "area": "龙岗区"
            },
            {
              "value": "440308",
              "area": "盐田区"
            },
            {
              "value": "440309",
              "area": "大鹏新区"
            },
            {
              "value": "440310",
              "area": "坪山新区"
            },
            {
              "value": "440311",
              "area": "光明新区"
            },
            {
              "value": "440312",
              "area": "龙华新区"
            }
          ]
        },
        {
          "value": "440400",
          "city": "珠海市",
          "dataList": [
            {
              "value": "440402",
              "area": "香洲区"
            },
            {
              "value": "440403",
              "area": "斗门区"
            },
            {
              "value": "440404",
              "area": "金湾区"
            }
          ]
        },
        {
          "value": "440500",
          "city": "汕头市",
          "dataList": [
            {
              "value": "440507",
              "area": "龙湖区"
            },
            {
              "value": "440511",
              "area": "金平区"
            },
            {
              "value": "440512",
              "area": "濠江区"
            },
            {
              "value": "440513",
              "area": "潮阳区"
            },
            {
              "value": "440514",
              "area": "潮南区"
            },
            {
              "value": "440515",
              "area": "澄海区"
            },
            {
              "value": "440523",
              "area": "南澳县"
            }
          ]
        },
        {
          "value": "440600",
          "city": "佛山市",
          "dataList": [
            {
              "value": "440604",
              "area": "禅城区"
            },
            {
              "value": "440605",
              "area": "南海区"
            },
            {
              "value": "440606",
              "area": "顺德区"
            },
            {
              "value": "440607",
              "area": "三水区"
            },
            {
              "value": "440608",
              "area": "高明区"
            }
          ]
        },
        {
          "value": "440700",
          "city": "江门市",
          "dataList": [
            {
              "value": "440703",
              "area": "蓬江区"
            },
            {
              "value": "440704",
              "area": "江海区"
            },
            {
              "value": "440705",
              "area": "新会区"
            },
            {
              "value": "440781",
              "area": "台山市"
            },
            {
              "value": "440783",
              "area": "开平市"
            },
            {
              "value": "440784",
              "area": "鹤山市"
            },
            {
              "value": "440785",
              "area": "恩平市"
            }
          ]
        },
        {
          "value": "440800",
          "city": "湛江市",
          "dataList": [
            {
              "value": "440802",
              "area": "赤坎区"
            },
            {
              "value": "440803",
              "area": "霞山区"
            },
            {
              "value": "440804",
              "area": "坡头区"
            },
            {
              "value": "440811",
              "area": "麻章区"
            },
            {
              "value": "440823",
              "area": "遂溪县"
            },
            {
              "value": "440825",
              "area": "徐闻县"
            },
            {
              "value": "440881",
              "area": "廉江市"
            },
            {
              "value": "440882",
              "area": "雷州市"
            },
            {
              "value": "440883",
              "area": "吴川市"
            },
            {
              "value": "440890",
              "area": "经济技术开发区"
            }
          ]
        },
        {
          "value": "440900",
          "city": "茂名市",
          "dataList": [
            {
              "value": "440902",
              "area": "茂南区"
            },
            {
              "value": "440903",
              "area": "茂港区"
            },
            {
              "value": "440923",
              "area": "电白县"
            },
            {
              "value": "440981",
              "area": "高州市"
            },
            {
              "value": "440982",
              "area": "化州市"
            },
            {
              "value": "440983",
              "area": "信宜市"
            }
          ]
        },
        {
          "value": "441200",
          "city": "肇庆市",
          "dataList": [
            {
              "value": "441202",
              "area": "端州区"
            },
            {
              "value": "441203",
              "area": "鼎湖区"
            },
            {
              "value": "441204",
              "area": "高要区"
            },
            {
              "value": "441223",
              "area": "广宁县"
            },
            {
              "value": "441224",
              "area": "怀集县"
            },
            {
              "value": "441225",
              "area": "封开县"
            },
            {
              "value": "441226",
              "area": "德庆县"
            },
            {
              "value": "441284",
              "area": "四会市"
            }
          ]
        },
        {
          "value": "441300",
          "city": "惠州市",
          "dataList": [
            {
              "value": "441302",
              "area": "惠城区"
            },
            {
              "value": "441303",
              "area": "惠阳区"
            },
            {
              "value": "441322",
              "area": "博罗县"
            },
            {
              "value": "441323",
              "area": "惠东县"
            },
            {
              "value": "441324",
              "area": "龙门县"
            },
            {
              "value": "441326",
              "area": "大亚湾区"
            }
          ]
        },
        {
          "value": "441400",
          "city": "梅州市",
          "dataList": [
            {
              "value": "441402",
              "area": "梅江区"
            },
            {
              "value": "441421",
              "area": "梅　县"
            },
            {
              "value": "441422",
              "area": "大埔县"
            },
            {
              "value": "441423",
              "area": "丰顺县"
            },
            {
              "value": "441424",
              "area": "五华县"
            },
            {
              "value": "441426",
              "area": "平远县"
            },
            {
              "value": "441427",
              "area": "蕉岭县"
            },
            {
              "value": "441481",
              "area": "兴宁市"
            }
          ]
        },
        {
          "value": "441500",
          "city": "汕尾市",
          "dataList": [
            {
              "value": "441502",
              "area": "城　区"
            },
            {
              "value": "441521",
              "area": "海丰县"
            },
            {
              "value": "441523",
              "area": "陆河县"
            },
            {
              "value": "441581",
              "area": "陆丰市"
            }
          ]
        },
        {
          "value": "441600",
          "city": "河源市",
          "dataList": [
            {
              "value": "441602",
              "area": "源城区"
            },
            {
              "value": "441621",
              "area": "紫金县"
            },
            {
              "value": "441622",
              "area": "龙川县"
            },
            {
              "value": "441623",
              "area": "连平县"
            },
            {
              "value": "441624",
              "area": "和平县"
            },
            {
              "value": "441625",
              "area": "东源县"
            }
          ]
        },
        {
          "value": "441700",
          "city": "阳江市",
          "dataList": [
            {
              "value": "441702",
              "area": "江城区"
            },
            {
              "value": "441704",
              "area": "阳东区"
            },
            {
              "value": "441721",
              "area": "阳西县"
            },
            {
              "value": "441781",
              "area": "阳春市"
            }
          ]
        },
        {
          "value": "441800",
          "city": "清远市",
          "dataList": [
            {
              "value": "441802",
              "area": "清城区"
            },
            {
              "value": "441803",
              "area": "清新区"
            },
            {
              "value": "441821",
              "area": "佛冈县"
            },
            {
              "value": "441823",
              "area": "阳山县"
            },
            {
              "value": "441825",
              "area": "连山壮族瑶族自治县"
            },
            {
              "value": "441826",
              "area": "连南瑶族自治县"
            },
            {
              "value": "441881",
              "area": "英德市"
            },
            {
              "value": "441882",
              "area": "连州市"
            }
          ]
        },
        {
          "value": "441900",
          "city": "东莞市",
          "dataList": [
            {
              "value": "659005",
              "area": "莞城区"
            },
            {
              "value": "659006",
              "area": "南城区"
            },
            {
              "value": "659007",
              "area": "东城区"
            },
            {
              "value": "659008",
              "area": "万江区"
            },
            {
              "value": "659009",
              "area": "石碣镇"
            },
            {
              "value": "659010",
              "area": "石龙镇"
            },
            {
              "value": "659011",
              "area": "茶山镇"
            },
            {
              "value": "659012",
              "area": "石排镇"
            },
            {
              "value": "659013",
              "area": "企石镇"
            },
            {
              "value": "659014",
              "area": "横沥镇"
            },
            {
              "value": "659015",
              "area": "桥头镇"
            },
            {
              "value": "659016",
              "area": "谢岗镇"
            },
            {
              "value": "659017",
              "area": "东坑镇"
            },
            {
              "value": "659018",
              "area": "常平镇"
            },
            {
              "value": "659019",
              "area": "寮步镇"
            },
            {
              "value": "659020",
              "area": "大朗镇"
            },
            {
              "value": "659021",
              "area": "黄江镇"
            },
            {
              "value": "659022",
              "area": "清溪镇"
            },
            {
              "value": "659023",
              "area": "塘厦镇"
            },
            {
              "value": "659024",
              "area": "凤岗镇"
            },
            {
              "value": "659025",
              "area": "长安镇"
            },
            {
              "value": "659026",
              "area": "虎门镇"
            },
            {
              "value": "659027",
              "area": "厚街镇"
            },
            {
              "value": "659028",
              "area": "沙田镇"
            },
            {
              "value": "659029",
              "area": "道滘镇"
            },
            {
              "value": "659030",
              "area": "洪梅镇"
            },
            {
              "value": "659031",
              "area": "麻涌镇"
            },
            {
              "value": "659032",
              "area": "中堂镇"
            },
            {
              "value": "659033",
              "area": "高埗镇"
            },
            {
              "value": "659034",
              "area": "樟木头镇"
            },
            {
              "value": "659035",
              "area": "大岭山镇"
            },
            {
              "value": "659036",
              "area": "望牛墩镇"
            }
          ]
        },
        {
          "value": "442000",
          "city": "中山市",
          "dataList": [
            {
              "value": "442001",
              "area": "石岐区街道"
            },
            {
              "value": "442002",
              "area": "东区街道"
            },
            {
              "value": "442003",
              "area": "火炬开发区"
            },
            {
              "value": "442004",
              "area": "西区街道"
            },
            {
              "value": "442005",
              "area": "南区街道"
            },
            {
              "value": "442006",
              "area": "五桂山街道"
            },
            {
              "value": "659037",
              "area": "板芙镇"
            },
            {
              "value": "659038",
              "area": "大涌镇"
            },
            {
              "value": "659039",
              "area": "东凤镇"
            },
            {
              "value": "659040",
              "area": "东升镇"
            },
            {
              "value": "659041",
              "area": "阜沙镇"
            },
            {
              "value": "659042",
              "area": "港口镇"
            },
            {
              "value": "659043",
              "area": "古镇"
            },
            {
              "value": "659044",
              "area": "横栏镇"
            },
            {
              "value": "659045",
              "area": "黄圃镇"
            },
            {
              "value": "659046",
              "area": "民众镇"
            },
            {
              "value": "659047",
              "area": "南朗镇"
            },
            {
              "value": "659048",
              "area": "南头镇"
            },
            {
              "value": "659049",
              "area": "三角镇"
            },
            {
              "value": "659050",
              "area": "三乡镇"
            },
            {
              "value": "659051",
              "area": "沙溪镇"
            },
            {
              "value": "659052",
              "area": "神湾镇"
            },
            {
              "value": "659053",
              "area": "坦洲镇"
            },
            {
              "value": "659054",
              "area": "小榄镇"
            }
          ]
        },
        {
          "value": "445100",
          "city": "潮州市",
          "dataList": [
            {
              "value": "445102",
              "area": "湘桥区"
            },
            {
              "value": "445103",
              "area": "潮安区"
            },
            {
              "value": "445104",
              "area": "枫溪区"
            },
            {
              "value": "445122",
              "area": "饶平县"
            }
          ]
        },
        {
          "value": "445200",
          "city": "揭阳市",
          "dataList": [
            {
              "value": "445202",
              "area": "榕城区"
            },
            {
              "value": "445221",
              "area": "揭东区"
            },
            {
              "value": "445222",
              "area": "揭西县"
            },
            {
              "value": "445224",
              "area": "惠来县"
            },
            {
              "value": "445281",
              "area": "普宁市"
            }
          ]
        },
        {
          "value": "445300",
          "city": "云浮市",
          "dataList": [
            {
              "value": "445302",
              "area": "云城区"
            },
            {
              "value": "445303",
              "area": "云安区"
            },
            {
              "value": "445321",
              "area": "新兴县"
            },
            {
              "value": "445322",
              "area": "郁南县"
            },
            {
              "value": "445381",
              "area": "罗定市"
            }
          ]
        }
      ]
    },
    {
      "value": "450000",
      "province": "广西壮族自治区",
      "data": [
        {
          "value": "450100",
          "city": "南宁市",
          "dataList": [
            {
              "value": "450102",
              "area": "兴宁区"
            },
            {
              "value": "450103",
              "area": "青秀区"
            },
            {
              "value": "450105",
              "area": "江南区"
            },
            {
              "value": "450107",
              "area": "西乡塘区"
            },
            {
              "value": "450108",
              "area": "良庆区"
            },
            {
              "value": "450109",
              "area": "邕宁区"
            },
            {
              "value": "450122",
              "area": "武鸣县"
            },
            {
              "value": "450123",
              "area": "隆安县"
            },
            {
              "value": "450124",
              "area": "马山县"
            },
            {
              "value": "450125",
              "area": "上林县"
            },
            {
              "value": "450126",
              "area": "宾阳县"
            },
            {
              "value": "450127",
              "area": "横　县"
            }
          ]
        },
        {
          "value": "450200",
          "city": "柳州市",
          "dataList": [
            {
              "value": "450202",
              "area": "城中区"
            },
            {
              "value": "450203",
              "area": "鱼峰区"
            },
            {
              "value": "450204",
              "area": "柳南区"
            },
            {
              "value": "450205",
              "area": "柳北区"
            },
            {
              "value": "450221",
              "area": "柳江县"
            },
            {
              "value": "450222",
              "area": "柳城县"
            },
            {
              "value": "450223",
              "area": "鹿寨县"
            },
            {
              "value": "450224",
              "area": "融安县"
            },
            {
              "value": "450225",
              "area": "融水苗族自治县"
            },
            {
              "value": "450226",
              "area": "三江侗族自治县"
            }
          ]
        },
        {
          "value": "450300",
          "city": "桂林市",
          "dataList": [
            {
              "value": "450302",
              "area": "秀峰区"
            },
            {
              "value": "450303",
              "area": "叠彩区"
            },
            {
              "value": "450304",
              "area": "象山区"
            },
            {
              "value": "450305",
              "area": "七星区"
            },
            {
              "value": "450311",
              "area": "雁山区"
            },
            {
              "value": "450321",
              "area": "阳朔县"
            },
            {
              "value": "450322",
              "area": "临桂区"
            },
            {
              "value": "450323",
              "area": "灵川县"
            },
            {
              "value": "450324",
              "area": "全州县"
            },
            {
              "value": "450325",
              "area": "兴安县"
            },
            {
              "value": "450326",
              "area": "永福县"
            },
            {
              "value": "450327",
              "area": "灌阳县"
            },
            {
              "value": "450328",
              "area": "龙胜各族自治县"
            },
            {
              "value": "450329",
              "area": "资源县"
            },
            {
              "value": "450330",
              "area": "平乐县"
            },
            {
              "value": "450331",
              "area": "荔蒲县"
            },
            {
              "value": "450332",
              "area": "恭城瑶族自治县"
            }
          ]
        },
        {
          "value": "450400",
          "city": "梧州市",
          "dataList": [
            {
              "value": "450403",
              "area": "万秀区"
            },
            {
              "value": "450405",
              "area": "长洲区"
            },
            {
              "value": "450406",
              "area": "龙圩区"
            },
            {
              "value": "450421",
              "area": "苍梧县"
            },
            {
              "value": "450422",
              "area": "藤　县"
            },
            {
              "value": "450423",
              "area": "蒙山县"
            },
            {
              "value": "450481",
              "area": "岑溪市"
            }
          ]
        },
        {
          "value": "450500",
          "city": "北海市",
          "dataList": [
            {
              "value": "450502",
              "area": "海城区"
            },
            {
              "value": "450503",
              "area": "银海区"
            },
            {
              "value": "450512",
              "area": "铁山港区"
            },
            {
              "value": "450521",
              "area": "合浦县"
            }
          ]
        },
        {
          "value": "450600",
          "city": "防城港市",
          "dataList": [
            {
              "value": "450602",
              "area": "港口区"
            },
            {
              "value": "450603",
              "area": "防城区"
            },
            {
              "value": "450621",
              "area": "上思县"
            },
            {
              "value": "450681",
              "area": "东兴市"
            }
          ]
        },
        {
          "value": "450700",
          "city": "钦州市",
          "dataList": [
            {
              "value": "450702",
              "area": "钦南区"
            },
            {
              "value": "450703",
              "area": "钦北区"
            },
            {
              "value": "450721",
              "area": "灵山县"
            },
            {
              "value": "450722",
              "area": "浦北县"
            }
          ]
        },
        {
          "value": "450800",
          "city": "贵港市",
          "dataList": [
            {
              "value": "450802",
              "area": "港北区"
            },
            {
              "value": "450803",
              "area": "港南区"
            },
            {
              "value": "450804",
              "area": "覃塘区"
            },
            {
              "value": "450821",
              "area": "平南县"
            },
            {
              "value": "450881",
              "area": "桂平市"
            }
          ]
        },
        {
          "value": "450900",
          "city": "玉林市",
          "dataList": [
            {
              "value": "450902",
              "area": "玉州区"
            },
            {
              "value": "450903",
              "area": "福绵区"
            },
            {
              "value": "450921",
              "area": "容　县"
            },
            {
              "value": "450922",
              "area": "陆川县"
            },
            {
              "value": "450923",
              "area": "博白县"
            },
            {
              "value": "450924",
              "area": "兴业县"
            },
            {
              "value": "450981",
              "area": "北流市"
            }
          ]
        },
        {
          "value": "451000",
          "city": "百色市",
          "dataList": [
            {
              "value": "451002",
              "area": "右江区"
            },
            {
              "value": "451021",
              "area": "田阳县"
            },
            {
              "value": "451022",
              "area": "田东县"
            },
            {
              "value": "451023",
              "area": "平果县"
            },
            {
              "value": "451024",
              "area": "德保县"
            },
            {
              "value": "451025",
              "area": "靖西市"
            },
            {
              "value": "451026",
              "area": "那坡县"
            },
            {
              "value": "451027",
              "area": "凌云县"
            },
            {
              "value": "451028",
              "area": "乐业县"
            },
            {
              "value": "451029",
              "area": "田林县"
            },
            {
              "value": "451030",
              "area": "西林县"
            },
            {
              "value": "451031",
              "area": "隆林各族自治县"
            }
          ]
        },
        {
          "value": "451100",
          "city": "贺州市",
          "dataList": [
            {
              "value": "451102",
              "area": "八步区"
            },
            {
              "value": "451121",
              "area": "昭平县"
            },
            {
              "value": "451122",
              "area": "钟山县"
            },
            {
              "value": "451123",
              "area": "富川瑶族自治县"
            }
          ]
        },
        {
          "value": "451200",
          "city": "河池市",
          "dataList": [
            {
              "value": "451202",
              "area": "金城江区"
            },
            {
              "value": "451221",
              "area": "南丹县"
            },
            {
              "value": "451222",
              "area": "天峨县"
            },
            {
              "value": "451223",
              "area": "凤山县"
            },
            {
              "value": "451224",
              "area": "东兰县"
            },
            {
              "value": "451225",
              "area": "罗城仫佬族自治县"
            },
            {
              "value": "451226",
              "area": "环江毛南族自治县"
            },
            {
              "value": "451227",
              "area": "巴马瑶族自治县"
            },
            {
              "value": "451228",
              "area": "都安瑶族自治县"
            },
            {
              "value": "451229",
              "area": "大化瑶族自治县"
            },
            {
              "value": "451281",
              "area": "宜州市"
            }
          ]
        },
        {
          "value": "451300",
          "city": "来宾市",
          "dataList": [
            {
              "value": "451302",
              "area": "兴宾区"
            },
            {
              "value": "451321",
              "area": "忻城县"
            },
            {
              "value": "451322",
              "area": "象州县"
            },
            {
              "value": "451323",
              "area": "武宣县"
            },
            {
              "value": "451324",
              "area": "金秀瑶族自治县"
            },
            {
              "value": "451381",
              "area": "合山市"
            }
          ]
        },
        {
          "value": "451400",
          "city": "崇左市",
          "dataList": [
            {
              "value": "451402",
              "area": "江洲区"
            },
            {
              "value": "451421",
              "area": "扶绥县"
            },
            {
              "value": "451422",
              "area": "宁明县"
            },
            {
              "value": "451423",
              "area": "龙州县"
            },
            {
              "value": "451424",
              "area": "大新县"
            },
            {
              "value": "451425",
              "area": "天等县"
            },
            {
              "value": "451481",
              "area": "凭祥市"
            }
          ]
        }
      ]
    },
    {
      "value": "460000",
      "province": "海南省",
      "data": [
        {
          "value": "460100",
          "city": "海口市",
          "dataList": [
            {
              "value": "460105",
              "area": "秀英区"
            },
            {
              "value": "460106",
              "area": "龙华区"
            },
            {
              "value": "460107",
              "area": "琼山区"
            },
            {
              "value": "460108",
              "area": "美兰区"
            }
          ]
        },
        {
          "value": "460200",
          "city": "三亚市",
          "dataList": [
            {
              "value": "659055",
              "area": "吉阳区"
            },
            {
              "value": "659056",
              "area": "天涯区"
            },
            {
              "value": "659057",
              "area": "崖州区"
            },
            {
              "value": "659058",
              "area": "海棠区"
            }
          ]
        },
        {
          "value": "460300",
          "city": "三沙市",
          "dataList": [
            {
              "value": "460321",
              "area": "西沙群岛"
            },
            {
              "value": "460322",
              "area": "南沙群岛"
            },
            {
              "value": "460323",
              "area": "中沙群岛的岛礁及其海域"
            }
          ]
        },
        {
          "value": "469000",
          "city": "省直辖县级行政区划",
          "dataList": [
            {
              "value": "469001",
              "area": "五指山市"
            },
            {
              "value": "469002",
              "area": "琼海市"
            },
            {
              "value": "469003",
              "area": "儋州市"
            },
            {
              "value": "469005",
              "area": "文昌市"
            },
            {
              "value": "469006",
              "area": "万宁市"
            },
            {
              "value": "469007",
              "area": "东方市"
            },
            {
              "value": "469021",
              "area": "定安县"
            },
            {
              "value": "469022",
              "area": "屯昌县"
            },
            {
              "value": "469023",
              "area": "澄迈县"
            },
            {
              "value": "469024",
              "area": "临高县"
            },
            {
              "value": "469025",
              "area": "白沙黎族自治县"
            },
            {
              "value": "469026",
              "area": "昌江黎族自治县"
            },
            {
              "value": "469027",
              "area": "乐东黎族自治县"
            },
            {
              "value": "469028",
              "area": "陵水黎族自治县"
            },
            {
              "value": "469029",
              "area": "保亭黎族苗族自治县"
            },
            {
              "value": "469030",
              "area": "琼中黎族苗族自治县"
            }
          ]
        }
      ]
    },
    {
      "value": "500000",
      "province": "重庆市",
      "data": [
        {
          "value": "500100",
          "city": "重庆市",
          "dataList": [
            {
              "value": "500101",
              "area": "万州区"
            },
            {
              "value": "500102",
              "area": "涪陵区"
            },
            {
              "value": "500103",
              "area": "渝中区"
            },
            {
              "value": "500104",
              "area": "大渡口区"
            },
            {
              "value": "500105",
              "area": "江北区"
            },
            {
              "value": "500106",
              "area": "沙坪坝区"
            },
            {
              "value": "500107",
              "area": "九龙坡区"
            },
            {
              "value": "500108",
              "area": "南岸区"
            },
            {
              "value": "500109",
              "area": "北碚区"
            },
            {
              "value": "500110",
              "area": "綦江区"
            },
            {
              "value": "500111",
              "area": "大足区"
            },
            {
              "value": "500112",
              "area": "渝北区"
            },
            {
              "value": "500113",
              "area": "巴南区"
            },
            {
              "value": "500114",
              "area": "黔江区"
            },
            {
              "value": "500115",
              "area": "长寿区"
            },
            {
              "value": "500116",
              "area": "江津区"
            },
            {
              "value": "500117",
              "area": "合川区"
            },
            {
              "value": "500118",
              "area": "永川区"
            },
            {
              "value": "500119",
              "area": "南川区"
            },
            {
              "value": "500120",
              "area": "璧山区"
            },
            {
              "value": "500223",
              "area": "潼南区"
            },
            {
              "value": "500224",
              "area": "铜梁区"
            },
            {
              "value": "500226",
              "area": "荣昌区"
            },
            {
              "value": "500228",
              "area": "梁平县"
            },
            {
              "value": "500229",
              "area": "城口县"
            },
            {
              "value": "500230",
              "area": "丰都县"
            },
            {
              "value": "500231",
              "area": "垫江县"
            },
            {
              "value": "500232",
              "area": "武隆县"
            },
            {
              "value": "500233",
              "area": "忠　县"
            },
            {
              "value": "500234",
              "area": "开　县"
            },
            {
              "value": "500235",
              "area": "云阳县"
            },
            {
              "value": "500236",
              "area": "奉节县"
            },
            {
              "value": "500237",
              "area": "巫山县"
            },
            {
              "value": "500238",
              "area": "巫溪县"
            },
            {
              "value": "500240",
              "area": "石柱土家族自治县"
            },
            {
              "value": "500241",
              "area": "秀山土家族苗族自治县"
            },
            {
              "value": "500242",
              "area": "酉阳土家族苗族自治县"
            },
            {
              "value": "500243",
              "area": "彭水苗族土家族自治县"
            }
          ]
        }
      ]
    },
    {
      "value": "510000",
      "province": "四川省",
      "data": [
        {
          "value": "510100",
          "city": "成都市",
          "dataList": [
            {
              "value": "510104",
              "area": "锦江区"
            },
            {
              "value": "510105",
              "area": "青羊区"
            },
            {
              "value": "510106",
              "area": "金牛区"
            },
            {
              "value": "510107",
              "area": "武侯区"
            },
            {
              "value": "510108",
              "area": "成华区"
            },
            {
              "value": "510112",
              "area": "龙泉驿区"
            },
            {
              "value": "510113",
              "area": "青白江区"
            },
            {
              "value": "510114",
              "area": "新都区"
            },
            {
              "value": "510115",
              "area": "温江区"
            },
            {
              "value": "510121",
              "area": "金堂县"
            },
            {
              "value": "510122",
              "area": "双流县"
            },
            {
              "value": "510124",
              "area": "郫　县"
            },
            {
              "value": "510129",
              "area": "大邑县"
            },
            {
              "value": "510131",
              "area": "蒲江县"
            },
            {
              "value": "510132",
              "area": "新津县"
            },
            {
              "value": "510181",
              "area": "都江堰市"
            },
            {
              "value": "510182",
              "area": "彭州市"
            },
            {
              "value": "510183",
              "area": "邛崃市"
            },
            {
              "value": "510184",
              "area": "崇州市"
            }
          ]
        },
        {
          "value": "510300",
          "city": "自贡市",
          "dataList": [
            {
              "value": "510302",
              "area": "自流井区"
            },
            {
              "value": "510303",
              "area": "贡井区"
            },
            {
              "value": "510304",
              "area": "大安区"
            },
            {
              "value": "510311",
              "area": "沿滩区"
            },
            {
              "value": "510321",
              "area": "荣　县"
            },
            {
              "value": "510322",
              "area": "富顺县"
            }
          ]
        },
        {
          "value": "510400",
          "city": "攀枝花市",
          "dataList": [
            {
              "value": "510402",
              "area": "东　区"
            },
            {
              "value": "510403",
              "area": "西　区"
            },
            {
              "value": "510411",
              "area": "仁和区"
            },
            {
              "value": "510421",
              "area": "米易县"
            },
            {
              "value": "510422",
              "area": "盐边县"
            }
          ]
        },
        {
          "value": "510500",
          "city": "泸州市",
          "dataList": [
            {
              "value": "510502",
              "area": "江阳区"
            },
            {
              "value": "510503",
              "area": "纳溪区"
            },
            {
              "value": "510504",
              "area": "龙马潭区"
            },
            {
              "value": "510521",
              "area": "泸　县"
            },
            {
              "value": "510522",
              "area": "合江县"
            },
            {
              "value": "510524",
              "area": "叙永县"
            },
            {
              "value": "510525",
              "area": "古蔺县"
            }
          ]
        },
        {
          "value": "510600",
          "city": "德阳市",
          "dataList": [
            {
              "value": "510603",
              "area": "旌阳区"
            },
            {
              "value": "510623",
              "area": "中江县"
            },
            {
              "value": "510626",
              "area": "罗江县"
            },
            {
              "value": "510681",
              "area": "广汉市"
            },
            {
              "value": "510682",
              "area": "什邡市"
            },
            {
              "value": "510683",
              "area": "绵竹市"
            }
          ]
        },
        {
          "value": "510700",
          "city": "绵阳市",
          "dataList": [
            {
              "value": "510703",
              "area": "涪城区"
            },
            {
              "value": "510704",
              "area": "游仙区"
            },
            {
              "value": "510722",
              "area": "三台县"
            },
            {
              "value": "510723",
              "area": "盐亭县"
            },
            {
              "value": "510724",
              "area": "安　县"
            },
            {
              "value": "510725",
              "area": "梓潼县"
            },
            {
              "value": "510726",
              "area": "北川羌族自治县"
            },
            {
              "value": "510727",
              "area": "平武县"
            },
            {
              "value": "510781",
              "area": "江油市"
            }
          ]
        },
        {
          "value": "510800",
          "city": "广元市",
          "dataList": [
            {
              "value": "510802",
              "area": "利州区"
            },
            {
              "value": "510811",
              "area": "昭化区"
            },
            {
              "value": "510812",
              "area": "朝天区"
            },
            {
              "value": "510821",
              "area": "旺苍县"
            },
            {
              "value": "510822",
              "area": "青川县"
            },
            {
              "value": "510823",
              "area": "剑阁县"
            },
            {
              "value": "510824",
              "area": "苍溪县"
            }
          ]
        },
        {
          "value": "510900",
          "city": "遂宁市",
          "dataList": [
            {
              "value": "510903",
              "area": "船山区"
            },
            {
              "value": "510904",
              "area": "安居区"
            },
            {
              "value": "510921",
              "area": "蓬溪县"
            },
            {
              "value": "510922",
              "area": "射洪县"
            },
            {
              "value": "510923",
              "area": "大英县"
            }
          ]
        },
        {
          "value": "511000",
          "city": "内江市",
          "dataList": [
            {
              "value": "511002",
              "area": "市中区"
            },
            {
              "value": "511011",
              "area": "东兴区"
            },
            {
              "value": "511024",
              "area": "威远县"
            },
            {
              "value": "511025",
              "area": "资中县"
            },
            {
              "value": "511028",
              "area": "隆昌县"
            }
          ]
        },
        {
          "value": "511100",
          "city": "乐山市",
          "dataList": [
            {
              "value": "511102",
              "area": "市中区"
            },
            {
              "value": "511111",
              "area": "沙湾区"
            },
            {
              "value": "511112",
              "area": "五通桥区"
            },
            {
              "value": "511113",
              "area": "金口河区"
            },
            {
              "value": "511123",
              "area": "犍为县"
            },
            {
              "value": "511124",
              "area": "井研县"
            },
            {
              "value": "511126",
              "area": "夹江县"
            },
            {
              "value": "511129",
              "area": "沐川县"
            },
            {
              "value": "511132",
              "area": "峨边彝族自治县"
            },
            {
              "value": "511133",
              "area": "马边彝族自治县"
            },
            {
              "value": "511181",
              "area": "峨眉山市"
            }
          ]
        },
        {
          "value": "511300",
          "city": "南充市",
          "dataList": [
            {
              "value": "511302",
              "area": "顺庆区"
            },
            {
              "value": "511303",
              "area": "高坪区"
            },
            {
              "value": "511304",
              "area": "嘉陵区"
            },
            {
              "value": "511321",
              "area": "南部县"
            },
            {
              "value": "511322",
              "area": "营山县"
            },
            {
              "value": "511323",
              "area": "蓬安县"
            },
            {
              "value": "511324",
              "area": "仪陇县"
            },
            {
              "value": "511325",
              "area": "西充县"
            },
            {
              "value": "511381",
              "area": "阆中市"
            }
          ]
        },
        {
          "value": "511400",
          "city": "眉山市",
          "dataList": [
            {
              "value": "511402",
              "area": "东坡区"
            },
            {
              "value": "511403",
              "area": "彭山区"
            },
            {
              "value": "511421",
              "area": "仁寿县"
            },
            {
              "value": "511423",
              "area": "洪雅县"
            },
            {
              "value": "511424",
              "area": "丹棱县"
            },
            {
              "value": "511425",
              "area": "青神县"
            }
          ]
        },
        {
          "value": "511500",
          "city": "宜宾市",
          "dataList": [
            {
              "value": "511502",
              "area": "翠屏区"
            },
            {
              "value": "511503",
              "area": "南溪区"
            },
            {
              "value": "511521",
              "area": "宜宾县"
            },
            {
              "value": "511523",
              "area": "江安县"
            },
            {
              "value": "511524",
              "area": "长宁县"
            },
            {
              "value": "511525",
              "area": "高　县"
            },
            {
              "value": "511526",
              "area": "珙　县"
            },
            {
              "value": "511527",
              "area": "筠连县"
            },
            {
              "value": "511528",
              "area": "兴文县"
            },
            {
              "value": "511529",
              "area": "屏山县"
            }
          ]
        },
        {
          "value": "511600",
          "city": "广安市",
          "dataList": [
            {
              "value": "511602",
              "area": "广安区"
            },
            {
              "value": "511603",
              "area": "前锋区"
            },
            {
              "value": "511621",
              "area": "岳池县"
            },
            {
              "value": "511622",
              "area": "武胜县"
            },
            {
              "value": "511623",
              "area": "邻水县"
            },
            {
              "value": "511681",
              "area": "华蓥市"
            }
          ]
        },
        {
          "value": "511700",
          "city": "达州市",
          "dataList": [
            {
              "value": "511702",
              "area": "通川区"
            },
            {
              "value": "511703",
              "area": "达川区"
            },
            {
              "value": "511722",
              "area": "宣汉县"
            },
            {
              "value": "511723",
              "area": "开江县"
            },
            {
              "value": "511724",
              "area": "大竹县"
            },
            {
              "value": "511725",
              "area": "渠　县"
            },
            {
              "value": "511781",
              "area": "万源市"
            }
          ]
        },
        {
          "value": "511800",
          "city": "雅安市",
          "dataList": [
            {
              "value": "511802",
              "area": "雨城区"
            },
            {
              "value": "511803",
              "area": "名山区"
            },
            {
              "value": "511822",
              "area": "荥经县"
            },
            {
              "value": "511823",
              "area": "汉源县"
            },
            {
              "value": "511824",
              "area": "石棉县"
            },
            {
              "value": "511825",
              "area": "天全县"
            },
            {
              "value": "511826",
              "area": "芦山县"
            },
            {
              "value": "511827",
              "area": "宝兴县"
            }
          ]
        },
        {
          "value": "511900",
          "city": "巴中市",
          "dataList": [
            {
              "value": "511902",
              "area": "巴州区"
            },
            {
              "value": "511903",
              "area": "恩阳区"
            },
            {
              "value": "511921",
              "area": "通江县"
            },
            {
              "value": "511922",
              "area": "南江县"
            },
            {
              "value": "511923",
              "area": "平昌县"
            }
          ]
        },
        {
          "value": "512000",
          "city": "资阳市",
          "dataList": [
            {
              "value": "512002",
              "area": "雁江区"
            },
            {
              "value": "512021",
              "area": "安岳县"
            },
            {
              "value": "512022",
              "area": "乐至县"
            },
            {
              "value": "512081",
              "area": "简阳市"
            }
          ]
        },
        {
          "value": "513200",
          "city": "阿坝藏族羌族自治州",
          "dataList": [
            {
              "value": "513221",
              "area": "汶川县"
            },
            {
              "value": "513222",
              "area": "理　县"
            },
            {
              "value": "513223",
              "area": "茂　县"
            },
            {
              "value": "513224",
              "area": "松潘县"
            },
            {
              "value": "513225",
              "area": "九寨沟县"
            },
            {
              "value": "513226",
              "area": "金川县"
            },
            {
              "value": "513227",
              "area": "小金县"
            },
            {
              "value": "513228",
              "area": "黑水县"
            },
            {
              "value": "513229",
              "area": "马尔康县"
            },
            {
              "value": "513230",
              "area": "壤塘县"
            },
            {
              "value": "513231",
              "area": "阿坝县"
            },
            {
              "value": "513232",
              "area": "若尔盖县"
            },
            {
              "value": "513233",
              "area": "红原县"
            }
          ]
        },
        {
          "value": "513300",
          "city": "甘孜藏族自治州",
          "dataList": [
            {
              "value": "513321",
              "area": "康定县"
            },
            {
              "value": "513322",
              "area": "泸定县"
            },
            {
              "value": "513323",
              "area": "丹巴县"
            },
            {
              "value": "513324",
              "area": "九龙县"
            },
            {
              "value": "513325",
              "area": "雅江县"
            },
            {
              "value": "513326",
              "area": "道孚县"
            },
            {
              "value": "513327",
              "area": "炉霍县"
            },
            {
              "value": "513328",
              "area": "甘孜县"
            },
            {
              "value": "513329",
              "area": "新龙县"
            },
            {
              "value": "513330",
              "area": "德格县"
            },
            {
              "value": "513331",
              "area": "白玉县"
            },
            {
              "value": "513332",
              "area": "石渠县"
            },
            {
              "value": "513333",
              "area": "色达县"
            },
            {
              "value": "513334",
              "area": "理塘县"
            },
            {
              "value": "513335",
              "area": "巴塘县"
            },
            {
              "value": "513336",
              "area": "乡城县"
            },
            {
              "value": "513337",
              "area": "稻城县"
            },
            {
              "value": "513338",
              "area": "得荣县"
            }
          ]
        },
        {
          "value": "513400",
          "city": "凉山彝族自治州",
          "dataList": [
            {
              "value": "513401",
              "area": "西昌市"
            },
            {
              "value": "513422",
              "area": "木里藏族自治县"
            },
            {
              "value": "513423",
              "area": "盐源县"
            },
            {
              "value": "513424",
              "area": "德昌县"
            },
            {
              "value": "513425",
              "area": "会理县"
            },
            {
              "value": "513426",
              "area": "会东县"
            },
            {
              "value": "513427",
              "area": "宁南县"
            },
            {
              "value": "513428",
              "area": "普格县"
            },
            {
              "value": "513429",
              "area": "布拖县"
            },
            {
              "value": "513430",
              "area": "金阳县"
            },
            {
              "value": "513431",
              "area": "昭觉县"
            },
            {
              "value": "513432",
              "area": "喜德县"
            },
            {
              "value": "513433",
              "area": "冕宁县"
            },
            {
              "value": "513434",
              "area": "越西县"
            },
            {
              "value": "513435",
              "area": "甘洛县"
            },
            {
              "value": "513436",
              "area": "美姑县"
            },
            {
              "value": "513437",
              "area": "雷波县"
            }
          ]
        }
      ]
    },
    {
      "value": "520000",
      "province": "贵州省",
      "data": [
        {
          "value": "520100",
          "city": "贵阳市",
          "dataList": [
            {
              "value": "520102",
              "area": "南明区"
            },
            {
              "value": "520103",
              "area": "云岩区"
            },
            {
              "value": "520111",
              "area": "花溪区"
            },
            {
              "value": "520112",
              "area": "乌当区"
            },
            {
              "value": "520113",
              "area": "白云区"
            },
            {
              "value": "520115",
              "area": "观山湖区"
            },
            {
              "value": "520121",
              "area": "开阳县"
            },
            {
              "value": "520122",
              "area": "息烽县"
            },
            {
              "value": "520123",
              "area": "修文县"
            },
            {
              "value": "520181",
              "area": "清镇市"
            }
          ]
        },
        {
          "value": "520200",
          "city": "六盘水市",
          "dataList": [
            {
              "value": "520201",
              "area": "钟山区"
            },
            {
              "value": "520203",
              "area": "六枝特区"
            },
            {
              "value": "520221",
              "area": "水城县"
            },
            {
              "value": "520222",
              "area": "盘　县"
            }
          ]
        },
        {
          "value": "520300",
          "city": "遵义市",
          "dataList": [
            {
              "value": "520302",
              "area": "红花岗区"
            },
            {
              "value": "520303",
              "area": "汇川区"
            },
            {
              "value": "520321",
              "area": "遵义县"
            },
            {
              "value": "520322",
              "area": "桐梓县"
            },
            {
              "value": "520323",
              "area": "绥阳县"
            },
            {
              "value": "520324",
              "area": "正安县"
            },
            {
              "value": "520325",
              "area": "道真仡佬族苗族自治县"
            },
            {
              "value": "520326",
              "area": "务川仡佬族苗族自治县"
            },
            {
              "value": "520327",
              "area": "凤冈县"
            },
            {
              "value": "520328",
              "area": "湄潭县"
            },
            {
              "value": "520329",
              "area": "余庆县"
            },
            {
              "value": "520330",
              "area": "习水县"
            },
            {
              "value": "520381",
              "area": "赤水市"
            },
            {
              "value": "520382",
              "area": "仁怀市"
            }
          ]
        },
        {
          "value": "520400",
          "city": "安顺市",
          "dataList": [
            {
              "value": "520402",
              "area": "西秀区"
            },
            {
              "value": "520421",
              "area": "平坝县"
            },
            {
              "value": "520422",
              "area": "普定县"
            },
            {
              "value": "520423",
              "area": "镇宁布依族苗族自治县"
            },
            {
              "value": "520424",
              "area": "关岭布依族苗族自治县"
            },
            {
              "value": "520425",
              "area": "紫云苗族布依族自治县"
            }
          ]
        },
        {
          "value": "522200",
          "city": "铜仁市",
          "dataList": [
            {
              "value": "520602",
              "area": "碧江区"
            },
            {
              "value": "520603",
              "area": "万山区"
            },
            {
              "value": "522222",
              "area": "江口县"
            },
            {
              "value": "522223",
              "area": "玉屏侗族自治县"
            },
            {
              "value": "522224",
              "area": "石阡县"
            },
            {
              "value": "522225",
              "area": "思南县"
            },
            {
              "value": "522226",
              "area": "印江土家族苗族自治县"
            },
            {
              "value": "522227",
              "area": "德江县"
            },
            {
              "value": "522228",
              "area": "沿河土家族自治县"
            },
            {
              "value": "522229",
              "area": "松桃苗族自治县"
            }
          ]
        },
        {
          "value": "522400",
          "city": "毕节市",
          "dataList": [
            {
              "value": "522401",
              "area": "七星关区"
            },
            {
              "value": "522422",
              "area": "大方县"
            },
            {
              "value": "522423",
              "area": "黔西县"
            },
            {
              "value": "522424",
              "area": "金沙县"
            },
            {
              "value": "522425",
              "area": "织金县"
            },
            {
              "value": "522426",
              "area": "纳雍县"
            },
            {
              "value": "522427",
              "area": "威宁彝族回族苗族自治县"
            },
            {
              "value": "522428",
              "area": "赫章县"
            }
          ]
        },
        {
          "value": "522300",
          "city": "黔西南布依族苗族自治州",
          "dataList": [
            {
              "value": "522301",
              "area": "兴义市"
            },
            {
              "value": "522322",
              "area": "兴仁县"
            },
            {
              "value": "522323",
              "area": "普安县"
            },
            {
              "value": "522324",
              "area": "晴隆县"
            },
            {
              "value": "522325",
              "area": "贞丰县"
            },
            {
              "value": "522326",
              "area": "望谟县"
            },
            {
              "value": "522327",
              "area": "册亨县"
            },
            {
              "value": "522328",
              "area": "安龙县"
            }
          ]
        },
        {
          "value": "522600",
          "city": "黔东南苗族侗族自治州",
          "dataList": [
            {
              "value": "522601",
              "area": "凯里市"
            },
            {
              "value": "522622",
              "area": "黄平县"
            },
            {
              "value": "522623",
              "area": "施秉县"
            },
            {
              "value": "522624",
              "area": "三穗县"
            },
            {
              "value": "522625",
              "area": "镇远县"
            },
            {
              "value": "522626",
              "area": "岑巩县"
            },
            {
              "value": "522627",
              "area": "天柱县"
            },
            {
              "value": "522628",
              "area": "锦屏县"
            },
            {
              "value": "522629",
              "area": "剑河县"
            },
            {
              "value": "522630",
              "area": "台江县"
            },
            {
              "value": "522631",
              "area": "黎平县"
            },
            {
              "value": "522632",
              "area": "榕江县"
            },
            {
              "value": "522633",
              "area": "从江县"
            },
            {
              "value": "522634",
              "area": "雷山县"
            },
            {
              "value": "522635",
              "area": "麻江县"
            },
            {
              "value": "522636",
              "area": "丹寨县"
            }
          ]
        },
        {
          "value": "522700",
          "city": "黔南布依族苗族自治州",
          "dataList": [
            {
              "value": "522701",
              "area": "都匀市"
            },
            {
              "value": "522702",
              "area": "福泉市"
            },
            {
              "value": "522722",
              "area": "荔波县"
            },
            {
              "value": "522723",
              "area": "贵定县"
            },
            {
              "value": "522725",
              "area": "瓮安县"
            },
            {
              "value": "522726",
              "area": "独山县"
            },
            {
              "value": "522727",
              "area": "平塘县"
            },
            {
              "value": "522728",
              "area": "罗甸县"
            },
            {
              "value": "522729",
              "area": "长顺县"
            },
            {
              "value": "522730",
              "area": "龙里县"
            },
            {
              "value": "522731",
              "area": "惠水县"
            },
            {
              "value": "522732",
              "area": "三都水族自治县"
            }
          ]
        }
      ]
    },
    {
      "value": "530000",
      "province": "云南省",
      "data": [
        {
          "value": "530100",
          "city": "昆明市",
          "dataList": [
            {
              "value": "530102",
              "area": "五华区"
            },
            {
              "value": "530103",
              "area": "盘龙区"
            },
            {
              "value": "530111",
              "area": "官渡区"
            },
            {
              "value": "530112",
              "area": "西山区"
            },
            {
              "value": "530113",
              "area": "东川区"
            },
            {
              "value": "530121",
              "area": "呈贡县"
            },
            {
              "value": "530122",
              "area": "晋宁县"
            },
            {
              "value": "530124",
              "area": "富民县"
            },
            {
              "value": "530125",
              "area": "宜良县"
            },
            {
              "value": "530126",
              "area": "石林彝族自治县"
            },
            {
              "value": "530127",
              "area": "嵩明县"
            },
            {
              "value": "530128",
              "area": "禄劝彝族苗族自治县"
            },
            {
              "value": "530129",
              "area": "寻甸回族彝族自治县"
            },
            {
              "value": "530181",
              "area": "安宁市"
            }
          ]
        },
        {
          "value": "530300",
          "city": "曲靖市",
          "dataList": [
            {
              "value": "530302",
              "area": "麒麟区"
            },
            {
              "value": "530321",
              "area": "马龙县"
            },
            {
              "value": "530322",
              "area": "陆良县"
            },
            {
              "value": "530323",
              "area": "师宗县"
            },
            {
              "value": "530324",
              "area": "罗平县"
            },
            {
              "value": "530325",
              "area": "富源县"
            },
            {
              "value": "530326",
              "area": "会泽县"
            },
            {
              "value": "530328",
              "area": "沾益县"
            },
            {
              "value": "530381",
              "area": "宣威市"
            }
          ]
        },
        {
          "value": "530400",
          "city": "玉溪市",
          "dataList": [
            {
              "value": "530402",
              "area": "红塔区"
            },
            {
              "value": "530421",
              "area": "江川县"
            },
            {
              "value": "530422",
              "area": "澄江县"
            },
            {
              "value": "530423",
              "area": "通海县"
            },
            {
              "value": "530424",
              "area": "华宁县"
            },
            {
              "value": "530425",
              "area": "易门县"
            },
            {
              "value": "530426",
              "area": "峨山彝族自治县"
            },
            {
              "value": "530427",
              "area": "新平彝族傣族自治县"
            },
            {
              "value": "530428",
              "area": "元江哈尼族彝族傣族自治县"
            }
          ]
        },
        {
          "value": "530500",
          "city": "保山市",
          "dataList": [
            {
              "value": "530502",
              "area": "隆阳区"
            },
            {
              "value": "530521",
              "area": "施甸县"
            },
            {
              "value": "530522",
              "area": "腾冲县"
            },
            {
              "value": "530523",
              "area": "龙陵县"
            },
            {
              "value": "530524",
              "area": "昌宁县"
            }
          ]
        },
        {
          "value": "530600",
          "city": "昭通市",
          "dataList": [
            {
              "value": "530602",
              "area": "昭阳区"
            },
            {
              "value": "530621",
              "area": "鲁甸县"
            },
            {
              "value": "530622",
              "area": "巧家县"
            },
            {
              "value": "530623",
              "area": "盐津县"
            },
            {
              "value": "530624",
              "area": "大关县"
            },
            {
              "value": "530625",
              "area": "永善县"
            },
            {
              "value": "530626",
              "area": "绥江县"
            },
            {
              "value": "530627",
              "area": "镇雄县"
            },
            {
              "value": "530628",
              "area": "彝良县"
            },
            {
              "value": "530629",
              "area": "威信县"
            },
            {
              "value": "530630",
              "area": "水富县"
            }
          ]
        },
        {
          "value": "530700",
          "city": "丽江市",
          "dataList": [
            {
              "value": "530702",
              "area": "古城区"
            },
            {
              "value": "530721",
              "area": "玉龙纳西族自治县"
            },
            {
              "value": "530722",
              "area": "永胜县"
            },
            {
              "value": "530723",
              "area": "华坪县"
            },
            {
              "value": "530724",
              "area": "宁蒗彝族自治县"
            }
          ]
        },
        {
          "value": "530800",
          "city": "普洱市",
          "dataList": [
            {
              "value": "530802",
              "area": "思茅区"
            },
            {
              "value": "530821",
              "area": "宁洱哈尼族彝族自治县"
            },
            {
              "value": "530822",
              "area": "墨江哈尼族自治县"
            },
            {
              "value": "530823",
              "area": "景东彝族自治县"
            },
            {
              "value": "530824",
              "area": "景谷傣族彝族自治县"
            },
            {
              "value": "530825",
              "area": "镇沅彝族哈尼族拉祜族自治县"
            },
            {
              "value": "530826",
              "area": "江城哈尼族彝族自治县"
            },
            {
              "value": "530827",
              "area": "孟连傣族拉祜族佤族自治县"
            },
            {
              "value": "530828",
              "area": "澜沧拉祜族自治县"
            },
            {
              "value": "530829",
              "area": "西盟佤族自治县"
            }
          ]
        },
        {
          "value": "530900",
          "city": "临沧市",
          "dataList": [
            {
              "value": "530902",
              "area": "临翔区"
            },
            {
              "value": "530921",
              "area": "凤庆县"
            },
            {
              "value": "530922",
              "area": "云　县"
            },
            {
              "value": "530923",
              "area": "永德县"
            },
            {
              "value": "530924",
              "area": "镇康县"
            },
            {
              "value": "530925",
              "area": "双江拉祜族佤族布朗族傣族自治县"
            },
            {
              "value": "530926",
              "area": "耿马傣族佤族自治县"
            },
            {
              "value": "530927",
              "area": "沧源佤族自治县"
            }
          ]
        },
        {
          "value": "532300",
          "city": "楚雄彝族自治州",
          "dataList": [
            {
              "value": "532301",
              "area": "楚雄市"
            },
            {
              "value": "532322",
              "area": "双柏县"
            },
            {
              "value": "532323",
              "area": "牟定县"
            },
            {
              "value": "532324",
              "area": "南华县"
            },
            {
              "value": "532325",
              "area": "姚安县"
            },
            {
              "value": "532326",
              "area": "大姚县"
            },
            {
              "value": "532327",
              "area": "永仁县"
            },
            {
              "value": "532328",
              "area": "元谋县"
            },
            {
              "value": "532329",
              "area": "武定县"
            },
            {
              "value": "532331",
              "area": "禄丰县"
            }
          ]
        },
        {
          "value": "532500",
          "city": "红河哈尼族彝族自治州",
          "dataList": [
            {
              "value": "532501",
              "area": "个旧市"
            },
            {
              "value": "532502",
              "area": "开远市"
            },
            {
              "value": "532503",
              "area": "蒙自市"
            },
            {
              "value": "532504",
              "area": "弥勒市"
            },
            {
              "value": "532523",
              "area": "屏边苗族自治县"
            },
            {
              "value": "532524",
              "area": "建水县"
            },
            {
              "value": "532525",
              "area": "石屏县"
            },
            {
              "value": "532527",
              "area": "泸西县"
            },
            {
              "value": "532528",
              "area": "元阳县"
            },
            {
              "value": "532529",
              "area": "红河县"
            },
            {
              "value": "532530",
              "area": "金平苗族瑶族傣族自治县"
            },
            {
              "value": "532531",
              "area": "绿春县"
            },
            {
              "value": "532532",
              "area": "河口瑶族自治县"
            }
          ]
        },
        {
          "value": "532600",
          "city": "文山壮族苗族自治州",
          "dataList": [
            {
              "value": "532621",
              "area": "文山市"
            },
            {
              "value": "532622",
              "area": "砚山县"
            },
            {
              "value": "532623",
              "area": "西畴县"
            },
            {
              "value": "532624",
              "area": "麻栗坡县"
            },
            {
              "value": "532625",
              "area": "马关县"
            },
            {
              "value": "532626",
              "area": "丘北县"
            },
            {
              "value": "532627",
              "area": "广南县"
            },
            {
              "value": "532628",
              "area": "富宁县"
            }
          ]
        },
        {
          "value": "532800",
          "city": "西双版纳傣族自治州",
          "dataList": [
            {
              "value": "532801",
              "area": "景洪市"
            },
            {
              "value": "532822",
              "area": "勐海县"
            },
            {
              "value": "532823",
              "area": "勐腊县"
            }
          ]
        },
        {
          "value": "532900",
          "city": "大理白族自治州",
          "dataList": [
            {
              "value": "532901",
              "area": "大理市"
            },
            {
              "value": "532922",
              "area": "漾濞彝族自治县"
            },
            {
              "value": "532923",
              "area": "祥云县"
            },
            {
              "value": "532924",
              "area": "宾川县"
            },
            {
              "value": "532925",
              "area": "弥渡县"
            },
            {
              "value": "532926",
              "area": "南涧彝族自治县"
            },
            {
              "value": "532927",
              "area": "巍山彝族回族自治县"
            },
            {
              "value": "532928",
              "area": "永平县"
            },
            {
              "value": "532929",
              "area": "云龙县"
            },
            {
              "value": "532930",
              "area": "洱源县"
            },
            {
              "value": "532931",
              "area": "剑川县"
            },
            {
              "value": "532932",
              "area": "鹤庆县"
            }
          ]
        },
        {
          "value": "533100",
          "city": "德宏傣族景颇族自治州",
          "dataList": [
            {
              "value": "533102",
              "area": "瑞丽市"
            },
            {
              "value": "533103",
              "area": "芒市"
            },
            {
              "value": "533122",
              "area": "梁河县"
            },
            {
              "value": "533123",
              "area": "盈江县"
            },
            {
              "value": "533124",
              "area": "陇川县"
            }
          ]
        },
        {
          "value": "533300",
          "city": "怒江傈僳族自治州",
          "dataList": [
            {
              "value": "533321",
              "area": "泸水县"
            },
            {
              "value": "533323",
              "area": "福贡县"
            },
            {
              "value": "533324",
              "area": "贡山独龙族怒族自治县"
            },
            {
              "value": "533325",
              "area": "兰坪白族普米族自治县"
            }
          ]
        },
        {
          "value": "533400",
          "city": "迪庆藏族自治州",
          "dataList": [
            {
              "value": "533421",
              "area": "香格里拉县"
            },
            {
              "value": "533422",
              "area": "德钦县"
            },
            {
              "value": "533423",
              "area": "维西傈僳族自治县"
            }
          ]
        }
      ]
    },
    {
      "value": "540000",
      "province": "西藏自治区",
      "data": [
        {
          "value": "540100",
          "city": "拉萨市",
          "dataList": [
            {
              "value": "540102",
              "area": "城关区"
            },
            {
              "value": "540121",
              "area": "林周县"
            },
            {
              "value": "540122",
              "area": "当雄县"
            },
            {
              "value": "540123",
              "area": "尼木县"
            },
            {
              "value": "540124",
              "area": "曲水县"
            },
            {
              "value": "540125",
              "area": "堆龙德庆县"
            },
            {
              "value": "540126",
              "area": "达孜县"
            },
            {
              "value": "540127",
              "area": "墨竹工卡县"
            }
          ]
        },
        {
          "value": "542100",
          "city": "昌都市",
          "dataList": [
            {
              "value": "542102",
              "area": "卡若区"
            },
            {
              "value": "542122",
              "area": "江达县"
            },
            {
              "value": "542123",
              "area": "贡觉县"
            },
            {
              "value": "542124",
              "area": "类乌齐县"
            },
            {
              "value": "542125",
              "area": "丁青县"
            },
            {
              "value": "542126",
              "area": "察雅县"
            },
            {
              "value": "542127",
              "area": "八宿县"
            },
            {
              "value": "542128",
              "area": "左贡县"
            },
            {
              "value": "542129",
              "area": "芒康县"
            },
            {
              "value": "542132",
              "area": "洛隆县"
            },
            {
              "value": "542133",
              "area": "边坝县"
            }
          ]
        },
        {
          "value": "542200",
          "city": "山南地区",
          "dataList": [
            {
              "value": "542221",
              "area": "乃东县"
            },
            {
              "value": "542222",
              "area": "扎囊县"
            },
            {
              "value": "542223",
              "area": "贡嘎县"
            },
            {
              "value": "542224",
              "area": "桑日县"
            },
            {
              "value": "542225",
              "area": "琼结县"
            },
            {
              "value": "542226",
              "area": "曲松县"
            },
            {
              "value": "542227",
              "area": "措美县"
            },
            {
              "value": "542228",
              "area": "洛扎县"
            },
            {
              "value": "542229",
              "area": "加查县"
            },
            {
              "value": "542231",
              "area": "隆子县"
            },
            {
              "value": "542232",
              "area": "错那县"
            },
            {
              "value": "542233",
              "area": "浪卡子县"
            }
          ]
        },
        {
          "value": "542300",
          "city": "日喀则市",
          "dataList": [
            {
              "value": "542302",
              "area": "桑珠孜区"
            },
            {
              "value": "542322",
              "area": "南木林县"
            },
            {
              "value": "542323",
              "area": "江孜县"
            },
            {
              "value": "542324",
              "area": "定日县"
            },
            {
              "value": "542325",
              "area": "萨迦县"
            },
            {
              "value": "542326",
              "area": "拉孜县"
            },
            {
              "value": "542327",
              "area": "昂仁县"
            },
            {
              "value": "542328",
              "area": "谢通门县"
            },
            {
              "value": "542329",
              "area": "白朗县"
            },
            {
              "value": "542330",
              "area": "仁布县"
            },
            {
              "value": "542331",
              "area": "康马县"
            },
            {
              "value": "542332",
              "area": "定结县"
            },
            {
              "value": "542333",
              "area": "仲巴县"
            },
            {
              "value": "542334",
              "area": "亚东县"
            },
            {
              "value": "542335",
              "area": "吉隆县"
            },
            {
              "value": "542336",
              "area": "聂拉木县"
            },
            {
              "value": "542337",
              "area": "萨嘎县"
            },
            {
              "value": "542338",
              "area": "岗巴县"
            }
          ]
        },
        {
          "value": "542400",
          "city": "那曲地区",
          "dataList": [
            {
              "value": "542421",
              "area": "那曲县"
            },
            {
              "value": "542422",
              "area": "嘉黎县"
            },
            {
              "value": "542423",
              "area": "比如县"
            },
            {
              "value": "542424",
              "area": "聂荣县"
            },
            {
              "value": "542425",
              "area": "安多县"
            },
            {
              "value": "542426",
              "area": "申扎县"
            },
            {
              "value": "542427",
              "area": "索　县"
            },
            {
              "value": "542428",
              "area": "班戈县"
            },
            {
              "value": "542429",
              "area": "巴青县"
            },
            {
              "value": "542430",
              "area": "尼玛县"
            },
            {
              "value": "542431",
              "area": "双湖县"
            }
          ]
        },
        {
          "value": "542500",
          "city": "阿里地区",
          "dataList": [
            {
              "value": "542521",
              "area": "普兰县"
            },
            {
              "value": "542522",
              "area": "札达县"
            },
            {
              "value": "542523",
              "area": "噶尔县"
            },
            {
              "value": "542524",
              "area": "日土县"
            },
            {
              "value": "542525",
              "area": "革吉县"
            },
            {
              "value": "542526",
              "area": "改则县"
            },
            {
              "value": "542527",
              "area": "措勤县"
            }
          ]
        },
        {
          "value": "542600",
          "city": "林芝市",
          "dataList": [
            {
              "value": "542602",
              "area": "巴宜区"
            },
            {
              "value": "542622",
              "area": "工布江达县"
            },
            {
              "value": "542623",
              "area": "米林县"
            },
            {
              "value": "542624",
              "area": "墨脱县"
            },
            {
              "value": "542625",
              "area": "波密县"
            },
            {
              "value": "542626",
              "area": "察隅县"
            },
            {
              "value": "542627",
              "area": "朗　县"
            }
          ]
        }
      ]
    },
    {
      "value": "610000",
      "province": "陕西省",
      "data": [
        {
          "value": "610100",
          "city": "西安市",
          "dataList": [
            {
              "value": "610102",
              "area": "新城区"
            },
            {
              "value": "610103",
              "area": "碑林区"
            },
            {
              "value": "610104",
              "area": "莲湖区"
            },
            {
              "value": "610111",
              "area": "灞桥区"
            },
            {
              "value": "610112",
              "area": "未央区"
            },
            {
              "value": "610113",
              "area": "雁塔区"
            },
            {
              "value": "610114",
              "area": "阎良区"
            },
            {
              "value": "610115",
              "area": "临潼区"
            },
            {
              "value": "610116",
              "area": "长安区"
            },
            {
              "value": "610117",
              "area": "高陵区"
            },
            {
              "value": "610122",
              "area": "蓝田县"
            },
            {
              "value": "610124",
              "area": "周至县"
            },
            {
              "value": "610125",
              "area": "户　县"
            },
            {
              "value": "610126",
              "area": "杨凌农业示范区"
            }
          ]
        },
        {
          "value": "610200",
          "city": "铜川市",
          "dataList": [
            {
              "value": "610202",
              "area": "王益区"
            },
            {
              "value": "610203",
              "area": "印台区"
            },
            {
              "value": "610204",
              "area": "耀州区"
            },
            {
              "value": "610222",
              "area": "宜君县"
            }
          ]
        },
        {
          "value": "610300",
          "city": "宝鸡市",
          "dataList": [
            {
              "value": "610302",
              "area": "渭滨区"
            },
            {
              "value": "610303",
              "area": "金台区"
            },
            {
              "value": "610304",
              "area": "陈仓区"
            },
            {
              "value": "610322",
              "area": "凤翔县"
            },
            {
              "value": "610323",
              "area": "岐山县"
            },
            {
              "value": "610324",
              "area": "扶风县"
            },
            {
              "value": "610326",
              "area": "眉　县"
            },
            {
              "value": "610327",
              "area": "陇　县"
            },
            {
              "value": "610328",
              "area": "千阳县"
            },
            {
              "value": "610329",
              "area": "麟游县"
            },
            {
              "value": "610330",
              "area": "凤　县"
            },
            {
              "value": "610331",
              "area": "太白县"
            }
          ]
        },
        {
          "value": "610400",
          "city": "咸阳市",
          "dataList": [
            {
              "value": "610402",
              "area": "秦都区"
            },
            {
              "value": "610403",
              "area": "杨陵区"
            },
            {
              "value": "610404",
              "area": "渭城区"
            },
            {
              "value": "610422",
              "area": "三原县"
            },
            {
              "value": "610423",
              "area": "泾阳县"
            },
            {
              "value": "610424",
              "area": "乾　县"
            },
            {
              "value": "610425",
              "area": "礼泉县"
            },
            {
              "value": "610426",
              "area": "永寿县"
            },
            {
              "value": "610427",
              "area": "彬　县"
            },
            {
              "value": "610428",
              "area": "长武县"
            },
            {
              "value": "610429",
              "area": "旬邑县"
            },
            {
              "value": "610430",
              "area": "淳化县"
            },
            {
              "value": "610431",
              "area": "武功县"
            },
            {
              "value": "610481",
              "area": "兴平市"
            }
          ]
        },
        {
          "value": "610500",
          "city": "渭南市",
          "dataList": [
            {
              "value": "610502",
              "area": "临渭区"
            },
            {
              "value": "610521",
              "area": "华　县"
            },
            {
              "value": "610522",
              "area": "潼关县"
            },
            {
              "value": "610523",
              "area": "大荔县"
            },
            {
              "value": "610524",
              "area": "合阳县"
            },
            {
              "value": "610525",
              "area": "澄城县"
            },
            {
              "value": "610526",
              "area": "蒲城县"
            },
            {
              "value": "610527",
              "area": "白水县"
            },
            {
              "value": "610528",
              "area": "富平县"
            },
            {
              "value": "610581",
              "area": "韩城市"
            },
            {
              "value": "610582",
              "area": "华阴市"
            }
          ]
        },
        {
          "value": "610600",
          "city": "延安市",
          "dataList": [
            {
              "value": "610602",
              "area": "宝塔区"
            },
            {
              "value": "610621",
              "area": "延长县"
            },
            {
              "value": "610622",
              "area": "延川县"
            },
            {
              "value": "610623",
              "area": "子长县"
            },
            {
              "value": "610624",
              "area": "安塞县"
            },
            {
              "value": "610625",
              "area": "志丹县"
            },
            {
              "value": "610626",
              "area": "吴旗县"
            },
            {
              "value": "610627",
              "area": "甘泉县"
            },
            {
              "value": "610628",
              "area": "富　县"
            },
            {
              "value": "610629",
              "area": "洛川县"
            },
            {
              "value": "610630",
              "area": "宜川县"
            },
            {
              "value": "610631",
              "area": "黄龙县"
            },
            {
              "value": "610632",
              "area": "黄陵县"
            }
          ]
        },
        {
          "value": "610700",
          "city": "汉中市",
          "dataList": [
            {
              "value": "610702",
              "area": "汉台区"
            },
            {
              "value": "610721",
              "area": "南郑县"
            },
            {
              "value": "610722",
              "area": "城固县"
            },
            {
              "value": "610723",
              "area": "洋　县"
            },
            {
              "value": "610724",
              "area": "西乡县"
            },
            {
              "value": "610725",
              "area": "勉　县"
            },
            {
              "value": "610726",
              "area": "宁强县"
            },
            {
              "value": "610727",
              "area": "略阳县"
            },
            {
              "value": "610728",
              "area": "镇巴县"
            },
            {
              "value": "610729",
              "area": "留坝县"
            },
            {
              "value": "610730",
              "area": "佛坪县"
            }
          ]
        },
        {
          "value": "610800",
          "city": "榆林市",
          "dataList": [
            {
              "value": "610802",
              "area": "榆阳区"
            },
            {
              "value": "610821",
              "area": "神木县"
            },
            {
              "value": "610822",
              "area": "府谷县"
            },
            {
              "value": "610823",
              "area": "横山县"
            },
            {
              "value": "610824",
              "area": "靖边县"
            },
            {
              "value": "610825",
              "area": "定边县"
            },
            {
              "value": "610826",
              "area": "绥德县"
            },
            {
              "value": "610827",
              "area": "米脂县"
            },
            {
              "value": "610828",
              "area": "佳　县"
            },
            {
              "value": "610829",
              "area": "吴堡县"
            },
            {
              "value": "610830",
              "area": "清涧县"
            },
            {
              "value": "610831",
              "area": "子洲县"
            }
          ]
        },
        {
          "value": "610900",
          "city": "安康市",
          "dataList": [
            {
              "value": "610902",
              "area": "汉滨区"
            },
            {
              "value": "610921",
              "area": "汉阴县"
            },
            {
              "value": "610922",
              "area": "石泉县"
            },
            {
              "value": "610923",
              "area": "宁陕县"
            },
            {
              "value": "610924",
              "area": "紫阳县"
            },
            {
              "value": "610925",
              "area": "岚皋县"
            },
            {
              "value": "610926",
              "area": "平利县"
            },
            {
              "value": "610927",
              "area": "镇坪县"
            },
            {
              "value": "610928",
              "area": "旬阳县"
            },
            {
              "value": "610929",
              "area": "白河县"
            }
          ]
        },
        {
          "value": "611000",
          "city": "商洛市",
          "dataList": [
            {
              "value": "611002",
              "area": "商州区"
            },
            {
              "value": "611021",
              "area": "洛南县"
            },
            {
              "value": "611022",
              "area": "丹凤县"
            },
            {
              "value": "611023",
              "area": "商南县"
            },
            {
              "value": "611024",
              "area": "山阳县"
            },
            {
              "value": "611025",
              "area": "镇安县"
            },
            {
              "value": "611026",
              "area": "柞水县"
            }
          ]
        }
      ]
    },
    {
      "value": "620000",
      "province": "甘肃省",
      "data": [
        {
          "value": "620100",
          "city": "兰州市",
          "dataList": [
            {
              "value": "620102",
              "area": "城关区"
            },
            {
              "value": "620103",
              "area": "七里河区"
            },
            {
              "value": "620104",
              "area": "西固区"
            },
            {
              "value": "620105",
              "area": "安宁区"
            },
            {
              "value": "620111",
              "area": "红古区"
            },
            {
              "value": "620121",
              "area": "永登县"
            },
            {
              "value": "620122",
              "area": "皋兰县"
            },
            {
              "value": "620123",
              "area": "榆中县"
            }
          ]
        },
        {
          "value": "620200",
          "city": "嘉峪关市",
          "dataList": [
            {
              "value": "659059",
              "area": "雄关区"
            },
            {
              "value": "659060",
              "area": "长城区"
            },
            {
              "value": "659061",
              "area": "镜铁区"
            }
          ]
        },
        {
          "value": "620300",
          "city": "金昌市",
          "dataList": [
            {
              "value": "620302",
              "area": "金川区"
            },
            {
              "value": "620321",
              "area": "永昌县"
            }
          ]
        },
        {
          "value": "620400",
          "city": "白银市",
          "dataList": [
            {
              "value": "620402",
              "area": "白银区"
            },
            {
              "value": "620403",
              "area": "平川区"
            },
            {
              "value": "620421",
              "area": "靖远县"
            },
            {
              "value": "620422",
              "area": "会宁县"
            },
            {
              "value": "620423",
              "area": "景泰县"
            }
          ]
        },
        {
          "value": "620500",
          "city": "天水市",
          "dataList": [
            {
              "value": "620502",
              "area": "秦州区"
            },
            {
              "value": "620503",
              "area": "麦积区"
            },
            {
              "value": "620521",
              "area": "清水县"
            },
            {
              "value": "620522",
              "area": "秦安县"
            },
            {
              "value": "620523",
              "area": "甘谷县"
            },
            {
              "value": "620524",
              "area": "武山县"
            },
            {
              "value": "620525",
              "area": "张家川回族自治县"
            }
          ]
        },
        {
          "value": "620600",
          "city": "武威市",
          "dataList": [
            {
              "value": "620602",
              "area": "凉州区"
            },
            {
              "value": "620621",
              "area": "民勤县"
            },
            {
              "value": "620622",
              "area": "古浪县"
            },
            {
              "value": "620623",
              "area": "天祝藏族自治县"
            }
          ]
        },
        {
          "value": "620700",
          "city": "张掖市",
          "dataList": [
            {
              "value": "620702",
              "area": "甘州区"
            },
            {
              "value": "620721",
              "area": "肃南裕固族自治县"
            },
            {
              "value": "620722",
              "area": "民乐县"
            },
            {
              "value": "620723",
              "area": "临泽县"
            },
            {
              "value": "620724",
              "area": "高台县"
            },
            {
              "value": "620725",
              "area": "山丹县"
            }
          ]
        },
        {
          "value": "620800",
          "city": "平凉市",
          "dataList": [
            {
              "value": "620802",
              "area": "崆峒区"
            },
            {
              "value": "620821",
              "area": "泾川县"
            },
            {
              "value": "620822",
              "area": "灵台县"
            },
            {
              "value": "620823",
              "area": "崇信县"
            },
            {
              "value": "620824",
              "area": "华亭县"
            },
            {
              "value": "620825",
              "area": "庄浪县"
            },
            {
              "value": "620826",
              "area": "静宁县"
            }
          ]
        },
        {
          "value": "620900",
          "city": "酒泉市",
          "dataList": [
            {
              "value": "620902",
              "area": "肃州区"
            },
            {
              "value": "620921",
              "area": "金塔县"
            },
            {
              "value": "620922",
              "area": "瓜州县"
            },
            {
              "value": "620923",
              "area": "肃北蒙古族自治县"
            },
            {
              "value": "620924",
              "area": "阿克塞哈萨克族自治县"
            },
            {
              "value": "620981",
              "area": "玉门市"
            },
            {
              "value": "620982",
              "area": "敦煌市"
            }
          ]
        },
        {
          "value": "621000",
          "city": "庆阳市",
          "dataList": [
            {
              "value": "621002",
              "area": "西峰区"
            },
            {
              "value": "621021",
              "area": "庆城县"
            },
            {
              "value": "621022",
              "area": "环　县"
            },
            {
              "value": "621023",
              "area": "华池县"
            },
            {
              "value": "621024",
              "area": "合水县"
            },
            {
              "value": "621025",
              "area": "正宁县"
            },
            {
              "value": "621026",
              "area": "宁　县"
            },
            {
              "value": "621027",
              "area": "镇原县"
            }
          ]
        },
        {
          "value": "621100",
          "city": "定西市",
          "dataList": [
            {
              "value": "621102",
              "area": "安定区"
            },
            {
              "value": "621121",
              "area": "通渭县"
            },
            {
              "value": "621122",
              "area": "陇西县"
            },
            {
              "value": "621123",
              "area": "渭源县"
            },
            {
              "value": "621124",
              "area": "临洮县"
            },
            {
              "value": "621125",
              "area": "漳　县"
            },
            {
              "value": "621126",
              "area": "岷　县"
            }
          ]
        },
        {
          "value": "621200",
          "city": "陇南市",
          "dataList": [
            {
              "value": "621202",
              "area": "武都区"
            },
            {
              "value": "621221",
              "area": "成　县"
            },
            {
              "value": "621222",
              "area": "文　县"
            },
            {
              "value": "621223",
              "area": "宕昌县"
            },
            {
              "value": "621224",
              "area": "康　县"
            },
            {
              "value": "621225",
              "area": "西和县"
            },
            {
              "value": "621226",
              "area": "礼　县"
            },
            {
              "value": "621227",
              "area": "徽　县"
            },
            {
              "value": "621228",
              "area": "两当县"
            }
          ]
        },
        {
          "value": "622900",
          "city": "临夏回族自治州",
          "dataList": [
            {
              "value": "622901",
              "area": "临夏市"
            },
            {
              "value": "622921",
              "area": "临夏县"
            },
            {
              "value": "622922",
              "area": "康乐县"
            },
            {
              "value": "622923",
              "area": "永靖县"
            },
            {
              "value": "622924",
              "area": "广河县"
            },
            {
              "value": "622925",
              "area": "和政县"
            },
            {
              "value": "622926",
              "area": "东乡族自治县"
            },
            {
              "value": "622927",
              "area": "积石山保安族东乡族撒拉族自治县"
            }
          ]
        },
        {
          "value": "623000",
          "city": "甘南藏族自治州",
          "dataList": [
            {
              "value": "623001",
              "area": "合作市"
            },
            {
              "value": "623021",
              "area": "临潭县"
            },
            {
              "value": "623022",
              "area": "卓尼县"
            },
            {
              "value": "623023",
              "area": "舟曲县"
            },
            {
              "value": "623024",
              "area": "迭部县"
            },
            {
              "value": "623025",
              "area": "玛曲县"
            },
            {
              "value": "623026",
              "area": "碌曲县"
            },
            {
              "value": "623027",
              "area": "夏河县"
            }
          ]
        }
      ]
    },
    {
      "value": "630000",
      "province": "青海省",
      "data": [
        {
          "value": "630100",
          "city": "西宁市",
          "dataList": [
            {
              "value": "630102",
              "area": "城东区"
            },
            {
              "value": "630103",
              "area": "城中区"
            },
            {
              "value": "630104",
              "area": "城西区"
            },
            {
              "value": "630105",
              "area": "城北区"
            },
            {
              "value": "630121",
              "area": "大通回族土族自治县"
            },
            {
              "value": "630122",
              "area": "湟中县"
            },
            {
              "value": "630123",
              "area": "湟源县"
            }
          ]
        },
        {
          "value": "632100",
          "city": "海东市",
          "dataList": [
            {
              "value": "632002",
              "area": "乐都区"
            },
            {
              "value": "632121",
              "area": "平安县"
            },
            {
              "value": "632122",
              "area": "民和回族土族自治县"
            },
            {
              "value": "632126",
              "area": "互助土族自治县"
            },
            {
              "value": "632127",
              "area": "化隆回族自治县"
            },
            {
              "value": "632128",
              "area": "循化撒拉族自治县"
            }
          ]
        },
        {
          "value": "632200",
          "city": "海北藏族自治州",
          "dataList": [
            {
              "value": "632221",
              "area": "门源回族自治县"
            },
            {
              "value": "632222",
              "area": "祁连县"
            },
            {
              "value": "632223",
              "area": "海晏县"
            },
            {
              "value": "632224",
              "area": "刚察县"
            }
          ]
        },
        {
          "value": "632300",
          "city": "黄南藏族自治州",
          "dataList": [
            {
              "value": "632321",
              "area": "同仁县"
            },
            {
              "value": "632322",
              "area": "尖扎县"
            },
            {
              "value": "632323",
              "area": "泽库县"
            },
            {
              "value": "632324",
              "area": "河南蒙古族自治县"
            }
          ]
        },
        {
          "value": "632500",
          "city": "海南藏族自治州",
          "dataList": [
            {
              "value": "632521",
              "area": "共和县"
            },
            {
              "value": "632522",
              "area": "同德县"
            },
            {
              "value": "632523",
              "area": "贵德县"
            },
            {
              "value": "632524",
              "area": "兴海县"
            },
            {
              "value": "632525",
              "area": "贵南县"
            }
          ]
        },
        {
          "value": "632600",
          "city": "果洛藏族自治州",
          "dataList": [
            {
              "value": "632621",
              "area": "玛沁县"
            },
            {
              "value": "632622",
              "area": "班玛县"
            },
            {
              "value": "632623",
              "area": "甘德县"
            },
            {
              "value": "632624",
              "area": "达日县"
            },
            {
              "value": "632625",
              "area": "久治县"
            },
            {
              "value": "632626",
              "area": "玛多县"
            }
          ]
        },
        {
          "value": "632700",
          "city": "玉树藏族自治州",
          "dataList": [
            {
              "value": "632721",
              "area": "玉树市"
            },
            {
              "value": "632722",
              "area": "杂多县"
            },
            {
              "value": "632723",
              "area": "称多县"
            },
            {
              "value": "632724",
              "area": "治多县"
            },
            {
              "value": "632725",
              "area": "囊谦县"
            },
            {
              "value": "632726",
              "area": "曲麻莱县"
            }
          ]
        },
        {
          "value": "632800",
          "city": "海西蒙古族藏族自治州",
          "dataList": [
            {
              "value": "632801",
              "area": "格尔木市"
            },
            {
              "value": "632802",
              "area": "德令哈市"
            },
            {
              "value": "632821",
              "area": "乌兰县"
            },
            {
              "value": "632822",
              "area": "都兰县"
            },
            {
              "value": "632823",
              "area": "天峻县"
            }
          ]
        }
      ]
    },
    {
      "value": "640000",
      "province": "宁夏回族自治区",
      "data": [
        {
          "value": "640100",
          "city": "银川市",
          "dataList": [
            {
              "value": "640104",
              "area": "兴庆区"
            },
            {
              "value": "640105",
              "area": "西夏区"
            },
            {
              "value": "640106",
              "area": "金凤区"
            },
            {
              "value": "640121",
              "area": "永宁县"
            },
            {
              "value": "640122",
              "area": "贺兰县"
            },
            {
              "value": "640181",
              "area": "灵武市"
            }
          ]
        },
        {
          "value": "640200",
          "city": "石嘴山市",
          "dataList": [
            {
              "value": "640202",
              "area": "大武口区"
            },
            {
              "value": "640205",
              "area": "惠农区"
            },
            {
              "value": "640221",
              "area": "平罗县"
            }
          ]
        },
        {
          "value": "640300",
          "city": "吴忠市",
          "dataList": [
            {
              "value": "640302",
              "area": "利通区"
            },
            {
              "value": "640303",
              "area": "红寺堡区"
            },
            {
              "value": "640323",
              "area": "盐池县"
            },
            {
              "value": "640324",
              "area": "同心县"
            },
            {
              "value": "640381",
              "area": "青铜峡市"
            }
          ]
        },
        {
          "value": "640400",
          "city": "固原市",
          "dataList": [
            {
              "value": "640402",
              "area": "原州区"
            },
            {
              "value": "640422",
              "area": "西吉县"
            },
            {
              "value": "640423",
              "area": "隆德县"
            },
            {
              "value": "640424",
              "area": "泾源县"
            },
            {
              "value": "640425",
              "area": "彭阳县"
            }
          ]
        },
        {
          "value": "640500",
          "city": "中卫市",
          "dataList": [
            {
              "value": "640502",
              "area": "沙坡头区"
            },
            {
              "value": "640521",
              "area": "中宁县"
            },
            {
              "value": "640522",
              "area": "海原县"
            }
          ]
        }
      ]
    },
    {
      "value": "650000",
      "province": "新疆维吾尔自治区",
      "data": [
        {
          "value": "650100",
          "city": "乌鲁木齐市",
          "dataList": [
            {
              "value": "650102",
              "area": "天山区"
            },
            {
              "value": "650103",
              "area": "沙依巴克区"
            },
            {
              "value": "650104",
              "area": "新市区"
            },
            {
              "value": "650105",
              "area": "水磨沟区"
            },
            {
              "value": "650106",
              "area": "头屯河区"
            },
            {
              "value": "650107",
              "area": "达坂城区"
            },
            {
              "value": "650108",
              "area": "米东区"
            },
            {
              "value": "650121",
              "area": "乌鲁木齐县"
            }
          ]
        },
        {
          "value": "650200",
          "city": "克拉玛依市",
          "dataList": [
            {
              "value": "650202",
              "area": "独山子区"
            },
            {
              "value": "650203",
              "area": "克拉玛依区"
            },
            {
              "value": "650204",
              "area": "白碱滩区"
            },
            {
              "value": "650205",
              "area": "乌尔禾区"
            }
          ]
        },
        {
          "value": "652100",
          "city": "吐鲁番市",
          "dataList": [
            {
              "value": "652102",
              "area": "高昌区"
            },
            {
              "value": "652122",
              "area": "鄯善县"
            },
            {
              "value": "652123",
              "area": "托克逊县"
            }
          ]
        },
        {
          "value": "652200",
          "city": "哈密地区",
          "dataList": [
            {
              "value": "652201",
              "area": "哈密市"
            },
            {
              "value": "652222",
              "area": "巴里坤哈萨克自治县"
            },
            {
              "value": "652223",
              "area": "伊吾县"
            }
          ]
        },
        {
          "value": "652300",
          "city": "昌吉回族自治州",
          "dataList": [
            {
              "value": "652301",
              "area": "昌吉市"
            },
            {
              "value": "652302",
              "area": "阜康市"
            },
            {
              "value": "652303",
              "area": "米泉市"
            },
            {
              "value": "652323",
              "area": "呼图壁县"
            },
            {
              "value": "652324",
              "area": "玛纳斯县"
            },
            {
              "value": "652325",
              "area": "奇台县"
            },
            {
              "value": "652327",
              "area": "吉木萨尔县"
            },
            {
              "value": "652328",
              "area": "木垒哈萨克自治县"
            }
          ]
        },
        {
          "value": "652700",
          "city": "博尔塔拉蒙古自治州",
          "dataList": [
            {
              "value": "652701",
              "area": "博乐市"
            },
            {
              "value": "652702",
              "area": "阿拉山口市"
            },
            {
              "value": "652722",
              "area": "精河县"
            },
            {
              "value": "652723",
              "area": "温泉县"
            }
          ]
        },
        {
          "value": "652800",
          "city": "巴音郭楞蒙古自治州",
          "dataList": [
            {
              "value": "652801",
              "area": "库尔勒市"
            },
            {
              "value": "652822",
              "area": "轮台县"
            },
            {
              "value": "652823",
              "area": "尉犁县"
            },
            {
              "value": "652824",
              "area": "若羌县"
            },
            {
              "value": "652825",
              "area": "且末县"
            },
            {
              "value": "652826",
              "area": "焉耆回族自治县"
            },
            {
              "value": "652827",
              "area": "和静县"
            },
            {
              "value": "652828",
              "area": "和硕县"
            },
            {
              "value": "652829",
              "area": "博湖县"
            }
          ]
        },
        {
          "value": "652900",
          "city": "阿克苏地区",
          "dataList": [
            {
              "value": "652901",
              "area": "阿克苏市"
            },
            {
              "value": "652922",
              "area": "温宿县"
            },
            {
              "value": "652923",
              "area": "库车县"
            },
            {
              "value": "652924",
              "area": "沙雅县"
            },
            {
              "value": "652925",
              "area": "新和县"
            },
            {
              "value": "652926",
              "area": "拜城县"
            },
            {
              "value": "652927",
              "area": "乌什县"
            },
            {
              "value": "652928",
              "area": "阿瓦提县"
            },
            {
              "value": "652929",
              "area": "柯坪县"
            }
          ]
        },
        {
          "value": "653000",
          "city": "克孜勒苏柯尔克孜自治州",
          "dataList": [
            {
              "value": "653001",
              "area": "阿图什市"
            },
            {
              "value": "653022",
              "area": "阿克陶县"
            },
            {
              "value": "653023",
              "area": "阿合奇县"
            },
            {
              "value": "653024",
              "area": "乌恰县"
            }
          ]
        },
        {
          "value": "653100",
          "city": "喀什地区",
          "dataList": [
            {
              "value": "653101",
              "area": "喀什市"
            },
            {
              "value": "653121",
              "area": "疏附县"
            },
            {
              "value": "653122",
              "area": "疏勒县"
            },
            {
              "value": "653123",
              "area": "英吉沙县"
            },
            {
              "value": "653124",
              "area": "泽普县"
            },
            {
              "value": "653125",
              "area": "莎车县"
            },
            {
              "value": "653126",
              "area": "叶城县"
            },
            {
              "value": "653127",
              "area": "麦盖提县"
            },
            {
              "value": "653128",
              "area": "岳普湖县"
            },
            {
              "value": "653129",
              "area": "伽师县"
            },
            {
              "value": "653130",
              "area": "巴楚县"
            },
            {
              "value": "653131",
              "area": "塔什库尔干塔吉克自治县"
            }
          ]
        },
        {
          "value": "653200",
          "city": "和田地区",
          "dataList": [
            {
              "value": "653201",
              "area": "和田市"
            },
            {
              "value": "653221",
              "area": "和田县"
            },
            {
              "value": "653222",
              "area": "墨玉县"
            },
            {
              "value": "653223",
              "area": "皮山县"
            },
            {
              "value": "653224",
              "area": "洛浦县"
            },
            {
              "value": "653225",
              "area": "策勒县"
            },
            {
              "value": "653226",
              "area": "于田县"
            },
            {
              "value": "653227",
              "area": "民丰县"
            }
          ]
        },
        {
          "value": "654000",
          "city": "伊犁哈萨克自治州",
          "dataList": [
            {
              "value": "654002",
              "area": "伊宁市"
            },
            {
              "value": "654003",
              "area": "奎屯市"
            },
            {
              "value": "654021",
              "area": "伊宁县"
            },
            {
              "value": "654022",
              "area": "察布查尔锡伯自治县"
            },
            {
              "value": "654023",
              "area": "霍城县"
            },
            {
              "value": "654024",
              "area": "巩留县"
            },
            {
              "value": "654025",
              "area": "新源县"
            },
            {
              "value": "654026",
              "area": "昭苏县"
            },
            {
              "value": "654027",
              "area": "特克斯县"
            },
            {
              "value": "654028",
              "area": "尼勒克县"
            }
          ]
        },
        {
          "value": "654200",
          "city": "塔城地区",
          "dataList": [
            {
              "value": "654201",
              "area": "塔城市"
            },
            {
              "value": "654202",
              "area": "乌苏市"
            },
            {
              "value": "654221",
              "area": "额敏县"
            },
            {
              "value": "654223",
              "area": "沙湾县"
            },
            {
              "value": "654224",
              "area": "托里县"
            },
            {
              "value": "654225",
              "area": "裕民县"
            },
            {
              "value": "654226",
              "area": "和布克赛尔蒙古自治县"
            }
          ]
        },
        {
          "value": "654300",
          "city": "阿勒泰地区",
          "dataList": [
            {
              "value": "654301",
              "area": "阿勒泰市"
            },
            {
              "value": "654321",
              "area": "布尔津县"
            },
            {
              "value": "654322",
              "area": "富蕴县"
            },
            {
              "value": "654323",
              "area": "福海县"
            },
            {
              "value": "654324",
              "area": "哈巴河县"
            },
            {
              "value": "654325",
              "area": "青河县"
            },
            {
              "value": "654326",
              "area": "吉木乃县"
            }
          ]
        },
        {
          "value": "659000",
          "city": "自治区直辖县级行政区划",
          "dataList": [
            {
              "value": "659001",
              "area": "石河子市"
            },
            {
              "value": "659002",
              "area": "阿拉尔市"
            },
            {
              "value": "659003",
              "area": "图木舒克市"
            },
            {
              "value": "659004",
              "area": "五家渠市"
            }
          ]
        }
      ]
    },
    {
      "value": "710000",
      "province": "台湾省",
      "data": [
        {
          "value": "710100",
          "city": "台北市",
          "dataList": [
            {
              "value": "710101",
              "area": "中正区"
            },
            {
              "value": "710102",
              "area": "大同区"
            },
            {
              "value": "710103",
              "area": "中山区"
            },
            {
              "value": "710104",
              "area": "松山区"
            },
            {
              "value": "710105",
              "area": "大安区"
            },
            {
              "value": "710106",
              "area": "万华区"
            },
            {
              "value": "710107",
              "area": "信义区"
            },
            {
              "value": "710108",
              "area": "士林区"
            },
            {
              "value": "710109",
              "area": "北投区"
            },
            {
              "value": "710110",
              "area": "内湖区"
            },
            {
              "value": "710111",
              "area": "南港区"
            },
            {
              "value": "710112",
              "area": "文山区"
            },
            {
              "value": "710113",
              "area": "其它区"
            }
          ]
        },
        {
          "value": "710200",
          "city": "高雄市",
          "dataList": [
            {
              "value": "710201",
              "area": "新兴区"
            },
            {
              "value": "710202",
              "area": "前金区"
            },
            {
              "value": "710203",
              "area": "芩雅区"
            },
            {
              "value": "710204",
              "area": "盐埕区"
            },
            {
              "value": "710205",
              "area": "鼓山区"
            },
            {
              "value": "710206",
              "area": "旗津区"
            },
            {
              "value": "710207",
              "area": "前镇区"
            },
            {
              "value": "710208",
              "area": "三民区"
            },
            {
              "value": "710209",
              "area": "左营区"
            },
            {
              "value": "710210",
              "area": "楠梓区"
            },
            {
              "value": "710211",
              "area": "小港区"
            },
            {
              "value": "710212",
              "area": "其它区"
            },
            {
              "value": "710241",
              "area": "苓雅区"
            },
            {
              "value": "710242",
              "area": "仁武区"
            },
            {
              "value": "710243",
              "area": "大社区"
            },
            {
              "value": "710244",
              "area": "冈山区"
            },
            {
              "value": "710245",
              "area": "路竹区"
            },
            {
              "value": "710246",
              "area": "阿莲区"
            },
            {
              "value": "710247",
              "area": "田寮区"
            },
            {
              "value": "710248",
              "area": "燕巢区"
            },
            {
              "value": "710249",
              "area": "桥头区"
            },
            {
              "value": "710250",
              "area": "梓官区"
            },
            {
              "value": "710251",
              "area": "弥陀区"
            },
            {
              "value": "710252",
              "area": "永安区"
            },
            {
              "value": "710253",
              "area": "湖内区"
            },
            {
              "value": "710254",
              "area": "凤山区"
            },
            {
              "value": "710255",
              "area": "大寮区"
            },
            {
              "value": "710256",
              "area": "林园区"
            },
            {
              "value": "710257",
              "area": "鸟松区"
            },
            {
              "value": "710258",
              "area": "大树区"
            },
            {
              "value": "710259",
              "area": "旗山区"
            },
            {
              "value": "710260",
              "area": "美浓区"
            },
            {
              "value": "710261",
              "area": "六龟区"
            },
            {
              "value": "710262",
              "area": "内门区"
            },
            {
              "value": "710263",
              "area": "杉林区"
            },
            {
              "value": "710264",
              "area": "甲仙区"
            },
            {
              "value": "710265",
              "area": "桃源区"
            },
            {
              "value": "710266",
              "area": "那玛夏区"
            },
            {
              "value": "710267",
              "area": "茂林区"
            },
            {
              "value": "710268",
              "area": "茄萣区"
            }
          ]
        },
        {
          "value": "710300",
          "city": "台南市",
          "dataList": [
            {
              "value": "710301",
              "area": "中西区"
            },
            {
              "value": "710302",
              "area": "东区"
            },
            {
              "value": "710303",
              "area": "南区"
            },
            {
              "value": "710304",
              "area": "北区"
            },
            {
              "value": "710305",
              "area": "安平区"
            },
            {
              "value": "710306",
              "area": "安南区"
            },
            {
              "value": "710307",
              "area": "其它区"
            },
            {
              "value": "710339",
              "area": "永康区"
            },
            {
              "value": "710340",
              "area": "归仁区"
            },
            {
              "value": "710341",
              "area": "新化区"
            },
            {
              "value": "710342",
              "area": "左镇区"
            },
            {
              "value": "710343",
              "area": "玉井区"
            },
            {
              "value": "710344",
              "area": "楠西区"
            },
            {
              "value": "710345",
              "area": "南化区"
            },
            {
              "value": "710346",
              "area": "仁德区"
            },
            {
              "value": "710347",
              "area": "关庙区"
            },
            {
              "value": "710348",
              "area": "龙崎区"
            },
            {
              "value": "710349",
              "area": "官田区"
            },
            {
              "value": "710350",
              "area": "麻豆区"
            },
            {
              "value": "710351",
              "area": "佳里区"
            },
            {
              "value": "710352",
              "area": "西港区"
            },
            {
              "value": "710353",
              "area": "七股区"
            },
            {
              "value": "710354",
              "area": "将军区"
            },
            {
              "value": "710355",
              "area": "学甲区"
            },
            {
              "value": "710356",
              "area": "北门区"
            },
            {
              "value": "710357",
              "area": "新营区"
            },
            {
              "value": "710358",
              "area": "后壁区"
            },
            {
              "value": "710359",
              "area": "白河区"
            },
            {
              "value": "710360",
              "area": "东山区"
            },
            {
              "value": "710361",
              "area": "六甲区"
            },
            {
              "value": "710362",
              "area": "下营区"
            },
            {
              "value": "710363",
              "area": "柳营区"
            },
            {
              "value": "710364",
              "area": "盐水区"
            },
            {
              "value": "710365",
              "area": "善化区"
            },
            {
              "value": "710366",
              "area": "大内区"
            },
            {
              "value": "710367",
              "area": "山上区"
            },
            {
              "value": "710368",
              "area": "新市区"
            },
            {
              "value": "710369",
              "area": "安定区"
            }
          ]
        },
        {
          "value": "710400",
          "city": "台中市",
          "dataList": [
            {
              "value": "710401",
              "area": "中区"
            },
            {
              "value": "710402",
              "area": "东区"
            },
            {
              "value": "710403",
              "area": "南区"
            },
            {
              "value": "710404",
              "area": "西区"
            },
            {
              "value": "710405",
              "area": "北区"
            },
            {
              "value": "710406",
              "area": "北屯区"
            },
            {
              "value": "710407",
              "area": "西屯区"
            },
            {
              "value": "710408",
              "area": "南屯区"
            },
            {
              "value": "710409",
              "area": "其它区"
            },
            {
              "value": "710431",
              "area": "太平区"
            },
            {
              "value": "710432",
              "area": "大里区"
            },
            {
              "value": "710433",
              "area": "雾峰区"
            },
            {
              "value": "710434",
              "area": "乌日区"
            },
            {
              "value": "710435",
              "area": "丰原区"
            },
            {
              "value": "710436",
              "area": "后里区"
            },
            {
              "value": "710437",
              "area": "石冈区"
            },
            {
              "value": "710438",
              "area": "东势区"
            },
            {
              "value": "710439",
              "area": "和平区"
            },
            {
              "value": "710440",
              "area": "新社区"
            },
            {
              "value": "710441",
              "area": "潭子区"
            },
            {
              "value": "710442",
              "area": "大雅区"
            },
            {
              "value": "710443",
              "area": "神冈区"
            },
            {
              "value": "710444",
              "area": "大肚区"
            },
            {
              "value": "710445",
              "area": "沙鹿区"
            },
            {
              "value": "710446",
              "area": "龙井区"
            },
            {
              "value": "710447",
              "area": "梧栖区"
            },
            {
              "value": "710448",
              "area": "清水区"
            },
            {
              "value": "710449",
              "area": "大甲区"
            },
            {
              "value": "710450",
              "area": "外埔区"
            },
            {
              "value": "710451",
              "area": "大安区"
            }
          ]
        },
        {
          "value": "710500",
          "city": "金门县",
          "dataList": [
            {
              "value": "710507",
              "area": "金沙镇"
            },
            {
              "value": "710508",
              "area": "金湖镇"
            },
            {
              "value": "710509",
              "area": "金宁乡"
            },
            {
              "value": "710510",
              "area": "金城镇"
            },
            {
              "value": "710511",
              "area": "烈屿乡"
            },
            {
              "value": "710512",
              "area": "乌坵乡"
            }
          ]
        },
        {
          "value": "710600",
          "city": "南投县",
          "dataList": [
            {
              "value": "710614",
              "area": "南投市"
            },
            {
              "value": "710615",
              "area": "中寮乡"
            },
            {
              "value": "710616",
              "area": "草屯镇"
            },
            {
              "value": "710617",
              "area": "国姓乡"
            },
            {
              "value": "710618",
              "area": "埔里镇"
            },
            {
              "value": "710619",
              "area": "仁爱乡"
            },
            {
              "value": "710620",
              "area": "名间乡"
            },
            {
              "value": "710621",
              "area": "集集镇"
            },
            {
              "value": "710622",
              "area": "水里乡"
            },
            {
              "value": "710623",
              "area": "鱼池乡"
            },
            {
              "value": "710624",
              "area": "信义乡"
            },
            {
              "value": "710625",
              "area": "竹山镇"
            },
            {
              "value": "710626",
              "area": "鹿谷乡"
            }
          ]
        },
        {
          "value": "710700",
          "city": "基隆市",
          "dataList": [
            {
              "value": "710701",
              "area": "仁爱区"
            },
            {
              "value": "710702",
              "area": "信义区"
            },
            {
              "value": "710703",
              "area": "中正区"
            },
            {
              "value": "710704",
              "area": "中山区"
            },
            {
              "value": "710705",
              "area": "安乐区"
            },
            {
              "value": "710706",
              "area": "暖暖区"
            },
            {
              "value": "710707",
              "area": "七堵区"
            },
            {
              "value": "710708",
              "area": "其它区"
            }
          ]
        },
        {
          "value": "710800",
          "city": "新竹市",
          "dataList": [
            {
              "value": "710801",
              "area": "东区"
            },
            {
              "value": "710802",
              "area": "北区"
            },
            {
              "value": "710803",
              "area": "香山区"
            },
            {
              "value": "710804",
              "area": "其它区"
            }
          ]
        },
        {
          "value": "710900",
          "city": "嘉义市",
          "dataList": [
            {
              "value": "710901",
              "area": "东区"
            },
            {
              "value": "710902",
              "area": "西区"
            },
            {
              "value": "710903",
              "area": "其它区"
            }
          ]
        },
        {
          "value": "711100",
          "city": "新北市",
          "dataList": [
            {
              "value": "711130",
              "area": "万里区"
            },
            {
              "value": "711131",
              "area": "金山区"
            },
            {
              "value": "711132",
              "area": "板桥区"
            },
            {
              "value": "711133",
              "area": "汐止区"
            },
            {
              "value": "711134",
              "area": "深坑区"
            },
            {
              "value": "711135",
              "area": "石碇区"
            },
            {
              "value": "711136",
              "area": "瑞芳区"
            },
            {
              "value": "711137",
              "area": "平溪区"
            },
            {
              "value": "711138",
              "area": "双溪区"
            },
            {
              "value": "711139",
              "area": "贡寮区"
            },
            {
              "value": "711140",
              "area": "新店区"
            },
            {
              "value": "711141",
              "area": "坪林区"
            },
            {
              "value": "711142",
              "area": "乌来区"
            },
            {
              "value": "711143",
              "area": "永和区"
            },
            {
              "value": "711144",
              "area": "中和区"
            },
            {
              "value": "711145",
              "area": "土城区"
            },
            {
              "value": "711146",
              "area": "三峡区"
            },
            {
              "value": "711147",
              "area": "树林区"
            },
            {
              "value": "711148",
              "area": "莺歌区"
            },
            {
              "value": "711149",
              "area": "三重区"
            },
            {
              "value": "711150",
              "area": "新庄区"
            },
            {
              "value": "711151",
              "area": "泰山区"
            },
            {
              "value": "711152",
              "area": "林口区"
            },
            {
              "value": "711153",
              "area": "芦洲区"
            },
            {
              "value": "711154",
              "area": "五股区"
            },
            {
              "value": "711155",
              "area": "八里区"
            },
            {
              "value": "711156",
              "area": "淡水区"
            },
            {
              "value": "711157",
              "area": "三芝区"
            },
            {
              "value": "711158",
              "area": "石门区"
            }
          ]
        },
        {
          "value": "711200",
          "city": "宜兰县",
          "dataList": [
            {
              "value": "711214",
              "area": "宜兰市"
            },
            {
              "value": "711215",
              "area": "头城镇"
            },
            {
              "value": "711216",
              "area": "礁溪乡"
            },
            {
              "value": "711217",
              "area": "壮围乡"
            },
            {
              "value": "711218",
              "area": "员山乡"
            },
            {
              "value": "711219",
              "area": "罗东镇"
            },
            {
              "value": "711220",
              "area": "三星乡"
            },
            {
              "value": "711221",
              "area": "大同乡"
            },
            {
              "value": "711222",
              "area": "五结乡"
            },
            {
              "value": "711223",
              "area": "冬山乡"
            },
            {
              "value": "711224",
              "area": "苏澳镇"
            },
            {
              "value": "711225",
              "area": "南澳乡"
            },
            {
              "value": "711226",
              "area": "钓鱼台"
            }
          ]
        },
        {
          "value": "711300",
          "city": "新竹县",
          "dataList": [
            {
              "value": "711314",
              "area": "竹北市"
            },
            {
              "value": "711315",
              "area": "湖口乡"
            },
            {
              "value": "711316",
              "area": "新丰乡"
            },
            {
              "value": "711317",
              "area": "新埔镇"
            },
            {
              "value": "711318",
              "area": "关西镇"
            },
            {
              "value": "711319",
              "area": "芎林乡"
            },
            {
              "value": "711320",
              "area": "宝山乡"
            },
            {
              "value": "711321",
              "area": "竹东镇"
            },
            {
              "value": "711322",
              "area": "五峰乡"
            },
            {
              "value": "711323",
              "area": "横山乡"
            },
            {
              "value": "711324",
              "area": "尖石乡"
            },
            {
              "value": "711325",
              "area": "北埔乡"
            },
            {
              "value": "711326",
              "area": "峨眉乡"
            }
          ]
        },
        {
          "value": "711400",
          "city": "桃园县",
          "dataList": [
            {
              "value": "711414",
              "area": "中坜市"
            },
            {
              "value": "711415",
              "area": "平镇市"
            },
            {
              "value": "711416",
              "area": "龙潭乡"
            },
            {
              "value": "711417",
              "area": "杨梅市"
            },
            {
              "value": "711418",
              "area": "新屋乡"
            },
            {
              "value": "711419",
              "area": "观音乡"
            },
            {
              "value": "711420",
              "area": "桃园市"
            },
            {
              "value": "711421",
              "area": "龟山乡"
            },
            {
              "value": "711422",
              "area": "八德市"
            },
            {
              "value": "711423",
              "area": "大溪镇"
            },
            {
              "value": "711424",
              "area": "复兴乡"
            },
            {
              "value": "711425",
              "area": "大园乡"
            },
            {
              "value": "711426",
              "area": "芦竹乡"
            }
          ]
        },
        {
          "value": "711500",
          "city": "苗栗县",
          "dataList": [
            {
              "value": "711519",
              "area": "竹南镇"
            },
            {
              "value": "711520",
              "area": "头份镇"
            },
            {
              "value": "711521",
              "area": "三湾乡"
            },
            {
              "value": "711522",
              "area": "南庄乡"
            },
            {
              "value": "711523",
              "area": "狮潭乡"
            },
            {
              "value": "711524",
              "area": "后龙镇"
            },
            {
              "value": "711525",
              "area": "通霄镇"
            },
            {
              "value": "711526",
              "area": "苑里镇"
            },
            {
              "value": "711527",
              "area": "苗栗市"
            },
            {
              "value": "711528",
              "area": "造桥乡"
            },
            {
              "value": "711529",
              "area": "头屋乡"
            },
            {
              "value": "711530",
              "area": "公馆乡"
            },
            {
              "value": "711531",
              "area": "大湖乡"
            },
            {
              "value": "711532",
              "area": "泰安乡"
            },
            {
              "value": "711533",
              "area": "铜锣乡"
            },
            {
              "value": "711534",
              "area": "三义乡"
            },
            {
              "value": "711535",
              "area": "西湖乡"
            },
            {
              "value": "711536",
              "area": "卓兰镇"
            }
          ]
        },
        {
          "value": "711700",
          "city": "彰化县",
          "dataList": [
            {
              "value": "711727",
              "area": "彰化市"
            },
            {
              "value": "711728",
              "area": "芬园乡"
            },
            {
              "value": "711729",
              "area": "花坛乡"
            },
            {
              "value": "711730",
              "area": "秀水乡"
            },
            {
              "value": "711731",
              "area": "鹿港镇"
            },
            {
              "value": "711732",
              "area": "福兴乡"
            },
            {
              "value": "711733",
              "area": "线西乡"
            },
            {
              "value": "711734",
              "area": "和美镇"
            },
            {
              "value": "711735",
              "area": "伸港乡"
            },
            {
              "value": "711736",
              "area": "员林镇"
            },
            {
              "value": "711737",
              "area": "社头乡"
            },
            {
              "value": "711738",
              "area": "永靖乡"
            },
            {
              "value": "711739",
              "area": "埔心乡"
            },
            {
              "value": "711740",
              "area": "溪湖镇"
            },
            {
              "value": "711741",
              "area": "大村乡"
            },
            {
              "value": "711742",
              "area": "埔盐乡"
            },
            {
              "value": "711743",
              "area": "田中镇"
            },
            {
              "value": "711744",
              "area": "北斗镇"
            },
            {
              "value": "711745",
              "area": "田尾乡"
            },
            {
              "value": "711746",
              "area": "埤头乡"
            },
            {
              "value": "711747",
              "area": "溪州乡"
            },
            {
              "value": "711748",
              "area": "竹塘乡"
            },
            {
              "value": "711749",
              "area": "二林镇"
            },
            {
              "value": "711750",
              "area": "大城乡"
            },
            {
              "value": "711751",
              "area": "芳苑乡"
            },
            {
              "value": "711752",
              "area": "二水乡"
            }
          ]
        },
        {
          "value": "711900",
          "city": "嘉义县",
          "dataList": [
            {
              "value": "711919",
              "area": "番路乡"
            },
            {
              "value": "711920",
              "area": "梅山乡"
            },
            {
              "value": "711921",
              "area": "竹崎乡"
            },
            {
              "value": "711922",
              "area": "阿里山乡"
            },
            {
              "value": "711923",
              "area": "中埔乡"
            },
            {
              "value": "711924",
              "area": "大埔乡"
            },
            {
              "value": "711925",
              "area": "水上乡"
            },
            {
              "value": "711926",
              "area": "鹿草乡"
            },
            {
              "value": "711927",
              "area": "太保市"
            },
            {
              "value": "711928",
              "area": "朴子市"
            },
            {
              "value": "711929",
              "area": "东石乡"
            },
            {
              "value": "711930",
              "area": "六脚乡"
            },
            {
              "value": "711931",
              "area": "新港乡"
            },
            {
              "value": "711932",
              "area": "民雄乡"
            },
            {
              "value": "711933",
              "area": "大林镇"
            },
            {
              "value": "711934",
              "area": "溪口乡"
            },
            {
              "value": "711935",
              "area": "义竹乡"
            },
            {
              "value": "711936",
              "area": "布袋镇"
            }
          ]
        },
        {
          "value": "712100",
          "city": "云林县",
          "dataList": [
            {
              "value": "712121",
              "area": "斗南镇"
            },
            {
              "value": "712122",
              "area": "大埤乡"
            },
            {
              "value": "712123",
              "area": "虎尾镇"
            },
            {
              "value": "712124",
              "area": "土库镇"
            },
            {
              "value": "712125",
              "area": "褒忠乡"
            },
            {
              "value": "712126",
              "area": "东势乡"
            },
            {
              "value": "712127",
              "area": "台西乡"
            },
            {
              "value": "712128",
              "area": "仑背乡"
            },
            {
              "value": "712129",
              "area": "麦寮乡"
            },
            {
              "value": "712130",
              "area": "斗六市"
            },
            {
              "value": "712131",
              "area": "林内乡"
            },
            {
              "value": "712132",
              "area": "古坑乡"
            },
            {
              "value": "712133",
              "area": "莿桐乡"
            },
            {
              "value": "712134",
              "area": "西螺镇"
            },
            {
              "value": "712135",
              "area": "二仑乡"
            },
            {
              "value": "712136",
              "area": "北港镇"
            },
            {
              "value": "712137",
              "area": "水林乡"
            },
            {
              "value": "712138",
              "area": "口湖乡"
            },
            {
              "value": "712139",
              "area": "四湖乡"
            },
            {
              "value": "712140",
              "area": "元长乡"
            }
          ]
        },
        {
          "value": "712400",
          "city": "屏东县",
          "dataList": [
            {
              "value": "712434",
              "area": "屏东市"
            },
            {
              "value": "712435",
              "area": "三地门乡"
            },
            {
              "value": "712436",
              "area": "雾台乡"
            },
            {
              "value": "712437",
              "area": "玛家乡"
            },
            {
              "value": "712438",
              "area": "九如乡"
            },
            {
              "value": "712439",
              "area": "里港乡"
            },
            {
              "value": "712440",
              "area": "高树乡"
            },
            {
              "value": "712441",
              "area": "盐埔乡"
            },
            {
              "value": "712442",
              "area": "长治乡"
            },
            {
              "value": "712443",
              "area": "麟洛乡"
            },
            {
              "value": "712444",
              "area": "竹田乡"
            },
            {
              "value": "712445",
              "area": "内埔乡"
            },
            {
              "value": "712446",
              "area": "万丹乡"
            },
            {
              "value": "712447",
              "area": "潮州镇"
            },
            {
              "value": "712448",
              "area": "泰武乡"
            },
            {
              "value": "712449",
              "area": "来义乡"
            },
            {
              "value": "712450",
              "area": "万峦乡"
            },
            {
              "value": "712451",
              "area": "崁顶乡"
            },
            {
              "value": "712452",
              "area": "新埤乡"
            },
            {
              "value": "712453",
              "area": "南州乡"
            },
            {
              "value": "712454",
              "area": "林边乡"
            },
            {
              "value": "712455",
              "area": "东港镇"
            },
            {
              "value": "712456",
              "area": "琉球乡"
            },
            {
              "value": "712457",
              "area": "佳冬乡"
            },
            {
              "value": "712458",
              "area": "新园乡"
            },
            {
              "value": "712459",
              "area": "枋寮乡"
            },
            {
              "value": "712460",
              "area": "枋山乡"
            },
            {
              "value": "712461",
              "area": "春日乡"
            },
            {
              "value": "712462",
              "area": "狮子乡"
            },
            {
              "value": "712463",
              "area": "车城乡"
            },
            {
              "value": "712464",
              "area": "牡丹乡"
            },
            {
              "value": "712465",
              "area": "恒春镇"
            },
            {
              "value": "712466",
              "area": "满州乡"
            }
          ]
        },
        {
          "value": "712500",
          "city": "台东县",
          "dataList": [
            {
              "value": "712517",
              "area": "台东市"
            },
            {
              "value": "712518",
              "area": "绿岛乡"
            },
            {
              "value": "712519",
              "area": "兰屿乡"
            },
            {
              "value": "712520",
              "area": "延平乡"
            },
            {
              "value": "712521",
              "area": "卑南乡"
            },
            {
              "value": "712522",
              "area": "鹿野乡"
            },
            {
              "value": "712523",
              "area": "关山镇"
            },
            {
              "value": "712524",
              "area": "海端乡"
            },
            {
              "value": "712525",
              "area": "池上乡"
            },
            {
              "value": "712526",
              "area": "东河乡"
            },
            {
              "value": "712527",
              "area": "成功镇"
            },
            {
              "value": "712528",
              "area": "长滨乡"
            },
            {
              "value": "712529",
              "area": "金峰乡"
            },
            {
              "value": "712530",
              "area": "大武乡"
            },
            {
              "value": "712531",
              "area": "达仁乡"
            },
            {
              "value": "712532",
              "area": "太麻里乡"
            }
          ]
        },
        {
          "value": "712600",
          "city": "花莲县",
          "dataList": [
            {
              "value": "712615",
              "area": "花莲市"
            },
            {
              "value": "712616",
              "area": "新城乡"
            },
            {
              "value": "712617",
              "area": "太鲁阁"
            },
            {
              "value": "712618",
              "area": "秀林乡"
            },
            {
              "value": "712619",
              "area": "吉安乡"
            },
            {
              "value": "712620",
              "area": "寿丰乡"
            },
            {
              "value": "712621",
              "area": "凤林镇"
            },
            {
              "value": "712622",
              "area": "光复乡"
            },
            {
              "value": "712623",
              "area": "丰滨乡"
            },
            {
              "value": "712624",
              "area": "瑞穗乡"
            },
            {
              "value": "712625",
              "area": "万荣乡"
            },
            {
              "value": "712626",
              "area": "玉里镇"
            },
            {
              "value": "712627",
              "area": "卓溪乡"
            },
            {
              "value": "712628",
              "area": "富里乡"
            }
          ]
        },
        {
          "value": "712700",
          "city": "澎湖县",
          "dataList": [
            {
              "value": "712707",
              "area": "马公市"
            },
            {
              "value": "712708",
              "area": "西屿乡"
            },
            {
              "value": "712709",
              "area": "望安乡"
            },
            {
              "value": "712710",
              "area": "七美乡"
            },
            {
              "value": "712711",
              "area": "白沙乡"
            },
            {
              "value": "712712",
              "area": "湖西乡"
            }
          ]
        },
        {
          "value": "712800",
          "city": "连江县",
          "dataList": [
            {
              "value": "712805",
              "area": "南竿乡"
            },
            {
              "value": "712806",
              "area": "北竿乡"
            },
            {
              "value": "712807",
              "area": "莒光乡"
            },
            {
              "value": "712808",
              "area": "东引乡"
            }
          ]
        }
      ]
    },
    {
      "value": "810000",
      "province": "香港特别行政区",
      "data": [
        {
          "value": "810100",
          "city": "香港",
          "dataList": [
            {
              "value": "810101",
              "area": "中西区"
            },
            {
              "value": "810102",
              "area": "湾仔区"
            },
            {
              "value": "810103",
              "area": "东区"
            },
            {
              "value": "810104",
              "area": "南区"
            },
            {
              "value": "810105",
              "area": "油尖旺区"
            },
            {
              "value": "810106",
              "area": "深水埗区"
            },
            {
              "value": "810107",
              "area": "九龙城区"
            },
            {
              "value": "810108",
              "area": "黄大仙区"
            },
            {
              "value": "810109",
              "area": "观塘区"
            },
            {
              "value": "810110",
              "area": "荃湾区"
            },
            {
              "value": "810111",
              "area": "屯门区"
            },
            {
              "value": "810112",
              "area": "元朗区"
            },
            {
              "value": "810113",
              "area": "北区"
            },
            {
              "value": "810114",
              "area": "大埔区"
            },
            {
              "value": "810115",
              "area": "西贡区"
            },
            {
              "value": "810116",
              "area": "沙田区"
            },
            {
              "value": "810117",
              "area": "葵青区"
            },
            {
              "value": "810118",
              "area": "离岛区"
            }
          ]
        }
      ]
    },
    {
      "value": "820000",
      "province": "澳门特别行政区",
      "data": [
        {
          "value": "820100",
          "city": "澳门",
          "dataList": [
            {
              "value": "820101",
              "area": "花地玛堂区"
            },
            {
              "value": "820102",
              "area": "花王堂区"
            },
            {
              "value": "820103",
              "area": "望德堂区"
            },
            {
              "value": "820104",
              "area": "大堂区"
            },
            {
              "value": "820105",
              "area": "风顺堂区"
            },
            {
              "value": "820106",
              "area": "嘉模堂区"
            },
            {
              "value": "820107",
              "area": "路凼填海区"
            },
            {
              "value": "820108",
              "area": "圣方济各堂区"
            }
          ]
        }
      ]
    }
  ]

const provinces = []
const provinceNames = []
for (var item of datas) {
  provinceNames.push(item.province)
  provinces.push(item)
}
export { provinces, provinceNames }


// WEBPACK FOOTER //
// ./src/pages/infocollect/components/province.js